import { openBlock as T, createElementBlock as L, normalizeClass as y, toDisplayString as G, resolveComponent as Ie, createBlock as _e, resolveDynamicComponent as Ai, withCtx as De, createCommentVNode as me, renderSlot as K, createElementVNode as D, normalizeStyle as On, Fragment as ne, mergeProps as Ei, createVNode as ze, createTextVNode as xe, withModifiers as We, renderList as Ne, normalizeProps as us, guardReactiveProps as cs, Teleport as Dp, computed as wt, unref as tt, ref as Et, shallowRef as Lp, watch as ss, getCurrentScope as Ap, onScopeDispose as Ep, shallowReadonly as qr, withDirectives as zi, Transition as hs, vShow as ms, createSlots as Ip, reactive as Rp, createApp as Pp, h as Wp } from "vue";
const ps = "-";
function Bp(r) {
  const o = Np(r), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: l
  } = r;
  function s(g) {
    const h = g.split(ps);
    return h[0] === "" && h.length !== 1 && h.shift(), bu(h, o) || Fp(g);
  }
  function c(g, h) {
    const w = n[g] || [];
    return h && l[g] ? [...w, ...l[g]] : w;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: c
  };
}
function bu(r, o) {
  var g;
  if (r.length === 0)
    return o.classGroupId;
  const n = r[0], l = o.nextPart.get(n), s = l ? bu(r.slice(1), l) : void 0;
  if (s)
    return s;
  if (o.validators.length === 0)
    return;
  const c = r.join(ps);
  return (g = o.validators.find(({
    validator: h
  }) => h(c))) == null ? void 0 : g.classGroupId;
}
const tu = /^\[(.+)\]$/;
function Fp(r) {
  if (tu.test(r)) {
    const o = tu.exec(r)[1], n = o == null ? void 0 : o.substring(0, o.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Np(r) {
  const {
    theme: o,
    prefix: n
  } = r, l = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return $p(Object.entries(r.classGroups), n).forEach(([c, g]) => {
    fs(g, l, c, o);
  }), l;
}
function fs(r, o, n, l) {
  r.forEach((s) => {
    if (typeof s == "string") {
      const c = s === "" ? o : ru(o, s);
      c.classGroupId = n;
      return;
    }
    if (typeof s == "function") {
      if (Up(s)) {
        fs(s(l), o, n, l);
        return;
      }
      o.validators.push({
        validator: s,
        classGroupId: n
      });
      return;
    }
    Object.entries(s).forEach(([c, g]) => {
      fs(g, ru(o, c), n, l);
    });
  });
}
function ru(r, o) {
  let n = r;
  return o.split(ps).forEach((l) => {
    n.nextPart.has(l) || n.nextPart.set(l, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(l);
  }), n;
}
function Up(r) {
  return r.isThemeGetter;
}
function $p(r, o) {
  return o ? r.map(([n, l]) => {
    const s = l.map((c) => typeof c == "string" ? o + c : typeof c == "object" ? Object.fromEntries(Object.entries(c).map(([g, h]) => [o + g, h])) : c);
    return [n, s];
  }) : r;
}
function Hp(r) {
  if (r < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let o = 0, n = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
  function s(c, g) {
    n.set(c, g), o++, o > r && (o = 0, l = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(c) {
      let g = n.get(c);
      if (g !== void 0)
        return g;
      if ((g = l.get(c)) !== void 0)
        return s(c, g), g;
    },
    set(c, g) {
      n.has(c) ? n.set(c, g) : s(c, g);
    }
  };
}
const vu = "!";
function Yp(r) {
  const o = r.separator, n = o.length === 1, l = o[0], s = o.length;
  return function(g) {
    const h = [];
    let w = 0, x = 0, z;
    for (let W = 0; W < g.length; W++) {
      let F = g[W];
      if (w === 0) {
        if (F === l && (n || g.slice(W, W + s) === o)) {
          h.push(g.slice(x, W)), x = W + s;
          continue;
        }
        if (F === "/") {
          z = W;
          continue;
        }
      }
      F === "[" ? w++ : F === "]" && w--;
    }
    const O = h.length === 0 ? g : g.substring(x), R = O.startsWith(vu), E = R ? O.substring(1) : O, $ = z && z > x ? z - x : void 0;
    return {
      modifiers: h,
      hasImportantModifier: R,
      baseClassName: E,
      maybePostfixModifierPosition: $
    };
  };
}
function Vp(r) {
  if (r.length <= 1)
    return r;
  const o = [];
  let n = [];
  return r.forEach((l) => {
    l[0] === "[" ? (o.push(...n.sort(), l), n = []) : n.push(l);
  }), o.push(...n.sort()), o;
}
function Gp(r) {
  return {
    cache: Hp(r.cacheSize),
    splitModifiers: Yp(r),
    ...Bp(r)
  };
}
const qp = /\s+/;
function Xp(r, o) {
  const {
    splitModifiers: n,
    getClassGroupId: l,
    getConflictingClassGroupIds: s
  } = o, c = /* @__PURE__ */ new Set();
  return r.trim().split(qp).map((g) => {
    const {
      modifiers: h,
      hasImportantModifier: w,
      baseClassName: x,
      maybePostfixModifierPosition: z
    } = n(g);
    let O = l(z ? x.substring(0, z) : x), R = !!z;
    if (!O) {
      if (!z)
        return {
          isTailwindClass: !1,
          originalClassName: g
        };
      if (O = l(x), !O)
        return {
          isTailwindClass: !1,
          originalClassName: g
        };
      R = !1;
    }
    const E = Vp(h).join(":");
    return {
      isTailwindClass: !0,
      modifierId: w ? E + vu : E,
      classGroupId: O,
      originalClassName: g,
      hasPostfixModifier: R
    };
  }).reverse().filter((g) => {
    if (!g.isTailwindClass)
      return !0;
    const {
      modifierId: h,
      classGroupId: w,
      hasPostfixModifier: x
    } = g, z = h + w;
    return c.has(z) ? !1 : (c.add(z), s(w, x).forEach((O) => c.add(h + O)), !0);
  }).reverse().map((g) => g.originalClassName).join(" ");
}
function Kp() {
  let r = 0, o, n, l = "";
  for (; r < arguments.length; )
    (o = arguments[r++]) && (n = wu(o)) && (l && (l += " "), l += n);
  return l;
}
function wu(r) {
  if (typeof r == "string")
    return r;
  let o, n = "";
  for (let l = 0; l < r.length; l++)
    r[l] && (o = wu(r[l])) && (n && (n += " "), n += o);
  return n;
}
function Qp(r, ...o) {
  let n, l, s, c = g;
  function g(w) {
    const x = o.reduce((z, O) => O(z), r());
    return n = Gp(x), l = n.cache.get, s = n.cache.set, c = h, h(w);
  }
  function h(w) {
    const x = l(w);
    if (x)
      return x;
    const z = Xp(w, n);
    return s(w, z), z;
  }
  return function() {
    return c(Kp.apply(null, arguments));
  };
}
function ve(r) {
  const o = (n) => n[r] || [];
  return o.isThemeGetter = !0, o;
}
const yu = /^\[(?:([a-z-]+):)?(.+)\]$/i, Jp = /^\d+\/\d+$/, Zp = /* @__PURE__ */ new Set(["px", "full", "screen"]), jp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, eb = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, tb = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, rb = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, nb = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Gt(r) {
  return Mr(r) || Zp.has(r) || Jp.test(r);
}
function sr(r) {
  return jr(r, "length", fb);
}
function Mr(r) {
  return !!r && !Number.isNaN(Number(r));
}
function ki(r) {
  return jr(r, "number", Mr);
}
function Cn(r) {
  return !!r && Number.isInteger(Number(r));
}
function ib(r) {
  return r.endsWith("%") && Mr(r.slice(0, -1));
}
function X(r) {
  return yu.test(r);
}
function ar(r) {
  return jp.test(r);
}
const ob = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function sb(r) {
  return jr(r, ob, xu);
}
function ab(r) {
  return jr(r, "position", xu);
}
const lb = /* @__PURE__ */ new Set(["image", "url"]);
function ub(r) {
  return jr(r, lb, gb);
}
function cb(r) {
  return jr(r, "", db);
}
function kn() {
  return !0;
}
function jr(r, o, n) {
  const l = yu.exec(r);
  return l ? l[1] ? typeof o == "string" ? l[1] === o : o.has(l[1]) : n(l[2]) : !1;
}
function fb(r) {
  return eb.test(r) && !tb.test(r);
}
function xu() {
  return !1;
}
function db(r) {
  return rb.test(r);
}
function gb(r) {
  return nb.test(r);
}
function hb() {
  const r = ve("colors"), o = ve("spacing"), n = ve("blur"), l = ve("brightness"), s = ve("borderColor"), c = ve("borderRadius"), g = ve("borderSpacing"), h = ve("borderWidth"), w = ve("contrast"), x = ve("grayscale"), z = ve("hueRotate"), O = ve("invert"), R = ve("gap"), E = ve("gradientColorStops"), $ = ve("gradientColorStopPositions"), W = ve("inset"), F = ve("margin"), H = ve("opacity"), te = ve("padding"), oe = ve("saturate"), ke = ve("scale"), de = ve("sepia"), Se = ve("skew"), J = ve("space"), Ye = ve("translate"), Qe = () => ["auto", "contain", "none"], Tt = () => ["auto", "hidden", "clip", "visible", "scroll"], dr = () => ["auto", X, o], ge = () => [X, o], Or = () => ["", Gt, sr], Rt = () => ["auto", Mr, X], Re = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Ve = () => ["solid", "dashed", "dotted", "double", "none"], Ge = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], ct = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], gr = () => ["", "0", X], hr = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Ue = () => [Mr, ki], Dr = () => [Mr, X];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [kn],
      spacing: [Gt, sr],
      blur: ["none", "", ar, X],
      brightness: Ue(),
      borderColor: [r],
      borderRadius: ["none", "", "full", ar, X],
      borderSpacing: ge(),
      borderWidth: Or(),
      contrast: Ue(),
      grayscale: gr(),
      hueRotate: Dr(),
      invert: gr(),
      gap: ge(),
      gradientColorStops: [r],
      gradientColorStopPositions: [ib, sr],
      inset: dr(),
      margin: dr(),
      opacity: Ue(),
      padding: ge(),
      saturate: Ue(),
      scale: Ue(),
      sepia: gr(),
      skew: Dr(),
      space: ge(),
      translate: ge()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", X]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ar]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": hr()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": hr()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Re(), X]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Tt()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Tt()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Tt()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Qe()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Qe()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Qe()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [W]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [W]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [W]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [W]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [W]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [W]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [W]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [W]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [W]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Cn, X]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: dr()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", X]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: gr()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: gr()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Cn, X]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [kn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Cn, X]
        }, X]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Rt()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Rt()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [kn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Cn, X]
        }, X]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Rt()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Rt()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", X]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", X]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [R]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [R]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [R]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...ct()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ct(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...ct(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [te]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [te]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [te]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [te]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [te]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [te]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [te]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [te]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [te]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [F]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [F]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [F]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [F]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [F]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [F]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [F]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [F]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [F]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [J]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [J]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", X, o]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [X, o, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [X, o, "none", "full", "min", "max", "fit", "prose", {
          screen: [ar]
        }, ar]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [X, o, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [X, o, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [X, o, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [X, o, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ar, sr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ki]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [kn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", X]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Mr, ki]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Gt, X]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", X]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", X]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [r]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [H]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [r]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [H]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ve(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Gt, sr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Gt, X]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [r]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: ge()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", X]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", X]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [H]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Re(), ab]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", sb]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ub]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [r]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [$]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [$]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [$]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [E]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [E]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [E]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [c]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [c]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [c]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [c]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [c]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [c]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [c]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [c]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [c]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [c]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [c]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [c]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [c]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [c]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [c]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [h]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [h]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [h]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [h]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [h]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [h]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [h]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [h]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [h]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [H]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ve(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [h]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [h]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [H]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Ve()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Ve()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Gt, X]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Gt, sr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [r]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Or()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [r]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [H]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Gt, sr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [r]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ar, cb]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [kn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [H]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": Ge()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ge()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [l]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [w]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ar, X]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [x]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [z]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [O]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [oe]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [de]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [l]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [w]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [x]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [z]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [O]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [H]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [oe]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [de]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [g]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [g]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [g]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", X]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Dr()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", X]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Dr()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", X]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [ke]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [ke]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [ke]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Cn, X]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [Ye]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [Ye]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [Se]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [Se]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", X]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", r]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", X]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [r]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": ge()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": ge()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": ge()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": ge()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": ge()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": ge()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": ge()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": ge()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": ge()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": ge()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": ge()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": ge()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": ge()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": ge()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": ge()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": ge()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": ge()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": ge()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", X]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [r, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Gt, sr, ki]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [r, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const fe = /* @__PURE__ */ Qp(hb), we = (r, o) => {
  const n = r.__vccOpts || r;
  for (const [l, s] of o)
    n[l] = s;
  return n;
}, mb = {
  name: "ButtonComponent",
  props: {
    name: {
      type: String
    },
    size: {
      type: String
    },
    color: {
      type: String
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    iconColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return {
        blue: "text-sky-300",
        red: "text-red-300",
        yellow: "text-yellow-300",
        green: "text-green-300",
        gray: "text-gray-400",
        black: "text-zinc-900",
        white: "text-white"
      }[r];
    },
    iconSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "leading-3 text-xl";
        case "large":
          return "leading-7 text-3xl";
        default:
          return "leading-5 text-2xl";
      }
    }
  }
};
function pb(r, o, n, l, s, c) {
  return T(), L("i", {
    class: y(["material-icons", s.twMerge(
      c.iconColorClass,
      c.iconSizeClass,
      r.$attrs.class
    )])
  }, G(n.name), 3);
}
const bb = /* @__PURE__ */ we(mb, [["render", pb]]), vb = {
  name: "ButtonComponent",
  props: {
    routerLink: {
      type: Boolean
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    icon: {
      type: String
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    color: {
      type: String,
      default: "blue"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    component() {
      return this.routerLink ? "router-link" : this.$attrs.href ? "a" : "button";
    },
    buttonTypeClass() {
      var n, l;
      const r = (n = this.type) == null ? void 0 : n.toLowerCase(), o = (l = this.color) == null ? void 0 : l.toLowerCase();
      switch (r) {
        case "text":
          return this.disabled ? "rounded-lg text-gray-300 dark:text-gray-600 hover:bg-zinc-500                             cursor-not-allowed" : {
            blue: "rounded-lg text-sky-300 hover:bg-zinc-200 dark:hover:bg-zinc-700",
            red: "rounded-lg text-red-300 hover:bg-zinc-200 dark:hover:bg-zinc-700",
            yellow: "rounded-lg text-yellow-300 hover:bg-zinc-200 dark:hover:bg-zinc-700",
            green: "rounded-lg text-green-300 hover:bg-zinc-200 dark:hover:bg-zinc-700",
            gray: "rounded-lg text-gray-300 dark:text-gray-600 dark:hover:text-gray-300                                 hover:bg-zinc-200 dark:hover:bg-zinc-700",
            black: "rounded-lg text-zinc-900 dark:text-zinc-50 hover:bg-zinc-200                                 dark:hover:bg-zinc-700"
          }[o];
        case "rounded":
          return this.disabled ? "shadow-md rounded-full bg-gray-300 text-zinc-600 hover:bg-gray-400                             cursor-not-allowed" : {
            blue: "shadow-md rounded-full bg-sky-300 hover:bg-sky-400 text-zinc-900",
            red: "shadow-md rounded-full bg-red-300 hover:bg-red-400 text-zinc-900",
            yellow: "shadow-md rounded-full bg-yellow-300 hover:bg-yellow-400 text-zinc-900",
            green: "shadow-md rounded-full bg-green-300 hover:bg-green-400 text-zinc-900",
            gray: "shadow-md rounded-full bg-gray-300 hover:bg-gray-400 text-zinc-900                                 dark:bg-gray-600 dark:hover:bg-gray-700 dark:text-zinc-50",
            black: "shadow-md rounded-full bg-zinc-900 hover:bg-zinc-700 dark:bg-zinc-800                                 dark:hover:bg-zinc-700 text-zinc-50"
          }[o];
        case "outlined":
          return this.disabled ? "shadow-md rounded-lg border-2 border-gray-300 hover:bg-gray-400 cursor-not-allowed                             dark:text-gray-400 dark:hover:text-zinc-600" : {
            blue: "shadow-md rounded-lg border-2 border-sky-300 hover:bg-sky-400 dark:text-zinc-50                                 dark:hover:text-zinc-50",
            red: "shadow-md rounded-lg border-2 border-red-300 hover:bg-red-400 dark:text-zinc-50                                 dark:hover:text-zinc-50",
            yellow: "shadow-md rounded-lg border-2 border-yellow-300 hover:bg-yellow-400                                 dark:text-zinc-50 dark:hover:text-zinc-50",
            green: "shadow-md rounded-lg border-2 border-green-300 hover:bg-green-400                                 dark:text-zinc-50 dark:hover:text-zinc-50",
            gray: "shadow-md rounded-lg border-2 border-gray-300 hover:bg-gray-400 dark:text-zinc-50                                 dark:hover:text-zinc-600",
            black: "shadow-md rounded-lg border-2 border-zinc-900 hover:bg-zinc-700 dark:border-zinc-800                                 dark:hover:bg-zinc-700 text-zinc-900 hover:text-zinc-50 dark:text-zinc-50 dark:hover:text-zinc-50"
          }[o];
        default:
          return this.disabled ? "shadow-md rounded-lg bg-gray-300 text-zinc-600 hover:bg-gray-400 cursor-not-allowed" : {
            blue: "shadow-md rounded-lg bg-sky-300 hover:bg-sky-400 text-zinc-900",
            red: "shadow-md rounded-lg bg-red-300 hover:bg-red-400 text-zinc-900",
            yellow: "shadow-md rounded-lg bg-yellow-300 hover:bg-yellow-400 text-zinc-900",
            green: "shadow-md rounded-lg bg-green-300 hover:bg-green-400 text-zinc-900",
            gray: "shadow-md rounded-lg bg-gray-300 hover:bg-gray-400 text-zinc-900 dark:bg-gray-600                                 dark:hover:bg-gray-700 dark:text-zinc-50",
            black: "shadow-md rounded-lg bg-zinc-900 hover:bg-zinc-700 dark:bg-zinc-800                                 dark:hover:bg-zinc-700 text-zinc-50"
          }[o];
      }
    },
    buttonSizeClass() {
      var o, n, l, s;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return !this.$slots.default && ((n = this.icon) != null && n.length) ? "w-10 h-10 leading-3 text-base" : "px-4 py-1 leading-3 text-base h-10";
        case "large":
          return !this.$slots.default && ((l = this.icon) != null && l.length) ? "w-14 h-14 leading-7 text-xl" : "px-8 py-5 leading-7 text-xl h-14";
        default:
          return !this.$slots.default && ((s = this.icon) != null && s.length) ? "w-12 h-12 leading-5 text-lg" : "px-6 py-3 leading-5 text-lg h-12";
      }
    },
    buttonIconSizeClass() {
      var n, l;
      const r = (n = this.iconPosition) == null ? void 0 : n.toLowerCase(), o = (l = this.size) == null ? void 0 : l.toLowerCase();
      if (this.$slots.default)
        switch (o) {
          case "small":
            return {
              left: "mr-3",
              right: "ml-3"
            }[r];
          case "large":
            return {
              left: "mr-3",
              right: "ml-3"
            }[r];
          default:
            return {
              left: "mr-3",
              right: "ml-3"
            }[r];
        }
    }
  }
};
function wb(r, o, n, l, s, c) {
  const g = Ie("fs-icon");
  return T(), _e(Ai(c.component), {
    class: y(s.twMerge(
      "flex flex-row items-center justify-center font-semibold hover:shadow-lg transition-all ease-in-out duration-300",
      c.buttonTypeClass,
      c.buttonSizeClass,
      r.$attrs.class
    )),
    disabled: n.disabled
  }, {
    default: De(() => {
      var h, w, x, z;
      return [
        (h = n.icon) != null && h.length && ((w = n.iconPosition) == null ? void 0 : w.toLowerCase()) === "left" ? (T(), _e(g, {
          key: 0,
          name: n.icon,
          size: n.size,
          class: y(s.twMerge(
            c.buttonIconSizeClass,
            r.$attrs["left-icon-class"]
          ))
        }, null, 8, ["name", "size", "class"])) : me("", !0),
        K(r.$slots, "default"),
        (x = n.icon) != null && x.length && ((z = n.iconPosition) == null ? void 0 : z.toLowerCase()) === "right" ? (T(), _e(g, {
          key: 1,
          name: n.icon,
          size: n.size,
          class: y(s.twMerge(
            c.buttonIconSizeClass,
            r.$attrs["right-icon-class"]
          ))
        }, null, 8, ["name", "size", "class"])) : me("", !0)
      ];
    }),
    _: 3
  }, 8, ["class", "disabled"]);
}
const yb = /* @__PURE__ */ we(vb, [["render", wb]]), xb = {
  name: "RangeComponent",
  props: {
    modelValue: {
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    rangePrimaryClass() {
      return "appearance-none w-full h-2 rounded-sm outline-none                 transition-all ease-in-out duration-300                 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3                 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-sm                 [&::-webkit-slider-thumb]:cursor-pointer                 [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5                 [&::-moz-range-thumb]:rounded-sm                 [&::-moz-range-thumb]:cursor-pointer";
    },
    percentage() {
      return (this.modelValue - this.min) / (this.max - this.min) * 100;
    },
    rangeLightClass() {
      var n;
      const r = (n = this.color) == null ? void 0 : n.toLowerCase();
      let o = "";
      return o += {
        blue: "[&::-webkit-slider-thumb]:bg-sky-400 [&::-moz-range-thumb]:bg-sky-500",
        red: "[&::-webkit-slider-thumb]:bg-red-400 [&::-moz-range-thumb]:bg-red-500",
        yellow: "[&::-webkit-slider-thumb]:bg-yellow-400 [&::-moz-range-thumb]:bg-yellow-500",
        green: "[&::-webkit-slider-thumb]:bg-green-400 [&::-moz-range-thumb]:bg-green-500",
        gray: "[&::-webkit-slider-thumb]:bg-gray-400 [&::-moz-range-thumb]:bg-gray-500",
        black: "[&::-webkit-slider-thumb]:bg-zinc-950 [&::-moz-range-thumb]:bg-zinc-950"
      }[r], o;
    },
    rangeDarkClass() {
      var n;
      const r = (n = this.color) == null ? void 0 : n.toLowerCase();
      let o = "";
      return o += {
        blue: "[&::-webkit-slider-thumb]:bg-sky-400 [&::-moz-range-thumb]:bg-sky-500",
        red: "[&::-webkit-slider-thumb]:bg-red-400 [&::-moz-range-thumb]:bg-red-500",
        yellow: "[&::-webkit-slider-thumb]:bg-yellow-400 [&::-moz-range-thumb]:bg-yellow-500",
        green: "[&::-webkit-slider-thumb]:bg-green-400 [&::-moz-range-thumb]:bg-green-500",
        gray: "[&::-webkit-slider-thumb]:bg-gray-400 [&::-moz-range-thumb]:bg-gray-500                     dark:[&::-webkit-slider-thumb]:bg-gray-500 dark:[&::-moz-range-thumb]:bg-gray-600",
        black: "[&::-webkit-slider-thumb]:bg-zinc-950 [&::-moz-range-thumb]:bg-zinc-950                     dark:[&::-webkit-slider-thumb]:bg-zinc-800 dark:[&::-moz-range-thumb]:bg-zinc-900"
      }[r], o;
    },
    rangePercentageBGForLight() {
      var n;
      const r = (n = this.color) == null ? void 0 : n.toLowerCase(), o = {
        blue: "#7dd3fc",
        red: "#fca5a5",
        yellow: "#fde047",
        green: "#86efac",
        gray: "#d1d5db",
        black: "#18181b"
      }[r];
      return `linear-gradient(
                to right,
                ${o} 0%,
                ${o} ${this.percentage}%,
                #d4d4d8 ${this.percentage}%,
                #d4d4d8 100%
            )`;
    },
    rangePercentageBGForDark() {
      var n;
      const r = (n = this.color) == null ? void 0 : n.toLowerCase(), o = {
        blue: "#7dd3fc",
        red: "#fca5a5",
        yellow: "#fde047",
        green: "#86efac",
        gray: "#9ca3af",
        black: "#18181b"
      }[r];
      return `linear-gradient(
                to right,
                ${o} 0%,
                ${o} ${this.percentage}%,
                #52525b ${this.percentage}%,
                #52525b 100%
            )`;
    }
  },
  methods: {
    modelValueChanged(r) {
      this.$emit("update:modelValue", parseInt(r.target.value, 10));
    }
  }
}, _b = { class: "flex flex-col" }, Cb = ["value", "min", "max"], kb = ["value", "min", "max"];
function Mb(r, o, n, l, s, c) {
  return T(), L("div", _b, [
    D("input", {
      value: n.modelValue,
      type: "range",
      min: n.min,
      max: n.max,
      class: y(s.twMerge(
        "dark:hidden",
        c.rangePrimaryClass,
        c.rangeLightClass
      )),
      style: On({
        background: c.rangePercentageBGForLight
      }),
      onInput: o[0] || (o[0] = (...g) => c.modelValueChanged && c.modelValueChanged(...g))
    }, null, 46, Cb),
    D("input", {
      value: n.modelValue,
      type: "range",
      min: n.min,
      max: n.max,
      class: y(s.twMerge(
        "hidden dark:block",
        c.rangePrimaryClass,
        c.rangeDarkClass
      )),
      style: On({
        background: c.rangePercentageBGForDark
      }),
      onInput: o[1] || (o[1] = (...g) => c.modelValueChanged && c.modelValueChanged(...g))
    }, null, 46, kb)
  ]);
}
const zb = /* @__PURE__ */ we(xb, [["render", Mb]]), Sb = {
  name: "InputComponent",
  props: {
    modelValue: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    size: {
      type: String
    },
    icon: {
      type: String
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    id() {
      return Math.random();
    },
    componentType() {
      var r;
      return (r = this.type) == null ? void 0 : r.toLowerCase();
    },
    component() {
      return this.componentType === "textarea" ? "textarea" : "input";
    },
    inputMainContainerClass() {
      var r;
      if (this.componentType === "textarea")
        return "";
      switch ((r = this.size) == null ? void 0 : r.toLowerCase()) {
        case "small":
          return "max-h-[2.5rem]";
        case "large":
          return "max-h-[3.5rem]";
        default:
          return "max-h-[3rem]";
      }
    },
    inputContainerClass() {
      let r = "";
      return this.disabled ? r += "border-gray-400 dark:border-gray-600" : r += "border-gray-300 dark:border-gray-700", r;
    },
    inputClass() {
      var n;
      const r = (n = this.size) == null ? void 0 : n.toLowerCase();
      let o = "";
      switch (r) {
        case "small":
          o += "px-2 py-1 text-base leading-3", this.componentType !== "textarea" && (o += " h-10");
          break;
        case "large":
          o += "p-5 text-xl leading-7", this.componentType !== "textarea" && (o += " h-14");
          break;
        default:
          o += "p-3 text-lg leading-5", this.componentType !== "textarea" && (o += " h-12");
          break;
      }
      return this.disabled ? o += " cursor-not-allowed bg-gray-200 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-50" : o += " bg-zinc-50 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-50", this.componentType === "textarea" && (o += " resize-none"), o;
    },
    inputLabelClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "text-base";
        case "large":
          return "text-xl";
        default:
          return "text-lg";
      }
    }
  }
}, Tb = { class: "flex flex-col" }, Ob = ["for"], Db = {
  key: 0,
  class: "mb-1"
};
function Lb(r, o, n, l, s, c) {
  var h, w, x, z, O, R;
  const g = Ie("fs-icon");
  return T(), L("div", Tb, [
    D("label", {
      for: c.id,
      class: y(["flex flex-col font-semibold text-zinc-900 dark:text-zinc-50", s.twMerge(
        c.inputLabelClass,
        r.$attrs["label-class"]
      )])
    }, [
      r.$attrs.label ? (T(), L("span", Db, G(r.$attrs.label), 1)) : r.$slots.label ? (T(), L(ne, { key: 1 }, [], 64)) : me("", !0),
      D("div", {
        class: y(["flex flex-row w-full", s.twMerge(
          c.inputMainContainerClass,
          r.$attrs["main-container-class"]
        )])
      }, [
        K(r.$slots, "before"),
        D("div", {
          class: y(s.twMerge(
            "flex flex-row items-center flex-1 border-2 overflow-hidden",
            c.inputContainerClass,
            !r.$slots.before && !r.$slots.after ? "rounded-lg" : "",
            r.$slots.before && r.$slots.after ? "!border-s-0 !border-e-0" : "",
            r.$slots.before && !r.$slots.after ? "rounded-e-lg !border-s-0" : "",
            !r.$slots.before && r.$slots.after ? "rounded-s-lg !border-e-0" : "",
            r.$attrs["container-class"]
          ))
        }, [
          (h = n.icon) != null && h.length && ((w = n.iconPosition) == null ? void 0 : w.toLowerCase()) === "left" ? (T(), _e(g, {
            key: 0,
            name: n.icon,
            size: n.size,
            class: y(s.twMerge(
              "bg-gray-200 dark:bg-gray-600 flex flex-row items-center justify-center",
              {
                small: "min-w-[2.5rem] min-h-[2.5rem] max-w-[2.5rem] w-full h-full",
                large: "min-w-[4rem] min-h-[3.5rem] max-w-[4rem] w-full h-full"
              }[(x = n.size) == null ? void 0 : x.toLowerCase()] ?? "min-w-[3rem] min-h-[3rem] max-w-[3rem] w-full h-full",
              r.$attrs["icon-class"]
            ))
          }, null, 8, ["name", "size", "class"])) : me("", !0),
          (T(), _e(Ai(c.component), {
            placeholder: r.$attrs.placeholder,
            id: c.id,
            type: c.componentType,
            value: n.modelValue,
            rows: r.$attrs.rows,
            cols: r.$attrs.cols,
            onInput: o[0] || (o[0] = (E) => r.$emit("update:modelValue", E.target.value)),
            class: y(s.twMerge(
              "flex-1 outline-none",
              c.inputClass,
              r.$attrs["input-class"]
            )),
            disabled: n.disabled
          }, null, 40, ["placeholder", "id", "type", "value", "rows", "cols", "class", "disabled"])),
          (z = n.icon) != null && z.length && ((O = n.iconPosition) == null ? void 0 : O.toLowerCase()) === "right" ? (T(), _e(g, {
            key: 1,
            name: n.icon,
            size: n.size,
            class: y(s.twMerge(
              "bg-gray-200 dark:bg-gray-600 flex flex-row items-center justify-center",
              {
                small: "min-w-[2.5rem] min-h-[2.5rem] max-w-[2.5rem] max-h-[2.5rem] w-full h-full",
                large: "min-w-[4rem] min-h-[3.5rem] max-w-[4rem] max-h-[3.5rem] w-full h-full"
              }[(R = n.size) == null ? void 0 : R.toLowerCase()] ?? "min-w-[3rem] min-h-[3rem] max-w-[3rem] max-h-[3rem] w-full h-full",
              r.$attrs["icon-class"]
            ))
          }, null, 8, ["name", "size", "class"])) : me("", !0)
        ], 2),
        K(r.$slots, "after")
      ], 2)
    ], 10, Ob)
  ]);
}
const Ab = /* @__PURE__ */ we(Sb, [["render", Lb]]), Eb = {
  name: "CheckboxComponent",
  inheritAttrs: !1,
  props: {
    modelValue: {},
    label: {
      type: String
    },
    size: {
      type: String
    },
    icon: {
      type: String,
      default: "check"
    },
    color: {
      type: String,
      default: "blue"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    id() {
      return Math.random();
    },
    checkboxColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return this.disabled ? "border-2 border-gray-300 dark:border-gray-600 bg-gray-300 dark:bg-gray-600" : this.modelValue ? {
        blue: "bg-sky-300 group-hover/checkbox:bg-sky-400",
        red: "bg-red-300 group-hover/checkbox:bg-red-400",
        yellow: "bg-yellow-300 group-hover/checkbox:bg-yellow-400",
        green: "bg-green-300 group-hover/checkbox:bg-green-400",
        gray: "bg-gray-300 group-hover/checkbox:bg-gray-400 dark:bg-gray-600               dark:group-hover/checkbox:bg-gray-700",
        black: "bg-zinc-900 group-hover/checkbox:bg-zinc-700 dark:bg-zinc-800               dark:group-hover/checkbox:bg-zinc-700"
      }[r] : "bg-gray-400 border-2 border-gray-400 group-hover/checkbox:bg-gray-500             group-hover/checkbox:border-gray-500 dark:border-gray-400             dark:group-hover/checkbox:bg-gray-400 dark:group-hover/checkbox:border-gray-400";
    },
    checkboxSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] leading-3 text-base h-10";
        case "large":
          return "min-w-[34px] min-h-[34px] max-w-[34px] max-h-[34px] leading-7 text-xl h-14";
        default:
          return "min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] leading-5 text-lg h-12";
      }
    },
    checkboxLabelClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "leading-3 text-base";
        case "large":
          return "leading-7 text-xl";
        default:
          return "leading-5 text-lg";
      }
    }
  }
}, Ib = ["for"], Rb = ["id", "checked", "disabled"];
function Pb(r, o, n, l, s, c) {
  var h, w, x;
  const g = Ie("fs-icon");
  return T(), L("label", {
    for: c.id,
    class: y(s.twMerge(
      "group/checkbox flex flex-row items-center select-none relative text-zinc-900 dark:text-zinc-50",
      n.disabled ? "cursor-not-allowed" : "cursor-pointer",
      r.$attrs["container-class"]
    ))
  }, [
    D("input", Ei(r.$attrs, {
      id: c.id,
      checked: n.modelValue,
      disabled: n.disabled,
      type: "checkbox",
      class: s.twMerge(
        "absolute opacity-0 w-0 h-0",
        r.$attrs.class
      ),
      onChange: o[0] || (o[0] = () => {
        n.disabled || r.$emit("update:modelValue", !n.modelValue);
      })
    }), null, 16, Rb),
    D("div", {
      class: y(s.twMerge(
        `rounded-lg flex flex-row items-center justify-center
          shadow-md group-hover/checkbox:shadow-lg transition-all ease-in-out`,
        c.checkboxColorClass,
        c.checkboxSizeClass,
        r.$attrs["icon-container-class"]
      ))
    }, [
      ze(g, {
        name: n.icon,
        size: n.size,
        color: n.disabled ? "gray" : {
          blue: "black",
          red: "black",
          yellow: "black",
          green: "black",
          gray: "black",
          black: "white"
        }[(h = n.color) == null ? void 0 : h.toLowerCase()],
        class: y(s.twMerge(
          "font-semibold transition-all ease-in-out text-opacity-70",
          n.modelValue ? "scale-[.90] opacity-100" : "scale-0 opacity-0",
          r.$attrs["icon-class"]
        ))
      }, null, 8, ["name", "size", "color", "class"])
    ], 2),
    r.$slots.label || (w = n.label) != null && w.length ? (T(), L("div", {
      key: 0,
      class: y(s.twMerge(
        "ml-2 font-semibold",
        c.checkboxLabelClass,
        r.$attrs["label-class"]
      ))
    }, [
      r.$slots.label ? K(r.$slots, "label", { key: 0 }) : (x = n.label) != null && x.length ? (T(), L(ne, { key: 1 }, [
        xe(G(n.label), 1)
      ], 64)) : me("", !0)
    ], 2)) : me("", !0)
  ], 10, Ib);
}
const Wb = /* @__PURE__ */ we(Eb, [["render", Pb]]);
function Si(r) {
  "@babel/helpers - typeof";
  return Si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Si(r);
}
function ut(r) {
  if (r === null || r === !0 || r === !1)
    return NaN;
  var o = Number(r);
  return isNaN(o) ? o : o < 0 ? Math.ceil(o) : Math.floor(o);
}
function ie(r, o) {
  if (o.length < r)
    throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + o.length + " present");
}
function le(r) {
  ie(1, arguments);
  var o = Object.prototype.toString.call(r);
  return r instanceof Date || Si(r) === "object" && o === "[object Date]" ? new Date(r.getTime()) : typeof r == "number" || o === "[object Number]" ? new Date(r) : ((typeof r == "string" || o === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function zr(r, o) {
  ie(2, arguments);
  var n = le(r), l = ut(o);
  return isNaN(l) ? /* @__PURE__ */ new Date(NaN) : (l && n.setDate(n.getDate() + l), n);
}
function ur(r, o) {
  ie(2, arguments);
  var n = le(r), l = ut(o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (!l)
    return n;
  var s = n.getDate(), c = new Date(n.getTime());
  c.setMonth(n.getMonth() + l + 1, 0);
  var g = c.getDate();
  return s >= g ? c : (n.setFullYear(c.getFullYear(), c.getMonth(), s), n);
}
function Bb(r, o) {
  ie(2, arguments);
  var n = le(r).getTime(), l = ut(o);
  return new Date(n + l);
}
var Fb = {};
function Ii() {
  return Fb;
}
function ds(r) {
  var o = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
  return o.setUTCFullYear(r.getFullYear()), r.getTime() - o.getTime();
}
function nu(r) {
  ie(1, arguments);
  var o = le(r);
  return o.setHours(0, 0, 0, 0), o;
}
var Nb = 864e5;
function Ub(r, o) {
  ie(2, arguments);
  var n = nu(r), l = nu(o), s = n.getTime() - ds(n), c = l.getTime() - ds(l);
  return Math.round((s - c) / Nb);
}
function bs(r, o) {
  ie(2, arguments);
  var n = ut(o);
  return ur(r, n * 12);
}
function as(r, o) {
  ie(2, arguments);
  var n = le(r), l = le(o), s = n.getTime() - l.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function $b(r) {
  return ie(1, arguments), r instanceof Date || Si(r) === "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function Hb(r) {
  if (ie(1, arguments), !$b(r) && typeof r != "number")
    return !1;
  var o = le(r);
  return !isNaN(Number(o));
}
function Yb(r, o) {
  ie(2, arguments);
  var n = le(r), l = le(o), s = n.getFullYear() - l.getFullYear(), c = n.getMonth() - l.getMonth();
  return s * 12 + c;
}
function iu(r, o) {
  var n = r.getFullYear() - o.getFullYear() || r.getMonth() - o.getMonth() || r.getDate() - o.getDate() || r.getHours() - o.getHours() || r.getMinutes() - o.getMinutes() || r.getSeconds() - o.getSeconds() || r.getMilliseconds() - o.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function yt(r, o) {
  ie(2, arguments);
  var n = le(r), l = le(o), s = iu(n, l), c = Math.abs(Ub(n, l));
  n.setDate(n.getDate() - s * c);
  var g = +(iu(n, l) === -s), h = s * (c - g);
  return h === 0 ? 0 : h;
}
function Vb(r) {
  ie(1, arguments);
  var o = le(r);
  return o.setHours(23, 59, 59, 999), o;
}
function Ri(r) {
  ie(1, arguments);
  var o = le(r), n = o.getMonth();
  return o.setFullYear(o.getFullYear(), n + 1, 0), o.setHours(23, 59, 59, 999), o;
}
function Gb(r) {
  ie(1, arguments);
  var o = le(r);
  return Vb(o).getTime() === Ri(o).getTime();
}
function qt(r, o) {
  ie(2, arguments);
  var n = le(r), l = le(o), s = as(n, l), c = Math.abs(Yb(n, l)), g;
  if (c < 1)
    g = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - s * c);
    var h = as(n, l) === -s;
    Gb(le(r)) && c === 1 && as(r, l) === 1 && (h = !1), g = s * (c - Number(h));
  }
  return g === 0 ? 0 : g;
}
function cr(r) {
  ie(1, arguments);
  var o = le(r);
  return o.setDate(1), o.setHours(0, 0, 0, 0), o;
}
function qb(r, o) {
  ie(2, arguments);
  var n = ut(o);
  return Bb(r, -n);
}
var Xb = 864e5;
function Kb(r) {
  ie(1, arguments);
  var o = le(r), n = o.getTime();
  o.setUTCMonth(0, 1), o.setUTCHours(0, 0, 0, 0);
  var l = o.getTime(), s = n - l;
  return Math.floor(s / Xb) + 1;
}
function Ti(r) {
  ie(1, arguments);
  var o = 1, n = le(r), l = n.getUTCDay(), s = (l < o ? 7 : 0) + l - o;
  return n.setUTCDate(n.getUTCDate() - s), n.setUTCHours(0, 0, 0, 0), n;
}
function _u(r) {
  ie(1, arguments);
  var o = le(r), n = o.getUTCFullYear(), l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(n + 1, 0, 4), l.setUTCHours(0, 0, 0, 0);
  var s = Ti(l), c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(n, 0, 4), c.setUTCHours(0, 0, 0, 0);
  var g = Ti(c);
  return o.getTime() >= s.getTime() ? n + 1 : o.getTime() >= g.getTime() ? n : n - 1;
}
function Qb(r) {
  ie(1, arguments);
  var o = _u(r), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(o, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var l = Ti(n);
  return l;
}
var Jb = 6048e5;
function Zb(r) {
  ie(1, arguments);
  var o = le(r), n = Ti(o).getTime() - Qb(o).getTime();
  return Math.round(n / Jb) + 1;
}
function Oi(r, o) {
  var n, l, s, c, g, h, w, x;
  ie(1, arguments);
  var z = Ii(), O = ut((n = (l = (s = (c = o == null ? void 0 : o.weekStartsOn) !== null && c !== void 0 ? c : o == null || (g = o.locale) === null || g === void 0 || (h = g.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && s !== void 0 ? s : z.weekStartsOn) !== null && l !== void 0 ? l : (w = z.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var R = le(r), E = R.getUTCDay(), $ = (E < O ? 7 : 0) + E - O;
  return R.setUTCDate(R.getUTCDate() - $), R.setUTCHours(0, 0, 0, 0), R;
}
function Cu(r, o) {
  var n, l, s, c, g, h, w, x;
  ie(1, arguments);
  var z = le(r), O = z.getUTCFullYear(), R = Ii(), E = ut((n = (l = (s = (c = o == null ? void 0 : o.firstWeekContainsDate) !== null && c !== void 0 ? c : o == null || (g = o.locale) === null || g === void 0 || (h = g.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : R.firstWeekContainsDate) !== null && l !== void 0 ? l : (w = R.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var $ = /* @__PURE__ */ new Date(0);
  $.setUTCFullYear(O + 1, 0, E), $.setUTCHours(0, 0, 0, 0);
  var W = Oi($, o), F = /* @__PURE__ */ new Date(0);
  F.setUTCFullYear(O, 0, E), F.setUTCHours(0, 0, 0, 0);
  var H = Oi(F, o);
  return z.getTime() >= W.getTime() ? O + 1 : z.getTime() >= H.getTime() ? O : O - 1;
}
function jb(r, o) {
  var n, l, s, c, g, h, w, x;
  ie(1, arguments);
  var z = Ii(), O = ut((n = (l = (s = (c = o == null ? void 0 : o.firstWeekContainsDate) !== null && c !== void 0 ? c : o == null || (g = o.locale) === null || g === void 0 || (h = g.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : z.firstWeekContainsDate) !== null && l !== void 0 ? l : (w = z.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), R = Cu(r, o), E = /* @__PURE__ */ new Date(0);
  E.setUTCFullYear(R, 0, O), E.setUTCHours(0, 0, 0, 0);
  var $ = Oi(E, o);
  return $;
}
var ev = 6048e5;
function tv(r, o) {
  ie(1, arguments);
  var n = le(r), l = Oi(n, o).getTime() - jb(n, o).getTime();
  return Math.round(l / ev) + 1;
}
function ce(r, o) {
  for (var n = r < 0 ? "-" : "", l = Math.abs(r).toString(); l.length < o; )
    l = "0" + l;
  return n + l;
}
var rv = {
  // Year
  y: function(o, n) {
    var l = o.getUTCFullYear(), s = l > 0 ? l : 1 - l;
    return ce(n === "yy" ? s % 100 : s, n.length);
  },
  // Month
  M: function(o, n) {
    var l = o.getUTCMonth();
    return n === "M" ? String(l + 1) : ce(l + 1, 2);
  },
  // Day of the month
  d: function(o, n) {
    return ce(o.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(o, n) {
    var l = o.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return l.toUpperCase();
      case "aaa":
        return l;
      case "aaaaa":
        return l[0];
      case "aaaa":
      default:
        return l === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(o, n) {
    return ce(o.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(o, n) {
    return ce(o.getUTCHours(), n.length);
  },
  // Minute
  m: function(o, n) {
    return ce(o.getUTCMinutes(), n.length);
  },
  // Second
  s: function(o, n) {
    return ce(o.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(o, n) {
    var l = n.length, s = o.getUTCMilliseconds(), c = Math.floor(s * Math.pow(10, l - 3));
    return ce(c, n.length);
  }
};
const lr = rv;
var Xr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, nv = {
  // Era
  G: function(o, n, l) {
    var s = o.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return l.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return l.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return l.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(o, n, l) {
    if (n === "yo") {
      var s = o.getUTCFullYear(), c = s > 0 ? s : 1 - s;
      return l.ordinalNumber(c, {
        unit: "year"
      });
    }
    return lr.y(o, n);
  },
  // Local week-numbering year
  Y: function(o, n, l, s) {
    var c = Cu(o, s), g = c > 0 ? c : 1 - c;
    if (n === "YY") {
      var h = g % 100;
      return ce(h, 2);
    }
    return n === "Yo" ? l.ordinalNumber(g, {
      unit: "year"
    }) : ce(g, n.length);
  },
  // ISO week-numbering year
  R: function(o, n) {
    var l = _u(o);
    return ce(l, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(o, n) {
    var l = o.getUTCFullYear();
    return ce(l, n.length);
  },
  // Quarter
  Q: function(o, n, l) {
    var s = Math.ceil((o.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(s);
      case "QQ":
        return ce(s, 2);
      case "Qo":
        return l.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return l.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return l.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return l.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(o, n, l) {
    var s = Math.ceil((o.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(s);
      case "qq":
        return ce(s, 2);
      case "qo":
        return l.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return l.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return l.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return l.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(o, n, l) {
    var s = o.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return lr.M(o, n);
      case "Mo":
        return l.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return l.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return l.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return l.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(o, n, l) {
    var s = o.getUTCMonth();
    switch (n) {
      case "L":
        return String(s + 1);
      case "LL":
        return ce(s + 1, 2);
      case "Lo":
        return l.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return l.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return l.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return l.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(o, n, l, s) {
    var c = tv(o, s);
    return n === "wo" ? l.ordinalNumber(c, {
      unit: "week"
    }) : ce(c, n.length);
  },
  // ISO week of year
  I: function(o, n, l) {
    var s = Zb(o);
    return n === "Io" ? l.ordinalNumber(s, {
      unit: "week"
    }) : ce(s, n.length);
  },
  // Day of the month
  d: function(o, n, l) {
    return n === "do" ? l.ordinalNumber(o.getUTCDate(), {
      unit: "date"
    }) : lr.d(o, n);
  },
  // Day of year
  D: function(o, n, l) {
    var s = Kb(o);
    return n === "Do" ? l.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : ce(s, n.length);
  },
  // Day of week
  E: function(o, n, l) {
    var s = o.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return l.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return l.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return l.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return l.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(o, n, l, s) {
    var c = o.getUTCDay(), g = (c - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(g);
      case "ee":
        return ce(g, 2);
      case "eo":
        return l.ordinalNumber(g, {
          unit: "day"
        });
      case "eee":
        return l.day(c, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return l.day(c, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return l.day(c, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return l.day(c, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(o, n, l, s) {
    var c = o.getUTCDay(), g = (c - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(g);
      case "cc":
        return ce(g, n.length);
      case "co":
        return l.ordinalNumber(g, {
          unit: "day"
        });
      case "ccc":
        return l.day(c, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return l.day(c, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return l.day(c, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return l.day(c, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(o, n, l) {
    var s = o.getUTCDay(), c = s === 0 ? 7 : s;
    switch (n) {
      case "i":
        return String(c);
      case "ii":
        return ce(c, n.length);
      case "io":
        return l.ordinalNumber(c, {
          unit: "day"
        });
      case "iii":
        return l.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return l.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return l.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return l.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(o, n, l) {
    var s = o.getUTCHours(), c = s / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return l.dayPeriod(c, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return l.dayPeriod(c, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return l.dayPeriod(c, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return l.dayPeriod(c, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(o, n, l) {
    var s = o.getUTCHours(), c;
    switch (s === 12 ? c = Xr.noon : s === 0 ? c = Xr.midnight : c = s / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return l.dayPeriod(c, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return l.dayPeriod(c, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return l.dayPeriod(c, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return l.dayPeriod(c, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(o, n, l) {
    var s = o.getUTCHours(), c;
    switch (s >= 17 ? c = Xr.evening : s >= 12 ? c = Xr.afternoon : s >= 4 ? c = Xr.morning : c = Xr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return l.dayPeriod(c, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return l.dayPeriod(c, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return l.dayPeriod(c, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(o, n, l) {
    if (n === "ho") {
      var s = o.getUTCHours() % 12;
      return s === 0 && (s = 12), l.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return lr.h(o, n);
  },
  // Hour [0-23]
  H: function(o, n, l) {
    return n === "Ho" ? l.ordinalNumber(o.getUTCHours(), {
      unit: "hour"
    }) : lr.H(o, n);
  },
  // Hour [0-11]
  K: function(o, n, l) {
    var s = o.getUTCHours() % 12;
    return n === "Ko" ? l.ordinalNumber(s, {
      unit: "hour"
    }) : ce(s, n.length);
  },
  // Hour [1-24]
  k: function(o, n, l) {
    var s = o.getUTCHours();
    return s === 0 && (s = 24), n === "ko" ? l.ordinalNumber(s, {
      unit: "hour"
    }) : ce(s, n.length);
  },
  // Minute
  m: function(o, n, l) {
    return n === "mo" ? l.ordinalNumber(o.getUTCMinutes(), {
      unit: "minute"
    }) : lr.m(o, n);
  },
  // Second
  s: function(o, n, l) {
    return n === "so" ? l.ordinalNumber(o.getUTCSeconds(), {
      unit: "second"
    }) : lr.s(o, n);
  },
  // Fraction of second
  S: function(o, n) {
    return lr.S(o, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(o, n, l, s) {
    var c = s._originalDate || o, g = c.getTimezoneOffset();
    if (g === 0)
      return "Z";
    switch (n) {
      case "X":
        return su(g);
      case "XXXX":
      case "XX":
        return kr(g);
      case "XXXXX":
      case "XXX":
      default:
        return kr(g, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(o, n, l, s) {
    var c = s._originalDate || o, g = c.getTimezoneOffset();
    switch (n) {
      case "x":
        return su(g);
      case "xxxx":
      case "xx":
        return kr(g);
      case "xxxxx":
      case "xxx":
      default:
        return kr(g, ":");
    }
  },
  // Timezone (GMT)
  O: function(o, n, l, s) {
    var c = s._originalDate || o, g = c.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ou(g, ":");
      case "OOOO":
      default:
        return "GMT" + kr(g, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(o, n, l, s) {
    var c = s._originalDate || o, g = c.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ou(g, ":");
      case "zzzz":
      default:
        return "GMT" + kr(g, ":");
    }
  },
  // Seconds timestamp
  t: function(o, n, l, s) {
    var c = s._originalDate || o, g = Math.floor(c.getTime() / 1e3);
    return ce(g, n.length);
  },
  // Milliseconds timestamp
  T: function(o, n, l, s) {
    var c = s._originalDate || o, g = c.getTime();
    return ce(g, n.length);
  }
};
function ou(r, o) {
  var n = r > 0 ? "-" : "+", l = Math.abs(r), s = Math.floor(l / 60), c = l % 60;
  if (c === 0)
    return n + String(s);
  var g = o || "";
  return n + String(s) + g + ce(c, 2);
}
function su(r, o) {
  if (r % 60 === 0) {
    var n = r > 0 ? "-" : "+";
    return n + ce(Math.abs(r) / 60, 2);
  }
  return kr(r, o);
}
function kr(r, o) {
  var n = o || "", l = r > 0 ? "-" : "+", s = Math.abs(r), c = ce(Math.floor(s / 60), 2), g = ce(s % 60, 2);
  return l + c + n + g;
}
const iv = nv;
var au = function(o, n) {
  switch (o) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, ku = function(o, n) {
  switch (o) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ov = function(o, n) {
  var l = o.match(/(P+)(p+)?/) || [], s = l[1], c = l[2];
  if (!c)
    return au(o, n);
  var g;
  switch (s) {
    case "P":
      g = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      g = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      g = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      g = n.dateTime({
        width: "full"
      });
      break;
  }
  return g.replace("{{date}}", au(s, n)).replace("{{time}}", ku(c, n));
}, sv = {
  p: ku,
  P: ov
};
const av = sv;
var lv = ["D", "DD"], uv = ["YY", "YYYY"];
function cv(r) {
  return lv.indexOf(r) !== -1;
}
function fv(r) {
  return uv.indexOf(r) !== -1;
}
function lu(r, o, n) {
  if (r === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(o, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(o, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(o, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(o, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var dv = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, gv = function(o, n, l) {
  var s, c = dv[o];
  return typeof c == "string" ? s = c : n === 1 ? s = c.one : s = c.other.replace("{{count}}", n.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + s : s + " ago" : s;
};
const hv = gv;
function ls(r) {
  return function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = o.width ? String(o.width) : r.defaultWidth, l = r.formats[n] || r.formats[r.defaultWidth];
    return l;
  };
}
var mv = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pv = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, bv = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vv = {
  date: ls({
    formats: mv,
    defaultWidth: "full"
  }),
  time: ls({
    formats: pv,
    defaultWidth: "full"
  }),
  dateTime: ls({
    formats: bv,
    defaultWidth: "full"
  })
};
const wv = vv;
var yv = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, xv = function(o, n, l, s) {
  return yv[o];
};
const _v = xv;
function Mn(r) {
  return function(o, n) {
    var l = n != null && n.context ? String(n.context) : "standalone", s;
    if (l === "formatting" && r.formattingValues) {
      var c = r.defaultFormattingWidth || r.defaultWidth, g = n != null && n.width ? String(n.width) : c;
      s = r.formattingValues[g] || r.formattingValues[c];
    } else {
      var h = r.defaultWidth, w = n != null && n.width ? String(n.width) : r.defaultWidth;
      s = r.values[w] || r.values[h];
    }
    var x = r.argumentCallback ? r.argumentCallback(o) : o;
    return s[x];
  };
}
var Cv = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Mv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, zv = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Sv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Tv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ov = function(o, n) {
  var l = Number(o), s = l % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return l + "st";
      case 2:
        return l + "nd";
      case 3:
        return l + "rd";
    }
  return l + "th";
}, Dv = {
  ordinalNumber: Ov,
  era: Mn({
    values: Cv,
    defaultWidth: "wide"
  }),
  quarter: Mn({
    values: kv,
    defaultWidth: "wide",
    argumentCallback: function(o) {
      return o - 1;
    }
  }),
  month: Mn({
    values: Mv,
    defaultWidth: "wide"
  }),
  day: Mn({
    values: zv,
    defaultWidth: "wide"
  }),
  dayPeriod: Mn({
    values: Sv,
    defaultWidth: "wide",
    formattingValues: Tv,
    defaultFormattingWidth: "wide"
  })
};
const Lv = Dv;
function zn(r) {
  return function(o) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = n.width, s = l && r.matchPatterns[l] || r.matchPatterns[r.defaultMatchWidth], c = o.match(s);
    if (!c)
      return null;
    var g = c[0], h = l && r.parsePatterns[l] || r.parsePatterns[r.defaultParseWidth], w = Array.isArray(h) ? Ev(h, function(O) {
      return O.test(g);
    }) : Av(h, function(O) {
      return O.test(g);
    }), x;
    x = r.valueCallback ? r.valueCallback(w) : w, x = n.valueCallback ? n.valueCallback(x) : x;
    var z = o.slice(g.length);
    return {
      value: x,
      rest: z
    };
  };
}
function Av(r, o) {
  for (var n in r)
    if (r.hasOwnProperty(n) && o(r[n]))
      return n;
}
function Ev(r, o) {
  for (var n = 0; n < r.length; n++)
    if (o(r[n]))
      return n;
}
function Iv(r) {
  return function(o) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = o.match(r.matchPattern);
    if (!l)
      return null;
    var s = l[0], c = o.match(r.parsePattern);
    if (!c)
      return null;
    var g = r.valueCallback ? r.valueCallback(c[0]) : c[0];
    g = n.valueCallback ? n.valueCallback(g) : g;
    var h = o.slice(s.length);
    return {
      value: g,
      rest: h
    };
  };
}
var Rv = /^(\d+)(th|st|nd|rd)?/i, Pv = /\d+/i, Wv = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Bv = {
  any: [/^b/i, /^(a|c)/i]
}, Fv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Nv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Uv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $v = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Hv = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Yv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Vv = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Gv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, qv = {
  ordinalNumber: Iv({
    matchPattern: Rv,
    parsePattern: Pv,
    valueCallback: function(o) {
      return parseInt(o, 10);
    }
  }),
  era: zn({
    matchPatterns: Wv,
    defaultMatchWidth: "wide",
    parsePatterns: Bv,
    defaultParseWidth: "any"
  }),
  quarter: zn({
    matchPatterns: Fv,
    defaultMatchWidth: "wide",
    parsePatterns: Nv,
    defaultParseWidth: "any",
    valueCallback: function(o) {
      return o + 1;
    }
  }),
  month: zn({
    matchPatterns: Uv,
    defaultMatchWidth: "wide",
    parsePatterns: $v,
    defaultParseWidth: "any"
  }),
  day: zn({
    matchPatterns: Hv,
    defaultMatchWidth: "wide",
    parsePatterns: Yv,
    defaultParseWidth: "any"
  }),
  dayPeriod: zn({
    matchPatterns: Vv,
    defaultMatchWidth: "any",
    parsePatterns: Gv,
    defaultParseWidth: "any"
  })
};
const Xv = qv;
var Kv = {
  code: "en-US",
  formatDistance: hv,
  formatLong: wv,
  formatRelative: _v,
  localize: Lv,
  match: Xv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Qv = Kv;
var Jv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Zv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jv = /^'([^]*?)'?$/, ew = /''/g, tw = /[a-zA-Z]/;
function Sr(r, o, n) {
  var l, s, c, g, h, w, x, z, O, R, E, $, W, F, H, te, oe, ke;
  ie(2, arguments);
  var de = String(o), Se = Ii(), J = (l = (s = n == null ? void 0 : n.locale) !== null && s !== void 0 ? s : Se.locale) !== null && l !== void 0 ? l : Qv, Ye = ut((c = (g = (h = (w = n == null ? void 0 : n.firstWeekContainsDate) !== null && w !== void 0 ? w : n == null || (x = n.locale) === null || x === void 0 || (z = x.options) === null || z === void 0 ? void 0 : z.firstWeekContainsDate) !== null && h !== void 0 ? h : Se.firstWeekContainsDate) !== null && g !== void 0 ? g : (O = Se.locale) === null || O === void 0 || (R = O.options) === null || R === void 0 ? void 0 : R.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
  if (!(Ye >= 1 && Ye <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Qe = ut((E = ($ = (W = (F = n == null ? void 0 : n.weekStartsOn) !== null && F !== void 0 ? F : n == null || (H = n.locale) === null || H === void 0 || (te = H.options) === null || te === void 0 ? void 0 : te.weekStartsOn) !== null && W !== void 0 ? W : Se.weekStartsOn) !== null && $ !== void 0 ? $ : (oe = Se.locale) === null || oe === void 0 || (ke = oe.options) === null || ke === void 0 ? void 0 : ke.weekStartsOn) !== null && E !== void 0 ? E : 0);
  if (!(Qe >= 0 && Qe <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!J.localize)
    throw new RangeError("locale must contain localize property");
  if (!J.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Tt = le(r);
  if (!Hb(Tt))
    throw new RangeError("Invalid time value");
  var dr = ds(Tt), ge = qb(Tt, dr), Or = {
    firstWeekContainsDate: Ye,
    weekStartsOn: Qe,
    locale: J,
    _originalDate: Tt
  }, Rt = de.match(Zv).map(function(Re) {
    var Ve = Re[0];
    if (Ve === "p" || Ve === "P") {
      var Ge = av[Ve];
      return Ge(Re, J.formatLong);
    }
    return Re;
  }).join("").match(Jv).map(function(Re) {
    if (Re === "''")
      return "'";
    var Ve = Re[0];
    if (Ve === "'")
      return rw(Re);
    var Ge = iv[Ve];
    if (Ge)
      return !(n != null && n.useAdditionalWeekYearTokens) && fv(Re) && lu(Re, o, String(r)), !(n != null && n.useAdditionalDayOfYearTokens) && cv(Re) && lu(Re, o, String(r)), Ge(ge, Re, J.localize, Or);
    if (Ve.match(tw))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ve + "`");
    return Re;
  }).join("");
  return Rt;
}
function rw(r) {
  var o = r.match(jv);
  return o ? o[1].replace(ew, "'") : r;
}
function Le(r) {
  ie(1, arguments);
  var o = le(r), n = o.getDate();
  return n;
}
function vs(r) {
  ie(1, arguments);
  var o = le(r), n = o.getDay();
  return n;
}
function At(r) {
  ie(1, arguments);
  var o = le(r), n = o.getMonth();
  return n;
}
function Mu(r) {
  return ie(1, arguments), le(r).getFullYear();
}
function ws(r, o) {
  ie(2, arguments);
  var n = ut(o);
  return zr(r, -n);
}
function Jr(r, o) {
  ie(2, arguments);
  var n = ut(o);
  return ur(r, -n);
}
function zu(r, o) {
  ie(2, arguments);
  var n = ut(o);
  return bs(r, -n);
}
const nw = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], iw = {
  name: "DatepickerComponent",
  props: {
    value: Object | Date,
    limit: Number,
    controllersColor: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  emits: ["update:value"],
  data() {
    return {
      week: nw,
      format: Sr,
      differenceInDays: yt,
      getDate: Le,
      subMonths: Jr,
      addMonths: ur,
      sourceDate: cr(/* @__PURE__ */ new Date()),
      twMerge: fe
    };
  },
  computed: {
    days() {
      return [...Array(42).keys()].map((r) => {
        const o = cr(this.sourceDate), n = vs(o), l = Ri(this.sourceDate);
        return r < n ? {
          date: ws(o, Math.abs(r + 1 - (n + 1))),
          earlier: !0
        } : r >= Le(l) + n ? {
          date: zr(o, r - (n - 1) - 1),
          later: !0
        } : {
          date: zr(o, r - (n - 1) - 1),
          fit: !0
        };
      });
    }
  },
  methods: {
    itemColor(r) {
      if (this.isItemSelected(r))
        return this.color;
      if (this.isItemStartOrEndOfRange(r))
        return this.color;
      if (!this.isItemSelected(r))
        return "gray";
    },
    isItemToday(r) {
      return yt(r.date, /* @__PURE__ */ new Date()) === 0 && Le(r.date) === Le(/* @__PURE__ */ new Date());
    },
    isItemSelected(r) {
      var s, c;
      const o = structuredClone((s = this.value) == null ? void 0 : s.from), n = structuredClone((c = this.value) == null ? void 0 : c.to), l = r.date.getTime();
      return l >= o && l <= n;
    },
    isItemStartOrEndOfRange(r) {
      var l, s;
      const o = structuredClone((l = this.value) == null ? void 0 : l.from), n = structuredClone((s = this.value) == null ? void 0 : s.to);
      return yt(r.date, o) === 0 && Le(r.date) === Le(o) || yt(r.date, n) === 0 && Le(r.date) === Le(n);
    },
    select(r) {
      var l, s;
      r.earlier ? this.sourceDate = Jr(this.sourceDate, 1) : r.later && (this.sourceDate = ur(this.sourceDate, 1));
      let o = structuredClone((l = this.value) == null ? void 0 : l.from), n = structuredClone((s = this.value) == null ? void 0 : s.to);
      !o && !n || yt(r.date, o) < 0 && !n ? o = r.date : o && !n ? this.limit && yt(r.date, o) > this.limit ? this.$notification({
        content: `Date range must be ${this.limit} day${this.limit > 1 ? "s or less" : ""}`
      }) : n = r.date : (o = r.date, n = null), this.$emit("update:value", {
        from: o,
        to: n
      });
    }
  }
}, ow = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), sw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function aw(r, o, n, l, s, c) {
  const g = Ie("fs-button");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row flex-1 p-2",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-col min-w-max",
        r.$attrs["date-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-1 flex-row items-center",
          r.$attrs["controllers-container-class"]
        ))
      }, [
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_left",
          title: "Previous Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-left-button-class"]
          )),
          onClick: o[0] || (o[0] = We((h) => s.sourceDate = s.subMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"]),
        ow,
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg text-zinc-900 dark:text-zinc-50",
            r.$attrs["header-class"]
          ))
        }, G(s.format(s.sourceDate, "yyyy, LLL")), 3),
        sw,
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_right",
          title: "Next Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-right-button-class"]
          )),
          onClick: o[1] || (o[1] = We((h) => s.sourceDate = s.addMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"])
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "grid grid-cols-7 gap-1 mt-2",
          r.$attrs["items-container-class"]
        ))
      }, [
        (T(!0), L(ne, null, Ne(s.week, (h) => (T(), L("div", {
          class: y(s.twMerge(
            "flex flex-col",
            r.$attrs["week-days-container-class"]
          ))
        }, [
          D("h4", {
            class: y(s.twMerge(
              "font-sans font-semibold text-lg capitalize text-zinc-900 dark:text-zinc-50 text-center",
              r.$attrs["week-days-class"]
            ))
          }, G(h), 3)
        ], 2))), 256)),
        (T(!0), L(ne, null, Ne(c.days, (h) => (T(), _e(g, {
          color: c.itemColor(h),
          size: "small",
          class: y(s.twMerge(
            "min-w-[40px] w-10 min-h-[40px] h-10",
            h.fit ? "" : "opacity-25",
            c.isItemSelected(h) && !c.isItemStartOrEndOfRange(h) ? "bg-opacity-50" : "",
            r.$attrs["item-class"],
            c.isItemSelected(h) && !c.isItemStartOrEndOfRange(h) ? r.$attrs["range-item-class"] : "",
            c.isItemSelected(h) && c.isItemStartOrEndOfRange(h) ? r.$attrs["range-bound-item-class"] : ""
          )),
          title: s.format(h.date, "yyyy, dd LLL"),
          onClick: We((w) => c.select(h, "date"), ["stop"])
        }, {
          default: De(() => [
            D("div", {
              class: y(s.twMerge(
                "flex flex-row",
                r.$attrs["item-content-class"]
              ))
            }, [
              D("span", {
                class: y(s.twMerge(
                  "font-sans font-semibold text-base capitalize",
                  r.$attrs["item-content-value-class"]
                ))
              }, [
                s.getDate(h.date) < 10 ? (T(), L(ne, { key: 0 }, [
                  xe(" 0" + G(s.getDate(h.date)), 1)
                ], 64)) : (T(), L(ne, { key: 1 }, [
                  xe(G(s.getDate(h.date)), 1)
                ], 64))
              ], 2),
              c.isItemToday(h) ? (T(), L("div", {
                key: 0,
                class: y(s.twMerge(
                  "bg-red-600 rounded-full w-1 h-1",
                  r.$attrs["item-content-today-class"]
                ))
              }, null, 2)) : me("", !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["color", "class", "title", "onClick"]))), 256))
      ], 2)
    ], 2)
  ], 2);
}
const lw = /* @__PURE__ */ we(iw, [["render", aw]]), uw = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], cw = {
  name: "DatepickerComponent",
  props: {
    value: Object | Date,
    limit: Number,
    controllersColor: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  emits: ["update:value"],
  data() {
    return {
      week: uw,
      format: Sr,
      differenceInDays: yt,
      getDate: Le,
      subMonths: Jr,
      addMonths: ur,
      sourceDate: cr(/* @__PURE__ */ new Date()),
      twMerge: fe
    };
  },
  computed: {
    days() {
      return [...Array(42).keys()].map((r) => {
        const o = cr(this.sourceDate), n = vs(o), l = Ri(this.sourceDate);
        return r < n ? {
          date: ws(o, Math.abs(r + 1 - (n + 1))),
          earlier: !0
        } : r >= Le(l) + n ? {
          date: zr(o, r - (n - 1) - 1),
          later: !0
        } : {
          date: zr(o, r - (n - 1) - 1),
          fit: !0
        };
      });
    }
  },
  methods: {
    itemColor(r) {
      return this.isItemSelected(r) ? this.color : "gray";
    },
    isItemToday(r) {
      return yt(r.date, /* @__PURE__ */ new Date()) === 0 && Le(r.date) === Le(/* @__PURE__ */ new Date());
    },
    isItemSelected(r) {
      return yt(r.date, this.value) === 0 && Le(r.date) === Le(this.value);
    },
    select(r) {
      r.earlier ? this.sourceDate = Jr(this.sourceDate, 1) : r.later && (this.sourceDate = ur(this.sourceDate, 1)), this.$emit("update:value", r.date);
    }
  }
}, fw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), dw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function gw(r, o, n, l, s, c) {
  const g = Ie("fs-button");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row flex-1 p-2",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-col min-w-max",
        r.$attrs["date-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-1 flex-row items-center",
          r.$attrs["controllers-container-class"]
        ))
      }, [
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_left",
          title: "Previous Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-left-button-class"]
          )),
          onClick: o[0] || (o[0] = We((h) => s.sourceDate = s.subMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"]),
        fw,
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg text-zinc-900 dark:text-zinc-50",
            r.$attrs["header-class"]
          ))
        }, G(s.format(s.sourceDate, "yyyy, LLL")), 3),
        dw,
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_right",
          title: "Next Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-right-button-class"]
          )),
          onClick: o[1] || (o[1] = We((h) => s.sourceDate = s.addMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"])
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "grid grid-cols-7 gap-1 mt-2",
          r.$attrs["items-container-class"]
        ))
      }, [
        (T(!0), L(ne, null, Ne(s.week, (h) => (T(), L("div", {
          class: y(s.twMerge(
            "flex flex-col",
            r.$attrs["week-days-container-class"]
          ))
        }, [
          D("h4", {
            class: y(s.twMerge(
              "font-sans font-semibold text-lg capitalize text-zinc-900 dark:text-zinc-50 text-center",
              r.$attrs["week-days-class"]
            ))
          }, G(h), 3)
        ], 2))), 256)),
        (T(!0), L(ne, null, Ne(c.days, (h) => (T(), _e(g, {
          color: c.itemColor(h),
          size: "small",
          class: y(s.twMerge(
            "min-w-[40px] w-10 min-h-[40px] h-10",
            h.fit ? "" : "opacity-25",
            r.$attrs["item-class"]
          )),
          title: s.format(h.date, "yyyy, dd LLL"),
          onClick: We((w) => c.select(h, "date"), ["stop"])
        }, {
          default: De(() => [
            D("div", {
              class: y(s.twMerge(
                "flex flex-row",
                r.$attrs["item-content-class"]
              ))
            }, [
              D("span", {
                class: y(s.twMerge(
                  "font-sans font-semibold text-base capitalize",
                  r.$attrs["item-content-value-class"]
                ))
              }, [
                s.getDate(h.date) < 10 ? (T(), L(ne, { key: 0 }, [
                  xe(" 0" + G(s.getDate(h.date)), 1)
                ], 64)) : (T(), L(ne, { key: 1 }, [
                  xe(G(s.getDate(h.date)), 1)
                ], 64))
              ], 2),
              c.isItemToday(h) ? (T(), L("div", {
                key: 0,
                class: y(s.twMerge(
                  "bg-red-600 rounded-full w-1 h-1",
                  r.$attrs["item-content-today-class"]
                ))
              }, null, 2)) : me("", !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["color", "class", "title", "onClick"]))), 256))
      ], 2)
    ], 2)
  ], 2);
}
const hw = /* @__PURE__ */ we(cw, [["render", gw]]), mw = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], pw = [...Array(12).keys()].map((r) => {
  const o = r + 1;
  return o < 10 ? `0${o}` : o.toString();
}), bw = [...Array(60).keys()].filter((r) => r % 5 === 0).map((r) => r < 10 ? `0${r}` : r.toString()), vw = ["AM", "PM"], ww = {
  name: "DatepickerComponent",
  props: {
    value: Object | Date,
    limit: Number,
    controllersColor: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  emits: ["update:value"],
  data() {
    return {
      week: mw,
      hours: pw,
      minutes: bw,
      periods: vw,
      format: Sr,
      differenceInDays: yt,
      getDate: Le,
      subMonths: Jr,
      addMonths: ur,
      sourceDate: cr(/* @__PURE__ */ new Date()),
      twMerge: fe
    };
  },
  computed: {
    days() {
      return [...Array(42).keys()].map((r) => {
        const o = cr(this.sourceDate), n = vs(o), l = Ri(this.sourceDate);
        return r < n ? {
          date: ws(o, Math.abs(r + 1 - (n + 1))),
          earlier: !0
        } : r >= Le(l) + n ? {
          date: zr(o, r - (n - 1) - 1),
          later: !0
        } : {
          date: zr(o, r - (n - 1) - 1),
          fit: !0
        };
      });
    }
  },
  methods: {
    itemColor(r) {
      return this.isItemSelected(r) ? this.color : "gray";
    },
    hourItemColor(r) {
      const o = parseInt(r, 10), n = this.value;
      let l = (n == null ? void 0 : n.getHours()) > 12 ? (n == null ? void 0 : n.getHours()) - 12 : n == null ? void 0 : n.getHours();
      return l === 0 && (l = 12), l === o ? this.color : "gray";
    },
    minuteItemColor(r) {
      const o = parseInt(r, 10), n = this.value;
      return (n == null ? void 0 : n.getMinutes()) === o ? this.color : "gray";
    },
    periodItemColor(r) {
      const o = this.value;
      return (o == null ? void 0 : o.getHours()) > 12 && r === "PM" ? this.color : (o == null ? void 0 : o.getHours()) <= 12 && r === "AM" ? this.color : "gray";
    },
    isItemToday(r) {
      return yt(r.date, /* @__PURE__ */ new Date()) === 0 && Le(r.date) === Le(/* @__PURE__ */ new Date());
    },
    isItemSelected(r) {
      return yt(r.date, this.value) === 0 && Le(r.date) === Le(this.value);
    },
    select(r, o = "date") {
      if (r.earlier ? this.sourceDate = Jr(this.sourceDate, 1) : r.later && (this.sourceDate = ur(this.sourceDate, 1)), o !== "date" && this.value) {
        let n = structuredClone(this.value);
        o === "hours" && n.setHours(parseInt(r, 10) + (n.getHours() > 12 ? 12 : 0)), o === "minutes" && n.setMinutes(parseInt(r, 10)), o === "periods" && (r === "AM" && n.getHours() > 12 && n.setHours(n.getHours() - 12), r === "PM" && n.getHours() <= 12 && n.setHours(n.getHours() + 12)), this.$emit("update:value", n);
        return;
      } else if (o === "date") {
        let n = r.date;
        const l = structuredClone(this.value);
        n.setHours(l == null ? void 0 : l.getHours()), n.setMinutes(l == null ? void 0 : l.getMinutes()), this.$emit("update:value", r.date);
        return;
      }
    }
  }
}, yw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), xw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function _w(r, o, n, l, s, c) {
  const g = Ie("fs-button");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row flex-1 p-2",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-col min-w-max",
        r.$attrs["date-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-1 flex-row items-center",
          r.$attrs["controllers-container-class"]
        ))
      }, [
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_left",
          title: "Previous Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-left-button-class"]
          )),
          onClick: o[0] || (o[0] = We((h) => s.sourceDate = s.subMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"]),
        yw,
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg text-zinc-900 dark:text-zinc-50",
            r.$attrs["header-class"]
          ))
        }, G(s.format(s.sourceDate, "yyyy, LLL")), 3),
        xw,
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_right",
          title: "Next Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-right-button-class"]
          )),
          onClick: o[1] || (o[1] = We((h) => s.sourceDate = s.addMonths(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"])
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "grid grid-cols-7 gap-1 mt-2",
          r.$attrs["items-container-class"]
        ))
      }, [
        (T(!0), L(ne, null, Ne(s.week, (h) => (T(), L("div", {
          class: y(s.twMerge(
            "flex flex-col",
            r.$attrs["week-days-container-class"]
          ))
        }, [
          D("h4", {
            class: y(s.twMerge(
              "font-sans font-semibold text-lg capitalize text-zinc-900 dark:text-zinc-50 text-center",
              r.$attrs["week-days-class"]
            ))
          }, G(h), 3)
        ], 2))), 256)),
        (T(!0), L(ne, null, Ne(c.days, (h) => (T(), _e(g, {
          color: c.itemColor(h),
          size: "small",
          class: y(s.twMerge(
            "min-w-[40px] w-10 min-h-[40px] h-10",
            h.fit ? "" : "opacity-25",
            r.$attrs["item-class"]
          )),
          title: s.format(h.date, "yyyy, dd LLL"),
          onClick: We((w) => c.select(h, "date"), ["stop"])
        }, {
          default: De(() => [
            D("div", {
              class: y(s.twMerge(
                "flex flex-row",
                r.$attrs["item-content-class"]
              ))
            }, [
              D("span", {
                class: y(s.twMerge(
                  "font-sans font-semibold text-base capitalize",
                  r.$attrs["item-content-value-class"]
                ))
              }, [
                s.getDate(h.date) < 10 ? (T(), L(ne, { key: 0 }, [
                  xe(" 0" + G(s.getDate(h.date)), 1)
                ], 64)) : (T(), L(ne, { key: 1 }, [
                  xe(G(s.getDate(h.date)), 1)
                ], 64))
              ], 2),
              c.isItemToday(h) ? (T(), L("div", {
                key: 0,
                class: y(s.twMerge(
                  "bg-red-600 rounded-full w-1 h-1",
                  r.$attrs["item-content-today-class"]
                ))
              }, null, 2)) : me("", !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["color", "class", "title", "onClick"]))), 256))
      ], 2)
    ], 2),
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-row min-w-max max-h-[338px] ml-4",
        r.$attrs["time-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-col",
          r.$attrs["time-content-class"],
          r.$attrs["time-hours-content-class"]
        ))
      }, [
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg capitalize text-zinc-900                 dark:text-zinc-50 text-center",
            r.$attrs["time-title-class"],
            r.$attrs["time-hours-title-class"]
          ))
        }, " Hrs ", 2),
        D("div", {
          class: y(s.twMerge(
            "flex flex-col overflow-y-scroll hide-scrollbar mr-1",
            r.$attrs["time-items-container-class"],
            r.$attrs["time-hours-items-container-class"]
          ))
        }, [
          (T(!0), L(ne, null, Ne(s.hours, (h) => (T(), _e(g, {
            ref_for: !0,
            ref: `hour-${h}`,
            color: c.hourItemColor(h),
            size: "small",
            class: y(s.twMerge(
              "min-w-[40px] w-10 min-h-[40px] h-10 mb-1 last:mb-0",
              r.$attrs["time-item-class"],
              r.$attrs["time-hours-item-class"]
            )),
            onClick: We((w) => c.select(h, "hours"), ["stop"])
          }, {
            default: De(() => [
              xe(G(h), 1)
            ]),
            _: 2
          }, 1032, ["color", "class", "onClick"]))), 256))
        ], 2)
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "flex flex-col",
          r.$attrs["time-content-class"],
          r.$attrs["time-minutes-content-class"]
        ))
      }, [
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg capitalize text-zinc-900                 dark:text-zinc-50 text-center",
            r.$attrs["time-title-class"],
            r.$attrs["time-minutes-title-class"]
          ))
        }, " Min ", 2),
        D("div", {
          class: y(s.twMerge(
            "flex flex-col overflow-y-scroll hide-scrollbar mr-1",
            r.$attrs["time-items-container-class"],
            r.$attrs["time-minutes-items-container-class"]
          ))
        }, [
          (T(!0), L(ne, null, Ne(s.minutes, (h) => (T(), _e(g, {
            color: c.minuteItemColor(h),
            size: "small",
            class: y(s.twMerge(
              "min-w-[40px] w-10 min-h-[40px] h-10 mb-1 last:mb-0",
              r.$attrs["time-item-class"],
              r.$attrs["time-minutes-item-class"]
            )),
            onClick: We((w) => c.select(h, "minutes"), ["stop"])
          }, {
            default: De(() => [
              xe(G(h), 1)
            ]),
            _: 2
          }, 1032, ["color", "class", "onClick"]))), 256))
        ], 2)
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "flex flex-col",
          r.$attrs["time-content-class"],
          r.$attrs["time-period-content-class"]
        ))
      }, [
        D("div", {
          class: y(s.twMerge(
            "h-7",
            r.$attrs["time-period-gap-class"]
          ))
        }, null, 2),
        (T(!0), L(ne, null, Ne(s.periods, (h) => (T(), _e(g, {
          color: c.periodItemColor(h),
          size: "small",
          class: y(s.twMerge(
            "min-w-[40px] w-10 min-h-[40px] h-10 mb-1 last:mb-0",
            r.$attrs["time-item-class"],
            r.$attrs["time-period-item-class"]
          )),
          onClick: We((w) => c.select(h, "periods"), ["stop"])
        }, {
          default: De(() => [
            xe(G(h), 1)
          ]),
          _: 2
        }, 1032, ["color", "class", "onClick"]))), 256))
      ], 2)
    ], 2)
  ], 2);
}
const Cw = /* @__PURE__ */ we(ww, [["render", _w]]), uu = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], kw = {
  name: "DatepickerComponent",
  props: {
    value: Object | Date,
    limit: Number,
    controllersColor: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    },
    limitFutureDate: {
      type: Boolean,
      default: !1
    },
    containerClass: {},
    dateContainerClass: {},
    itemsContainerClass: {},
    itemClass: {},
    headerClass: {},
    controllersClass: {}
  },
  emits: ["update:value"],
  data() {
    return {
      months: uu,
      format: Sr,
      differenceInMonths: qt,
      subYears: zu,
      addYears: bs,
      getYear: Mu,
      sourceDate: cr(/* @__PURE__ */ new Date()),
      twMerge: fe
    };
  },
  computed: {
    monthsByName() {
      return Object.fromEntries(uu.map((r, o) => [r, o + 1]));
    }
  },
  methods: {
    itemDate(r) {
      const o = Sr(this.sourceDate, "yyyy");
      return new Date(o, this.monthsByName[r], 0);
    },
    itemColor(r) {
      return this.isItemSelected(r) ? this.color : "gray";
    },
    isItemThisMonth(r) {
      return qt(r, /* @__PURE__ */ new Date()) === 0 && At(r) === At(/* @__PURE__ */ new Date());
    },
    isItemSelected(r) {
      return qt(r, this.value) === 0 && At(r) === At(this.value);
    },
    select(r) {
      this.$emit("update:value", r);
    }
  }
}, Mw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), zw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function Sw(r, o, n, l, s, c) {
  const g = Ie("fs-button");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row flex-1 p-2",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-col min-w-max",
        r.$attrs["date-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-1 flex-row items-center",
          r.$attrs["controllers-container-class"]
        ))
      }, [
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_left",
          title: "Previous Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-left-button-class"]
          )),
          onClick: o[0] || (o[0] = We((h) => s.sourceDate = s.subYears(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"]),
        Mw,
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg text-zinc-900 dark:text-zinc-50",
            r.$attrs["header-class"]
          ))
        }, G(s.format(s.sourceDate, "yyyy")), 3),
        zw,
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_right",
          title: "Next Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-right-button-class"]
          )),
          disabled: n.limitFutureDate ? parseInt(s.format(s.sourceDate, "yyyy"), 10) >= s.getYear(/* @__PURE__ */ new Date()) : !1,
          onClick: o[1] || (o[1] = We((h) => s.sourceDate = s.addYears(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class", "disabled"])
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "grid grid-cols-3 gap-1 mt-2",
          r.$attrs["items-container-class"]
        ))
      }, [
        (T(!0), L(ne, null, Ne(s.months, (h) => (T(), _e(g, {
          color: c.itemColor(c.itemDate(h)),
          size: "small",
          class: y(s.twMerge(
            "min-w-[99px] w-10 min-h-[40px] h-10",
            r.$attrs["item-class"]
          )),
          title: s.format(c.itemDate(h), "yyyy, LLL"),
          onClick: We((w) => c.select(c.itemDate(h), "date"), ["stop"])
        }, {
          default: De(() => [
            D("div", {
              class: y(s.twMerge(
                "flex flex-row",
                r.$attrs["item-content-class"]
              ))
            }, [
              D("span", {
                class: y(s.twMerge(
                  "font-sans font-semibold text-base capitalize",
                  r.$attrs["item-content-value-class"]
                ))
              }, G(h), 3),
              c.isItemThisMonth(c.itemDate(h)) ? (T(), L("div", {
                key: 0,
                class: y(s.twMerge(
                  "bg-red-600 rounded-full w-1 h-1",
                  r.$attrs["item-content-today-class"]
                ))
              }, null, 2)) : me("", !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["color", "class", "title", "onClick"]))), 256))
      ], 2)
    ], 2)
  ], 2);
}
const Tw = /* @__PURE__ */ we(kw, [["render", Sw]]), cu = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Ow = {
  name: "DatepickerComponent",
  props: {
    value: Object | Date,
    limit: Number,
    controllersColor: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    },
    limitFutureDate: {
      type: Boolean,
      default: !1
    },
    containerClass: {},
    dateContainerClass: {},
    itemsContainerClass: {},
    itemClass: {},
    rangeBoundItemClass: {},
    rangeItemClass: {},
    headerClass: {},
    controllersClass: {}
  },
  emits: ["update:value"],
  data() {
    return {
      months: cu,
      format: Sr,
      differenceInMonths: qt,
      subYears: zu,
      addYears: bs,
      getYear: Mu,
      sourceDate: cr(/* @__PURE__ */ new Date()),
      twMerge: fe
    };
  },
  computed: {
    monthsByName() {
      return Object.fromEntries(cu.map((r, o) => [r, o + 1]));
    }
  },
  methods: {
    itemDate(r) {
      const o = Sr(this.sourceDate, "yyyy");
      return new Date(o, this.monthsByName[r], 0);
    },
    itemColor(r) {
      if (this.isItemSelected(r))
        return this.color;
      if (this.isItemStartOrEndOfRange(r))
        return this.color;
      if (!this.isItemSelected(r))
        return "gray";
    },
    isItemThisMonth(r) {
      return qt(r, /* @__PURE__ */ new Date()) === 0 && At(r) === At(/* @__PURE__ */ new Date());
    },
    isItemSelected(r) {
      var s, c;
      const o = structuredClone((s = this.value) == null ? void 0 : s.from), n = structuredClone((c = this.value) == null ? void 0 : c.to), l = r.getTime();
      return l >= o && l <= n;
    },
    isItemStartOrEndOfRange(r) {
      var l, s;
      const o = structuredClone((l = this.value) == null ? void 0 : l.from), n = structuredClone((s = this.value) == null ? void 0 : s.to);
      return qt(r, o) === 0 && At(r) === At(o) || qt(r, n) === 0 && At(r) === At(n);
    },
    select(r) {
      var l, s;
      let o = structuredClone((l = this.value) == null ? void 0 : l.from), n = structuredClone((s = this.value) == null ? void 0 : s.to);
      !o && !n || qt(r, o) < 0 && !n ? o = r : o && !n ? this.limit && qt(r, o) > this.limit ? this.$notification({
        content: `Month range must be ${this.limit} month${this.limit > 1 ? "s or less" : ""}`
      }) : n = r : (o = r, n = null), this.$emit("update:value", {
        from: o,
        to: n
      });
    }
  }
}, Dw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), Lw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function Aw(r, o, n, l, s, c) {
  const g = Ie("fs-button");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row flex-1 p-2",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "rounded-lg flex flex-col min-w-max",
        r.$attrs["date-container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex flex-1 flex-row items-center",
          r.$attrs["controllers-container-class"]
        ))
      }, [
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_left",
          title: "Previous Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-left-button-class"]
          )),
          onClick: o[0] || (o[0] = We((h) => s.sourceDate = s.subYears(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class"]),
        Dw,
        D("h4", {
          class: y(s.twMerge(
            "font-sans font-semibold text-lg text-zinc-900 dark:text-zinc-50",
            r.$attrs["header-class"]
          ))
        }, G(s.format(s.sourceDate, "yyyy")), 3),
        Lw,
        ze(g, {
          color: n.controllersColor || n.color,
          icon: "chevron_right",
          title: "Next Month",
          size: "small",
          class: y(s.twMerge(
            r.$attrs["controllers-class"],
            r.$attrs["controllers-right-button-class"]
          )),
          disabled: n.limitFutureDate ? parseInt(s.format(s.sourceDate, "yyyy"), 10) >= s.getYear(/* @__PURE__ */ new Date()) : !1,
          onClick: o[1] || (o[1] = We((h) => s.sourceDate = s.addYears(s.sourceDate, 1), ["stop"]))
        }, null, 8, ["color", "class", "disabled"])
      ], 2),
      D("div", {
        class: y(s.twMerge(
          "grid grid-cols-3 gap-1 mt-2",
          r.$attrs["items-container-class"]
        ))
      }, [
        (T(!0), L(ne, null, Ne(s.months, (h) => (T(), _e(g, {
          color: c.itemColor(c.itemDate(h)),
          size: "small",
          class: y(s.twMerge(
            "min-w-[99px] w-10 min-h-[40px] h-10",
            c.isItemSelected(c.itemDate(h)) && !c.isItemStartOrEndOfRange(c.itemDate(h)) ? "bg-opacity-50" : "",
            r.$attrs["item-class"],
            c.isItemSelected(c.itemDate(h)) && !c.isItemStartOrEndOfRange(c.itemDate(h)) ? r.$attrs["range-item-class"] : "",
            c.isItemSelected(c.itemDate(h)) && c.isItemStartOrEndOfRange(c.itemDate(h)) ? r.$attrs["range-bound-item-class"] : ""
          )),
          title: s.format(c.itemDate(h), "yyyy, LLL"),
          onClick: We((w) => c.select(c.itemDate(h), "date"), ["stop"])
        }, {
          default: De(() => [
            D("div", {
              class: y(s.twMerge(
                "flex flex-row",
                r.$attrs["item-content-class"]
              ))
            }, [
              D("span", {
                class: y(s.twMerge(
                  "font-sans font-semibold text-base capitalize",
                  r.$attrs["item-content-value-class"]
                ))
              }, G(h), 3),
              c.isItemThisMonth(c.itemDate(h)) ? (T(), L("div", {
                key: 0,
                class: y(s.twMerge(
                  "bg-red-600 rounded-full w-1 h-1",
                  r.$attrs["item-content-today-class"]
                ))
              }, null, 2)) : me("", !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["color", "class", "title", "onClick"]))), 256))
      ], 2)
    ], 2)
  ], 2);
}
const Ew = /* @__PURE__ */ we(Ow, [["render", Aw]]), Iw = {
  name: "CalendarComponent",
  components: {
    DateRangePicker: lw,
    DatePicker: hw,
    DatetimePicker: Cw,
    MonthPicker: Tw,
    MonthRangePicker: Ew
  },
  props: {
    type: {
      type: String,
      default: "date"
    }
  },
  computed: {
    component() {
      return {
        range: "DateRangePicker",
        date: "DatePicker",
        datetime: "DatetimePicker",
        month: "MonthPicker",
        monthrange: "MonthRangePicker"
      }[this.type];
    }
  }
};
function Rw(r, o, n, l, s, c) {
  return T(), _e(Ai(c.component), us(cs(r.$attrs)), null, 16);
}
const Pw = /* @__PURE__ */ we(Iw, [["render", Rw]]), Ww = {
  name: "ContainerComponent",
  props: {
    mode: {
      type: String,
      default: "smart"
    },
    size: {
      type: String,
      default: "large"
    },
    bg: {
      type: String,
      default: ""
    },
    hoverable: {
      type: Boolean
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    wrapperClass() {
      var l, s;
      const r = (l = this.size) == null ? void 0 : l.toLowerCase(), o = (s = this.mode) == null ? void 0 : s.toLowerCase();
      let n = "";
      switch (n += "rounded-lg", r) {
        case "x-small":
          n += " p-2";
          break;
        case "small":
          n += " p-2 md:!p-4";
          break;
        case "large":
          n += " p-2 md:!p-8";
          break;
        default:
          n += " p-2 md:!p-6";
          break;
      }
      switch (o) {
        case "smart":
          n += " bg-zinc-950 bg-opacity-5 text-zinc-950 dark:bg-zinc-50 dark:bg-opacity-5 dark:text-zinc-50";
          break;
        case "reverse-smart":
          n += " bg-zinc-50 bg-opacity-5 text-zinc-950 dark:bg-zinc-950 dark:bg-opacity-5 dark:text-zinc-50";
          break;
      }
      if (this.hoverable)
        switch (o) {
          case "smart":
          case "custom":
            n += " transition-all ease-in-out duration-300 hover:shadow-lg hover:bg-zinc-950 hover:bg-opacity-10 dark:hover:bg-zinc-50 dark:hover:bg-opacity-10 cursor-pointer";
            break;
          case "reverse-smart":
            n += " transition-all ease-in-out duration-300 hover:shadow-lg hover:bg-zinc-50 hover:bg-opacity-10 dark:hover:bg-zinc-950 dark:hover:bg-opacity-10 cursor-pointer";
            break;
        }
      return this.bg && (n += ` ${this.bg}`), n;
    }
  }
};
function Bw(r, o, n, l, s, c) {
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-col",
      c.wrapperClass,
      r.$attrs.class
    ))
  }, [
    K(r.$slots, "default")
  ], 2);
}
const Fw = /* @__PURE__ */ we(Ww, [["render", Bw]]), Nw = {
  name: "ContainerComponent",
  props: {
    mode: {
      type: String
    },
    size: {
      type: String,
      default: "large"
    },
    backUrl: {
      type: String
    },
    backText: {
      type: String,
      default: "Back"
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    containerSizeClass() {
      var l, s;
      const r = (l = this.size) == null ? void 0 : l.toLowerCase(), o = (s = this.mode) == null ? void 0 : s.toLowerCase();
      let n = "";
      switch (r) {
        case "x-small":
          n += "p-2";
          break;
        case "small":
          n += "p-2 md:!p-4";
          break;
        case "large":
          n += "p-2 md:!p-12";
          break;
        default:
          n += "p-2 md:!p-8";
          break;
      }
      return o === "fixed" && (n += " h-screen"), n;
    }
  }
};
function Uw(r, o, n, l, s, c) {
  const g = Ie("fs-button"), h = Ie("fs-wrapper");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-col w-full bg-slate-100 dark:bg-slate-800",
      c.containerSizeClass,
      r.$attrs["container-class"]
    ))
  }, [
    ze(h, {
      size: n.size,
      class: y(["", s.twMerge(
        "w-full h-full",
        r.$attrs["box-class"]
      )])
    }, {
      default: De(() => {
        var w, x, z, O, R, E;
        return [
          (w = n.backUrl) != null && w.length || r.$slots.title || (x = n.title) != null && x.length ? (T(), L("div", {
            key: 0,
            class: y(s.twMerge(
              "flex flex-row items-center mb-2 md:mb-4",
              r.$attrs["box-content-class"]
            ))
          }, [
            (z = n.backUrl) != null && z.length ? (T(), _e(g, {
              key: 0,
              href: n.backUrl,
              icon: "chevron_left",
              type: "text",
              color: "black",
              title: "Back",
              class: y(s.twMerge(r.$attrs["back-button-class"]))
            }, {
              default: De(() => [
                r.$slots["back-text"] ? K(r.$slots, "back-text", { key: 0 }) : (T(), L(ne, { key: 1 }, [
                  xe(G(n.backText), 1)
                ], 64))
              ]),
              _: 3
            }, 8, ["href", "class"])) : me("", !0),
            r.$slots.title ? (T(), L("div", {
              key: 1,
              class: y(s.twMerge(
                "w-full text-3xl font-semibold text-zinc-900 dark:text-zinc-50",
                r.back && (r.$slots["back-text"] || (O = n.backText) != null && O.length) ? "ml-2 md:ml-4" : ""
              ))
            }, [
              K(r.$slots, "title")
            ], 2)) : (R = n.title) != null && R.length ? (T(), L("h3", {
              key: 2,
              class: y(s.twMerge(
                "w-full text-3xl font-semibold text-zinc-900 dark:text-zinc-50",
                r.back && (r.$slots["back-text"] || (E = n.backText) != null && E.length) ? "ml-2 md:ml-4" : ""
              ))
            }, G(n.title), 3)) : me("", !0)
          ], 2)) : me("", !0),
          K(r.$slots, "default")
        ];
      }),
      _: 3
    }, 8, ["size", "class"])
  ], 2);
}
const $w = /* @__PURE__ */ we(Nw, [["render", Uw]]), Hw = {
  name: "ModalComponent",
  props: {
    modelValue: Boolean,
    title: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  watch: {
    modelValue: function() {
      this.modelValue ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden");
    }
  }
}, Yw = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function Vw(r, o, n, l, s, c) {
  var h;
  const g = Ie("fs-button");
  return T(), _e(Dp, { to: "body" }, [
    n.modelValue ? (T(), L("div", {
      key: 0,
      class: y(s.twMerge(
        "fixed flex flex-col transition-all ease-in-out duration-300 inset-0             items-center justify-center",
        n.modelValue ? "z-[99999]" : "",
        r.$attrs["container-class"]
      ))
    }, [
      D("div", {
        class: y(s.twMerge(
          "absolute inset-0 transition-all ease-in-out duration-300 bg-zinc-900               bg-opacity-60 cursor-pointer",
          n.modelValue ? "opacity-100 backdrop-blur" : "opacity-0 backdrop-blur-none",
          r.$attrs["overlay-class"]
        )),
        onClick: o[0] || (o[0] = (w) => r.$emit("update:modelValue", !1))
      }, null, 2),
      D("div", {
        class: y(s.twMerge(
          "flex flex-col transition-all ease-in-out duration-300 z-40 text-zinc-900 bg-zinc-50              dark:text-zinc-50 dark:bg-zinc-800 rounded-lg p-2 md:p-4 min-w-[320px] min-h-[220px]",
          n.modelValue ? "opacity-100" : "opacity-0 -translate-y-32",
          r.$attrs["modal-class"]
        ))
      }, [
        D("div", {
          class: y(s.twMerge(
            "flex flex-row mb-2 md:mb-4",
            r.$attrs["modal-header-class"]
          ))
        }, [
          r.$slots.title ? K(r.$slots, "title", { key: 0 }) : (h = n.title) != null && h.length ? (T(), L("h3", {
            key: 1,
            class: y(s.twMerge(
              "text-2xl font-semibold",
              r.$attrs["modal-title-class"]
            ))
          }, G(n.title), 3)) : me("", !0),
          Yw,
          ze(g, {
            type: "text",
            color: "black",
            icon: "close",
            class: y(s.twMerge(r.$attrs["modal-close-button-class"])),
            onClick: o[1] || (o[1] = (w) => r.$emit("update:modelValue", !1))
          }, null, 8, ["class"])
        ], 2),
        D("div", {
          class: y(s.twMerge(
            "flex flex-col flex-1",
            r.$attrs["modal-content-class"]
          ))
        }, [
          K(r.$slots, "default")
        ], 2)
      ], 2)
    ], 2)) : me("", !0)
  ]);
}
const Gw = /* @__PURE__ */ we(Hw, [["render", Vw]]);
const qw = {
  name: "ProgressComponent",
  props: {
    size: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    progressSizeClass() {
      var n;
      const r = (n = this.size) == null ? void 0 : n.toLowerCase();
      let o = "";
      switch (r) {
        case "small":
          o += " h-1";
          break;
        case "large":
          o += " h-3";
          break;
        default:
          o += " h-2";
          break;
      }
      return o;
    },
    progressBarClass() {
      var n;
      const r = (n = this.color) == null ? void 0 : n.toLowerCase();
      let o = "";
      return o += {
        blue: "bg-sky-300",
        red: "bg-red-300",
        yellow: "bg-yellow-300",
        green: "bg-green-300",
        gray: "bg-gray-300 dark:bg-gray-600",
        black: "bg-zinc-900"
      }[r], o;
    }
  }
};
function Xw(r, o, n, l, s, c) {
  return T(), L("div", {
    class: y(s.twMerge(
      "w-full bg-zinc-300 dark:bg-zinc-500 rounded-sm overflow-hidden",
      c.progressSizeClass,
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "w-full h-full rounded-sm origin-[0%_50%] animate-bar",
        c.progressBarClass,
        r.$attrs["progress-bar-class"]
      ))
    }, null, 2)
  ], 2);
}
const Kw = /* @__PURE__ */ we(qw, [["render", Xw], ["__scopeId", "data-v-549517fb"]]), Qw = {
  name: "ProgressComponent",
  props: {
    progressBarClass: {
      type: String,
      default: ""
    },
    size: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    spinnerColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return {
        blue: "text-sky-300",
        red: "text-red-300",
        yellow: "text-yellow-300",
        green: "text-green-300",
        gray: "text-zinc-400 dark:text-zinc-500",
        black: "text-zinc-900 dark:text-zinc-600"
      }[r];
    },
    spinnerSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return " h-5 w-5";
        case "large":
          return " h-12 w-12";
        default:
          return " h-8 w-8";
      }
    }
  }
}, Jw = /* @__PURE__ */ D("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), Zw = /* @__PURE__ */ D("path", {
  class: "opacity-100",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), jw = [
  Jw,
  Zw
];
function ey(r, o, n, l, s, c) {
  return T(), L("svg", {
    class: y(["", s.twMerge(
      "animate-spin",
      c.spinnerColorClass,
      c.spinnerSizeClass,
      r.$attrs["container-class"]
    )]),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, jw, 2);
}
const ty = /* @__PURE__ */ we(Qw, [["render", ey]]), ry = {
  name: "CheckboxComponent",
  inheritAttrs: !1,
  props: {
    modelValue: {},
    value: {},
    label: {
      type: String
    },
    size: {
      type: String
    },
    icon: {
      type: String,
      default: "check"
    },
    color: {
      type: String,
      default: "blue"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    id() {
      return Math.random();
    },
    radioColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return this.disabled ? "bg-gray-100 dark:bg-gray-600 border-2 border-gray-200 dark:border-gray-600" : this.modelValue === this.value ? {
        blue: "bg-sky-300 group-hover/radio:bg-sky-400",
        red: "bg-red-300 group-hover/radio:bg-red-400",
        yellow: "bg-yellow-300 group-hover/radio:bg-yellow-400",
        green: "bg-green-300 group-hover/radio:bg-green-400",
        gray: "bg-gray-300 group-hover/radio:bg-gray-400 dark:bg-gray-600               dark:group-hover/radio:bg-gray-700",
        black: "bg-zinc-900 group-hover/radio:bg-zinc-700 dark:bg-zinc-800               dark:group-hover/radio:bg-zinc-700"
      }[r] : "bg-gray-400 border-2 border-gray-200 dark:border-gray-600             group-hover/radio:bg-gray-500 dark:group-hover/radio:bg-gray-700             group-hover/radio:border-gray-300 dark:group-hover/radio:border-gray-600";
    },
    radioSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] leading-3             text-base h-10";
        case "large":
          return "min-w-[34px] min-h-[34px] max-w-[34px] max-h-[34px] leading-7             text-xl h-14";
        default:
          return "min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] leading-5             text-lg h-12";
      }
    },
    radioLabelClass() {
      var n;
      const r = (n = this.size) == null ? void 0 : n.toLowerCase();
      let o = "";
      switch (r) {
        case "small":
          o += "leading-3 text-base";
          break;
        case "large":
          o += "leading-7 text-xl";
          break;
        default:
          o += "leading-5 text-lg";
          break;
      }
      return o += this.disabled ? " cursor-not-allowed" : " cursor-pointer", o;
    }
  }
}, ny = ["for"], iy = ["id", "value", "disabled", "checked"];
function oy(r, o, n, l, s, c) {
  var h, w, x;
  const g = Ie("fs-icon");
  return T(), L("label", {
    for: c.id,
    class: y(s.twMerge(
      "group/radio flex flex-row items-center select-none relative         text-zinc-900 dark:text-zinc-50",
      c.radioLabelClass,
      r.$attrs["container-class"]
    ))
  }, [
    D("input", Ei(r.$attrs, {
      id: c.id,
      value: n.modelValue,
      type: "radio",
      class: s.twMerge(
        "absolute opacity-0 w-0 h-0",
        r.$attrs.class
      ),
      disabled: n.disabled,
      checked: n.modelValue === n.value,
      onChange: o[0] || (o[0] = () => {
        n.disabled || r.$emit("update:modelValue", n.value);
      })
    }), null, 16, iy),
    D("div", {
      class: y(s.twMerge(
        "rounded-full flex flex-row items-center justify-center           shadow-md group-hover/radio:shadow-lg transition-all ease-in-out",
        c.radioColorClass,
        c.radioSizeClass,
        r.$attrs["icon-container-class"]
      ))
    }, [
      ze(g, {
        name: "circle",
        size: n.size,
        color: n.disabled ? "gray" : {
          blue: "black",
          red: "black",
          yellow: "black",
          green: "black",
          gray: "black",
          black: "gray"
        }[(h = n.color) == null ? void 0 : h.toLowerCase()],
        class: y(s.twMerge(
          "transition-all ease-in-out text-opacity-70",
          n.modelValue === n.value ? "scale-100 opacity-100" : "scale-75 opacity-0",
          r.$attrs["icon-class"]
        ))
      }, null, 8, ["size", "color", "class"])
    ], 2),
    r.$slots.label || (w = n.label) != null && w.length ? (T(), L("div", {
      key: 0,
      class: y(s.twMerge(
        "ml-2 font-semibold",
        c.radioLabelClass,
        r.$attrs["label-class"]
      ))
    }, [
      r.$slots.label ? K(r.$slots, "label", { key: 0 }) : (x = n.label) != null && x.length ? (T(), L(ne, { key: 1 }, [
        xe(G(n.label), 1)
      ], 64)) : me("", !0)
    ], 2)) : me("", !0)
  ], 10, ny);
}
const sy = /* @__PURE__ */ we(ry, [["render", oy]]), ay = {
  name: "SwitchComponent",
  props: {
    before: {
      type: String
    },
    after: {
      type: String
    },
    modelValue: {
      type: Boolean
    },
    size: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    switchColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return this.disabled ? "!cursor-not-allowed bg-gray-300 dark:bg-gray-300" : this.modelValue ? {
        blue: "bg-sky-300 hover:bg-sky-400",
        red: "bg-red-300 hover:bg-red-400",
        yellow: "bg-yellow-300 hover:bg-yellow-400",
        green: "bg-green-300 hover:bg-green-400",
        gray: "bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-700",
        black: "bg-zinc-900 hover:bg-zinc-700 dark:bg-zinc-800 dark:hover:bg-zinc-900"
      }[r] : "bg-gray-100 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700";
    },
    switchSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "rounded-[6px] min-w-[58px] min-h-[24px] max-w-[58px] max-h-[24px] h-10 p-1";
        case "large":
          return "rounded-[8px] min-w-[86px] min-h-[34px] max-w-[86px] max-h-[34px] h-14 p-1";
        default:
          return "rounded-[7px] min-w-[66px] min-h-[28px] max-w-[66px] max-h-[28px] h-12 p-1";
      }
    },
    switchHanlderColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return this.disabled ? "bg-gray-400 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80" : this.modelValue ? {
        blue: "bg-gray-300 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80",
        red: "bg-gray-300 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80",
        yellow: "bg-gray-300 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80",
        green: "bg-gray-300 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80",
        gray: "bg-gray-100 bg-opacity-80 dark:bg-gray-800 dark:bg-opacity-60",
        black: "bg-gray-300 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80"
      }[r] : "bg-gray-400 bg-opacity-80 dark:bg-gray-500 dark:bg-opacity-80";
    },
    switchHanlderSizeClass() {
      var n;
      const r = (n = this.size) == null ? void 0 : n.toLowerCase();
      let o = "";
      switch (r) {
        case "small":
          o += " rounded-[5px]", this.modelValue && (o += " translate-x-[24px]");
          break;
        case "large":
          o += " rounded-[7px]", this.modelValue && (o += " translate-x-[39px]");
          break;
        default:
          o += " rounded-[6px]", this.modelValue && (o += " translate-x-[29px]");
          break;
      }
      return o;
    }
  }
};
function ly(r, o, n, l, s, c) {
  var g, h;
  return T(), L("div", {
    class: y(s.twMerge(
      "group/switch flex flex-row items-center",
      r.$attrs["container-class"]
    ))
  }, [
    D("label", {
      class: y(s.twMerge(
        "text-base text-zinc-900 dark:text-zinc-50 font-semibold",
        (g = n.before) != null && g.length ? "mr-2" : "",
        r.$attrs["label-class"],
        r.$attrs["label-before-class"]
      ))
    }, [
      r.$slots.before ? K(r.$slots, "before", { key: 0 }) : (T(), L(ne, { key: 1 }, [
        xe(G(n.before), 1)
      ], 64))
    ], 2),
    D("div", {
      class: y(s.twMerge(
        "flex flex-row transition-all ease-in-out duration-300           shadow-md group-hover/switch:shadow-lg overflow-hidden cursor-pointer",
        c.switchColorClass,
        c.switchSizeClass,
        r.$attrs["handler-container-class"]
      )),
      onClick: o[0] || (o[0] = () => {
        n.disabled || r.$emit("update:modelValue", !n.modelValue);
      })
    }, [
      D("div", {
        class: y(s.twMerge(
          "flex-1 max-w-[50%] transition-all ease-in-out duration-300",
          c.switchHanlderColorClass,
          c.switchHanlderSizeClass,
          r.$attrs["handler-class"]
        ))
      }, null, 2)
    ], 2),
    D("label", {
      class: y(s.twMerge(
        "text-base text-zinc-900 dark:text-zinc-50 font-semibold",
        (h = n.after) != null && h.length ? "ml-2" : "",
        r.$attrs["label-class"],
        r.$attrs["label-before-class"]
      ))
    }, [
      r.$slots.after ? K(r.$slots, "after", { key: 0 }) : (T(), L(ne, { key: 1 }, [
        xe(G(n.after), 1)
      ], 64))
    ], 2)
  ], 2);
}
const uy = /* @__PURE__ */ we(ay, [["render", ly]]), gs = Math.min, Kr = Math.max, Di = Math.round, Mi = Math.floor, fr = (r) => ({
  x: r,
  y: r
});
function Su(r) {
  return r.split("-")[0];
}
function cy(r) {
  return r.split("-")[1];
}
function fy(r) {
  return r === "x" ? "y" : "x";
}
function dy(r) {
  return r === "y" ? "height" : "width";
}
function Tu(r) {
  return ["top", "bottom"].includes(Su(r)) ? "y" : "x";
}
function gy(r) {
  return fy(Tu(r));
}
function Ou(r) {
  return {
    ...r,
    top: r.y,
    left: r.x,
    right: r.x + r.width,
    bottom: r.y + r.height
  };
}
function fu(r, o, n) {
  let {
    reference: l,
    floating: s
  } = r;
  const c = Tu(o), g = gy(o), h = dy(g), w = Su(o), x = c === "y", z = l.x + l.width / 2 - s.width / 2, O = l.y + l.height / 2 - s.height / 2, R = l[h] / 2 - s[h] / 2;
  let E;
  switch (w) {
    case "top":
      E = {
        x: z,
        y: l.y - s.height
      };
      break;
    case "bottom":
      E = {
        x: z,
        y: l.y + l.height
      };
      break;
    case "right":
      E = {
        x: l.x + l.width,
        y: O
      };
      break;
    case "left":
      E = {
        x: l.x - s.width,
        y: O
      };
      break;
    default:
      E = {
        x: l.x,
        y: l.y
      };
  }
  switch (cy(o)) {
    case "start":
      E[g] -= R * (n && x ? -1 : 1);
      break;
    case "end":
      E[g] += R * (n && x ? -1 : 1);
      break;
  }
  return E;
}
const hy = async (r, o, n) => {
  const {
    placement: l = "bottom",
    strategy: s = "absolute",
    middleware: c = [],
    platform: g
  } = n, h = c.filter(Boolean), w = await (g.isRTL == null ? void 0 : g.isRTL(o));
  let x = await g.getElementRects({
    reference: r,
    floating: o,
    strategy: s
  }), {
    x: z,
    y: O
  } = fu(x, l, w), R = l, E = {}, $ = 0;
  for (let W = 0; W < h.length; W++) {
    const {
      name: F,
      fn: H
    } = h[W], {
      x: te,
      y: oe,
      data: ke,
      reset: de
    } = await H({
      x: z,
      y: O,
      initialPlacement: l,
      placement: R,
      strategy: s,
      middlewareData: E,
      rects: x,
      platform: g,
      elements: {
        reference: r,
        floating: o
      }
    });
    z = te ?? z, O = oe ?? O, E = {
      ...E,
      [F]: {
        ...E[F],
        ...ke
      }
    }, de && $ <= 50 && ($++, typeof de == "object" && (de.placement && (R = de.placement), de.rects && (x = de.rects === !0 ? await g.getElementRects({
      reference: r,
      floating: o,
      strategy: s
    }) : de.rects), {
      x: z,
      y: O
    } = fu(x, R, w)), W = -1);
  }
  return {
    x: z,
    y: O,
    placement: R,
    strategy: s,
    middlewareData: E
  };
};
function Xt(r) {
  return ys(r) ? (r.nodeName || "").toLowerCase() : "#document";
}
function lt(r) {
  var o;
  return (r == null || (o = r.ownerDocument) == null ? void 0 : o.defaultView) || window;
}
function Qt(r) {
  var o;
  return (o = (ys(r) ? r.ownerDocument : r.document) || window.document) == null ? void 0 : o.documentElement;
}
function ys(r) {
  return r instanceof Node || r instanceof lt(r).Node;
}
function Kt(r) {
  return r instanceof Element || r instanceof lt(r).Element;
}
function It(r) {
  return r instanceof HTMLElement || r instanceof lt(r).HTMLElement;
}
function du(r) {
  return typeof ShadowRoot > "u" ? !1 : r instanceof ShadowRoot || r instanceof lt(r).ShadowRoot;
}
function Ln(r) {
  const {
    overflow: o,
    overflowX: n,
    overflowY: l,
    display: s
  } = xt(r);
  return /auto|scroll|overlay|hidden|clip/.test(o + l + n) && !["inline", "contents"].includes(s);
}
function my(r) {
  return ["table", "td", "th"].includes(Xt(r));
}
function xs(r) {
  const o = _s(), n = xt(r);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !o && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !o && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((l) => (n.willChange || "").includes(l)) || ["paint", "layout", "strict", "content"].some((l) => (n.contain || "").includes(l));
}
function Du(r) {
  let o = Zr(r);
  for (; It(o) && !Pi(o); ) {
    if (xs(o))
      return o;
    o = Zr(o);
  }
  return null;
}
function _s() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Pi(r) {
  return ["html", "body", "#document"].includes(Xt(r));
}
function xt(r) {
  return lt(r).getComputedStyle(r);
}
function Wi(r) {
  return Kt(r) ? {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  } : {
    scrollLeft: r.pageXOffset,
    scrollTop: r.pageYOffset
  };
}
function Zr(r) {
  if (Xt(r) === "html")
    return r;
  const o = (
    // Step into the shadow DOM of the parent of a slotted node.
    r.assignedSlot || // DOM Element detected.
    r.parentNode || // ShadowRoot detected.
    du(r) && r.host || // Fallback.
    Qt(r)
  );
  return du(o) ? o.host : o;
}
function Lu(r) {
  const o = Zr(r);
  return Pi(o) ? r.ownerDocument ? r.ownerDocument.body : r.body : It(o) && Ln(o) ? o : Lu(o);
}
function Dn(r, o, n) {
  var l;
  o === void 0 && (o = []), n === void 0 && (n = !0);
  const s = Lu(r), c = s === ((l = r.ownerDocument) == null ? void 0 : l.body), g = lt(s);
  return c ? o.concat(g, g.visualViewport || [], Ln(s) ? s : [], g.frameElement && n ? Dn(g.frameElement) : []) : o.concat(s, Dn(s, [], n));
}
function Au(r) {
  const o = xt(r);
  let n = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0;
  const s = It(r), c = s ? r.offsetWidth : n, g = s ? r.offsetHeight : l, h = Di(n) !== c || Di(l) !== g;
  return h && (n = c, l = g), {
    width: n,
    height: l,
    $: h
  };
}
function Cs(r) {
  return Kt(r) ? r : r.contextElement;
}
function Qr(r) {
  const o = Cs(r);
  if (!It(o))
    return fr(1);
  const n = o.getBoundingClientRect(), {
    width: l,
    height: s,
    $: c
  } = Au(o);
  let g = (c ? Di(n.width) : n.width) / l, h = (c ? Di(n.height) : n.height) / s;
  return (!g || !Number.isFinite(g)) && (g = 1), (!h || !Number.isFinite(h)) && (h = 1), {
    x: g,
    y: h
  };
}
const py = /* @__PURE__ */ fr(0);
function Eu(r) {
  const o = lt(r);
  return !_s() || !o.visualViewport ? py : {
    x: o.visualViewport.offsetLeft,
    y: o.visualViewport.offsetTop
  };
}
function by(r, o, n) {
  return o === void 0 && (o = !1), !n || o && n !== lt(r) ? !1 : o;
}
function Tr(r, o, n, l) {
  o === void 0 && (o = !1), n === void 0 && (n = !1);
  const s = r.getBoundingClientRect(), c = Cs(r);
  let g = fr(1);
  o && (l ? Kt(l) && (g = Qr(l)) : g = Qr(r));
  const h = by(c, n, l) ? Eu(c) : fr(0);
  let w = (s.left + h.x) / g.x, x = (s.top + h.y) / g.y, z = s.width / g.x, O = s.height / g.y;
  if (c) {
    const R = lt(c), E = l && Kt(l) ? lt(l) : l;
    let $ = R.frameElement;
    for (; $ && l && E !== R; ) {
      const W = Qr($), F = $.getBoundingClientRect(), H = xt($), te = F.left + ($.clientLeft + parseFloat(H.paddingLeft)) * W.x, oe = F.top + ($.clientTop + parseFloat(H.paddingTop)) * W.y;
      w *= W.x, x *= W.y, z *= W.x, O *= W.y, w += te, x += oe, $ = lt($).frameElement;
    }
  }
  return Ou({
    width: z,
    height: O,
    x: w,
    y: x
  });
}
const vy = [":popover-open", ":modal"];
function Iu(r) {
  let o = !1, n = 0, l = 0;
  function s(c) {
    try {
      o = o || r.matches(c);
    } catch {
    }
  }
  if (vy.forEach((c) => {
    s(c);
  }), o) {
    const c = Du(r);
    if (c) {
      const g = c.getBoundingClientRect();
      n = g.x, l = g.y;
    }
  }
  return [o, n, l];
}
function wy(r) {
  let {
    elements: o,
    rect: n,
    offsetParent: l,
    strategy: s
  } = r;
  const c = Qt(l), [g] = o ? Iu(o.floating) : [!1];
  if (l === c || g)
    return n;
  let h = {
    scrollLeft: 0,
    scrollTop: 0
  }, w = fr(1);
  const x = fr(0), z = It(l);
  if ((z || !z && s !== "fixed") && ((Xt(l) !== "body" || Ln(c)) && (h = Wi(l)), It(l))) {
    const O = Tr(l);
    w = Qr(l), x.x = O.x + l.clientLeft, x.y = O.y + l.clientTop;
  }
  return {
    width: n.width * w.x,
    height: n.height * w.y,
    x: n.x * w.x - h.scrollLeft * w.x + x.x,
    y: n.y * w.y - h.scrollTop * w.y + x.y
  };
}
function yy(r) {
  return Array.from(r.getClientRects());
}
function Ru(r) {
  return Tr(Qt(r)).left + Wi(r).scrollLeft;
}
function xy(r) {
  const o = Qt(r), n = Wi(r), l = r.ownerDocument.body, s = Kr(o.scrollWidth, o.clientWidth, l.scrollWidth, l.clientWidth), c = Kr(o.scrollHeight, o.clientHeight, l.scrollHeight, l.clientHeight);
  let g = -n.scrollLeft + Ru(r);
  const h = -n.scrollTop;
  return xt(l).direction === "rtl" && (g += Kr(o.clientWidth, l.clientWidth) - s), {
    width: s,
    height: c,
    x: g,
    y: h
  };
}
function _y(r, o) {
  const n = lt(r), l = Qt(r), s = n.visualViewport;
  let c = l.clientWidth, g = l.clientHeight, h = 0, w = 0;
  if (s) {
    c = s.width, g = s.height;
    const x = _s();
    (!x || x && o === "fixed") && (h = s.offsetLeft, w = s.offsetTop);
  }
  return {
    width: c,
    height: g,
    x: h,
    y: w
  };
}
function Cy(r, o) {
  const n = Tr(r, !0, o === "fixed"), l = n.top + r.clientTop, s = n.left + r.clientLeft, c = It(r) ? Qr(r) : fr(1), g = r.clientWidth * c.x, h = r.clientHeight * c.y, w = s * c.x, x = l * c.y;
  return {
    width: g,
    height: h,
    x: w,
    y: x
  };
}
function gu(r, o, n) {
  let l;
  if (o === "viewport")
    l = _y(r, n);
  else if (o === "document")
    l = xy(Qt(r));
  else if (Kt(o))
    l = Cy(o, n);
  else {
    const s = Eu(r);
    l = {
      ...o,
      x: o.x - s.x,
      y: o.y - s.y
    };
  }
  return Ou(l);
}
function Pu(r, o) {
  const n = Zr(r);
  return n === o || !Kt(n) || Pi(n) ? !1 : xt(n).position === "fixed" || Pu(n, o);
}
function ky(r, o) {
  const n = o.get(r);
  if (n)
    return n;
  let l = Dn(r, [], !1).filter((h) => Kt(h) && Xt(h) !== "body"), s = null;
  const c = xt(r).position === "fixed";
  let g = c ? Zr(r) : r;
  for (; Kt(g) && !Pi(g); ) {
    const h = xt(g), w = xs(g);
    !w && h.position === "fixed" && (s = null), (c ? !w && !s : !w && h.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Ln(g) && !w && Pu(r, g)) ? l = l.filter((z) => z !== g) : s = h, g = Zr(g);
  }
  return o.set(r, l), l;
}
function My(r) {
  let {
    element: o,
    boundary: n,
    rootBoundary: l,
    strategy: s
  } = r;
  const g = [...n === "clippingAncestors" ? ky(o, this._c) : [].concat(n), l], h = g[0], w = g.reduce((x, z) => {
    const O = gu(o, z, s);
    return x.top = Kr(O.top, x.top), x.right = gs(O.right, x.right), x.bottom = gs(O.bottom, x.bottom), x.left = Kr(O.left, x.left), x;
  }, gu(o, h, s));
  return {
    width: w.right - w.left,
    height: w.bottom - w.top,
    x: w.left,
    y: w.top
  };
}
function zy(r) {
  const {
    width: o,
    height: n
  } = Au(r);
  return {
    width: o,
    height: n
  };
}
function Sy(r, o, n, l) {
  const s = It(o), c = Qt(o), g = n === "fixed", h = Tr(r, !0, g, o);
  let w = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const x = fr(0);
  if (s || !s && !g)
    if ((Xt(o) !== "body" || Ln(c)) && (w = Wi(o)), s) {
      const W = Tr(o, !0, g, o);
      x.x = W.x + o.clientLeft, x.y = W.y + o.clientTop;
    } else
      c && (x.x = Ru(c));
  let z = h.left + w.scrollLeft - x.x, O = h.top + w.scrollTop - x.y;
  const [R, E, $] = Iu(l);
  return R && (z += E, O += $, s && (z += o.clientLeft, O += o.clientTop)), {
    x: z,
    y: O,
    width: h.width,
    height: h.height
  };
}
function hu(r, o) {
  return !It(r) || xt(r).position === "fixed" ? null : o ? o(r) : r.offsetParent;
}
function Wu(r, o) {
  const n = lt(r);
  if (!It(r))
    return n;
  let l = hu(r, o);
  for (; l && my(l) && xt(l).position === "static"; )
    l = hu(l, o);
  return l && (Xt(l) === "html" || Xt(l) === "body" && xt(l).position === "static" && !xs(l)) ? n : l || Du(r) || n;
}
const Ty = async function(r) {
  const o = this.getOffsetParent || Wu, n = this.getDimensions;
  return {
    reference: Sy(r.reference, await o(r.floating), r.strategy, r.floating),
    floating: {
      x: 0,
      y: 0,
      ...await n(r.floating)
    }
  };
};
function Oy(r) {
  return xt(r).direction === "rtl";
}
const Dy = {
  convertOffsetParentRelativeRectToViewportRelativeRect: wy,
  getDocumentElement: Qt,
  getClippingRect: My,
  getOffsetParent: Wu,
  getElementRects: Ty,
  getClientRects: yy,
  getDimensions: zy,
  getScale: Qr,
  isElement: Kt,
  isRTL: Oy
};
function Ly(r, o) {
  let n = null, l;
  const s = Qt(r);
  function c() {
    var h;
    clearTimeout(l), (h = n) == null || h.disconnect(), n = null;
  }
  function g(h, w) {
    h === void 0 && (h = !1), w === void 0 && (w = 1), c();
    const {
      left: x,
      top: z,
      width: O,
      height: R
    } = r.getBoundingClientRect();
    if (h || o(), !O || !R)
      return;
    const E = Mi(z), $ = Mi(s.clientWidth - (x + O)), W = Mi(s.clientHeight - (z + R)), F = Mi(x), te = {
      rootMargin: -E + "px " + -$ + "px " + -W + "px " + -F + "px",
      threshold: Kr(0, gs(1, w)) || 1
    };
    let oe = !0;
    function ke(de) {
      const Se = de[0].intersectionRatio;
      if (Se !== w) {
        if (!oe)
          return g();
        Se ? g(!1, Se) : l = setTimeout(() => {
          g(!1, 1e-7);
        }, 100);
      }
      oe = !1;
    }
    try {
      n = new IntersectionObserver(ke, {
        ...te,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(ke, te);
    }
    n.observe(r);
  }
  return g(!0), c;
}
function Bu(r, o, n, l) {
  l === void 0 && (l = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: c = !0,
    elementResize: g = typeof ResizeObserver == "function",
    layoutShift: h = typeof IntersectionObserver == "function",
    animationFrame: w = !1
  } = l, x = Cs(r), z = s || c ? [...x ? Dn(x) : [], ...Dn(o)] : [];
  z.forEach((H) => {
    s && H.addEventListener("scroll", n, {
      passive: !0
    }), c && H.addEventListener("resize", n);
  });
  const O = x && h ? Ly(x, n) : null;
  let R = -1, E = null;
  g && (E = new ResizeObserver((H) => {
    let [te] = H;
    te && te.target === x && E && (E.unobserve(o), cancelAnimationFrame(R), R = requestAnimationFrame(() => {
      var oe;
      (oe = E) == null || oe.observe(o);
    })), n();
  }), x && !w && E.observe(x), E.observe(o));
  let $, W = w ? Tr(r) : null;
  w && F();
  function F() {
    const H = Tr(r);
    W && (H.x !== W.x || H.y !== W.y || H.width !== W.width || H.height !== W.height) && n(), W = H, $ = requestAnimationFrame(F);
  }
  return n(), () => {
    var H;
    z.forEach((te) => {
      s && te.removeEventListener("scroll", n), c && te.removeEventListener("resize", n);
    }), O == null || O(), (H = E) == null || H.disconnect(), E = null, w && cancelAnimationFrame($);
  };
}
const Ay = (r, o, n) => {
  const l = /* @__PURE__ */ new Map(), s = {
    platform: Dy,
    ...n
  }, c = {
    ...s.platform,
    _c: l
  };
  return hy(r, o, {
    ...s,
    platform: c
  });
};
function Ey(r) {
  return r != null && typeof r == "object" && "$el" in r;
}
function mu(r) {
  if (Ey(r)) {
    const o = r.$el;
    return ys(o) && Xt(o) === "#comment" ? null : o;
  }
  return r;
}
function Fu(r) {
  return typeof window > "u" ? 1 : (r.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pu(r, o) {
  const n = Fu(r);
  return Math.round(o * n) / n;
}
function Nu(r, o, n) {
  n === void 0 && (n = {});
  const l = n.whileElementsMounted, s = wt(() => {
    var J;
    return (J = tt(n.open)) != null ? J : !0;
  }), c = wt(() => tt(n.middleware)), g = wt(() => {
    var J;
    return (J = tt(n.placement)) != null ? J : "bottom";
  }), h = wt(() => {
    var J;
    return (J = tt(n.strategy)) != null ? J : "absolute";
  }), w = wt(() => {
    var J;
    return (J = tt(n.transform)) != null ? J : !0;
  }), x = wt(() => mu(r.value)), z = wt(() => mu(o.value)), O = Et(0), R = Et(0), E = Et(h.value), $ = Et(g.value), W = Lp({}), F = Et(!1), H = wt(() => {
    const J = {
      position: E.value,
      left: "0",
      top: "0"
    };
    if (!z.value)
      return J;
    const Ye = pu(z.value, O.value), Qe = pu(z.value, R.value);
    return w.value ? {
      ...J,
      transform: "translate(" + Ye + "px, " + Qe + "px)",
      ...Fu(z.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: E.value,
      left: Ye + "px",
      top: Qe + "px"
    };
  });
  let te;
  function oe() {
    x.value == null || z.value == null || Ay(x.value, z.value, {
      middleware: c.value,
      placement: g.value,
      strategy: h.value
    }).then((J) => {
      O.value = J.x, R.value = J.y, E.value = J.strategy, $.value = J.placement, W.value = J.middlewareData, F.value = !0;
    });
  }
  function ke() {
    typeof te == "function" && (te(), te = void 0);
  }
  function de() {
    if (ke(), l === void 0) {
      oe();
      return;
    }
    if (x.value != null && z.value != null) {
      te = l(x.value, z.value, oe);
      return;
    }
  }
  function Se() {
    s.value || (F.value = !1);
  }
  return ss([c, g, h], oe, {
    flush: "sync"
  }), ss([x, z], de, {
    flush: "sync"
  }), ss(s, Se, {
    flush: "sync"
  }), Ap() && Ep(ke), {
    x: qr(O),
    y: qr(R),
    strategy: qr(E),
    placement: qr($),
    middlewareData: qr(W),
    isPositioned: qr(F),
    floatingStyles: H,
    update: oe
  };
}
const Iy = {
  beforeMount(r, o) {
    let n = !1;
    r.clickStarted = (l) => {
      r.contains(l.target) && (n = !0);
    }, r.clickOutsideHandler = (l) => {
      !r.contains(l.target) && o.value && !n && o.value(l), n = !1;
    }, document.addEventListener("mousedown", r.clickStarted), document.addEventListener("mouseup", r.clickOutsideHandler);
  },
  unmounted(r) {
    document.removeEventListener("mouseup", r.clickOutsideHandler), document.removeEventListener("mousedown", r.clickOutsideHandler);
  }
};
const Ry = {
  __name: "dropdown",
  props: {
    modelValue: {
      type: Boolean
    },
    size: {
      type: String
    },
    color: {
      type: String,
      default: "gray"
    },
    placement: {
      type: String,
      default: "bottom-start"
    }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: o }) {
    const n = o, l = r, s = Et(null), c = Et(null), { floatingStyles: g } = Nu(
      s,
      c,
      {
        placement: l.placement,
        whileElementsMounted: Bu
      }
    ), h = wt(() => {
      var z;
      const x = (z = l.color) == null ? void 0 : z.toLowerCase();
      return {
        blue: "rounded-lg bg-sky-300 text-zinc-900",
        red: "rounded-lg bg-red-300 text-zinc-900",
        yellow: "rounded-lg bg-yellow-300 text-zinc-900",
        green: "rounded-lg bg-green-300 text-zinc-900",
        gray: "rounded-lg bg-gray-300 text-zinc-900 dark:bg-gray-600 dark:text-zinc-50",
        white: "rounded-lg bg-zinc-50 text-zinc-900 dark:bg-zinc-100 dark:text-zinc-900",
        black: "rounded-lg bg-zinc-900 text-zinc-50 dark:bg-zinc-800 dark:text-zinc-50"
      }[x];
    }), w = wt(() => {
      var z;
      switch ((z = l.size) == null ? void 0 : z.toLowerCase()) {
        case "small":
          return "p-1 min-w-[250px] leading-3 text-base";
        case "large":
          return "p-5 min-w-[250px] leading-7 text-xl";
        default:
          return "p-3 min-w-[250px] leading-5 text-lg";
      }
    });
    return (x, z) => zi((T(), L("div", {
      class: y(tt(fe)(x.$attrs["container-class"]))
    }, [
      D("div", {
        ref_key: "reference",
        ref: s,
        class: y(tt(fe)(x.$attrs["trigger-container-class"]))
      }, [
        K(x.$slots, "trigger")
      ], 2),
      ze(hs, { name: "dropToBottom" }, {
        default: De(() => [
          zi(D("div", {
            ref_key: "floating",
            ref: c,
            class: y(tt(fe)(
              "flex flex-col items-center overflow-hidden font-semibold shadow-lg             rounded-lg z-40 mt-2",
              h.value,
              w.value,
              x.$attrs["content-class"]
            )),
            style: On(tt(g))
          }, [
            K(x.$slots, "default")
          ], 6), [
            [ms, r.modelValue]
          ])
        ]),
        _: 3
      })
    ], 2)), [
      [tt(Iy), () => {
        l.modelValue && n("update:modelValue", !1);
      }]
    ]);
  }
};
const Py = {
  __name: "tooltip",
  props: {
    size: {
      type: String
    },
    color: {
      type: String,
      default: "gray"
    },
    placement: {
      type: String,
      default: "bottom-start"
    }
  },
  setup(r) {
    const o = r, n = Et(!1), l = Et(null), s = Et(null), { floatingStyles: c } = Nu(
      l,
      s,
      {
        placement: o.placement,
        whileElementsMounted: Bu
      }
    ), g = wt(() => {
      var x;
      const w = (x = o.color) == null ? void 0 : x.toLowerCase();
      return {
        blue: "rounded-lg bg-sky-300 text-zinc-900",
        red: "rounded-lg bg-red-300 text-zinc-900",
        yellow: "rounded-lg bg-yellow-300 text-zinc-900",
        green: "rounded-lg bg-green-300 text-zinc-900",
        gray: "rounded-lg bg-gray-300 text-zinc-900 dark:bg-gray-600 dark:text-zinc-50",
        white: "rounded-lg bg-zinc-50 text-zinc-900 dark:bg-zinc-100 dark:text-zinc-900",
        black: "rounded-lg bg-zinc-900 text-zinc-50 dark:bg-zinc-800 dark:text-zinc-50"
      }[w];
    }), h = wt(() => {
      var x;
      switch ((x = o.size) == null ? void 0 : x.toLowerCase()) {
        case "small":
          return "p-1 leading-3 text-base";
        case "large":
          return "p-5 leading-7 text-xl";
        default:
          return "p-3 leading-5 text-lg";
      }
    });
    return (w, x) => (T(), L("div", {
      class: y(tt(fe)(
        "inline-block",
        w.$attrs["container-class"]
      ))
    }, [
      D("div", {
        ref_key: "reference",
        ref: l,
        class: y(tt(fe)(
          "flex flex-col",
          w.$attrs["target-class"]
        )),
        onMouseenter: x[0] || (x[0] = (z) => n.value = !0),
        onMouseleave: x[1] || (x[1] = (z) => n.value = !1)
      }, [
        K(w.$slots, "default")
      ], 34),
      ze(hs, { name: "dropToBottom" }, {
        default: De(() => [
          zi(D("div", {
            ref_key: "floating",
            ref: s,
            class: y(tt(fe)(
              "flex flex-col items-start overflow-hidden font-semibold shadow-lg             rounded-lg z-40 mt-2",
              g.value,
              h.value,
              w.$attrs["content-class"]
            )),
            style: On(tt(c))
          }, [
            K(w.$slots, "content")
          ], 6), [
            [ms, n.value]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
}, Wy = {
  name: "ButtonComponent",
  props: {
    icon: {
      type: String
    },
    size: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    alertColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return {
        blue: "bg-sky-300 text-zinc-950",
        red: "bg-red-300 text-zinc-950",
        yellow: "bg-yellow-300 text-zinc-950",
        green: "bg-green-300 text-zinc-950",
        gray: "bg-gray-300 text-zinc-950 dark:bg-gray-600 dark:text-zinc-50",
        black: "bg-zinc-900 text-zinc-50"
      }[r];
    },
    alertSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "leading-3 text-xl";
        case "large":
          return "leading-7 text-3xl";
        default:
          return "leading-5 text-2xl";
      }
    }
  }
};
function By(r, o, n, l, s, c) {
  const g = Ie("fs-icon");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-row items-center rounded-lg p-4 font-semibold text-lg",
      c.alertColorClass,
      c.alertSizeClass,
      r.$attrs["container-class"]
    ))
  }, [
    n.icon ? (T(), _e(g, {
      key: 0,
      name: n.icon,
      class: y(s.twMerge(
        "mr-2",
        r.$attrs["icon-class"]
      ))
    }, null, 8, ["name", "class"])) : me("", !0),
    K(r.$slots, "default")
  ], 2);
}
const Fy = /* @__PURE__ */ we(Wy, [["render", By]]), Ny = {
  name: "SegmentComponent",
  inheritAttrs: !1,
  props: {
    modelValue: {
      type: String
    },
    options: {
      type: Array
    },
    size: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    id() {
      return Math.random();
    },
    segmentColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return this.disabled ? "bg-gray-300 text-zinc-600 cursor-not-allowed" : {
        blue: "bg-sky-300 text-zinc-900",
        red: "bg-red-300 text-zinc-900",
        yellow: "bg-yellow-300 text-zinc-900",
        green: "bg-green-300 text-zinc-900",
        gray: "bg-gray-300 text-zinc-900 dark:bg-gray-600 dark:text-zinc-50",
        black: "bg-zinc-900 dark:bg-zinc-800 text-zinc-50"
      }[r];
    },
    segmentSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "min-h-[56px] max-h-[56px]";
        case "large":
          return "min-h-[72px] max-h-[72px]";
        default:
          return "min-h-[64px] max-h-[64px]";
      }
    }
  },
  methods: {
    segmentItemClass(r) {
      var s, c;
      const o = (s = this.color) == null ? void 0 : s.toLowerCase(), n = (c = this.size) == null ? void 0 : c.toLowerCase();
      let l = "";
      switch (this.modelValue === r && (this.disabled ? l += "!bg-gray-400 dark:!bg-gray-500 text-zinc-50" : l += {
        blue: "!bg-sky-500",
        red: "!bg-red-500",
        yellow: "!bg-yellow-500",
        green: "!bg-green-500",
        gray: "!bg-gray-500 dark:!bg-gray-800 text-zinc-50",
        black: "!bg-zinc-600 dark:!bg-zinc-600"
      }[o], l += " shadow-lg"), this.disabled ? l += " cursor-not-allowed" : this.modelValue !== r && (l += {
        blue: "hover:bg-sky-400",
        red: "hover:bg-red-400",
        yellow: "hover:bg-yellow-400",
        green: "hover:bg-green-400",
        gray: "hover:bg-gray-400 dark:hover:bg-gray-700",
        black: "hover:bg-zinc-700 dark:hover:bg-zinc-700"
      }[o], l += " hover:shadow-lg cursor-pointer"), l += " ", n) {
        case "small":
          l += "p-1 leading-3 text-base h-10";
          break;
        case "large":
          l += "p-5 leading-7 text-xl h-14";
          break;
        default:
          l += "p-3 leading-5 text-lg h-12";
          break;
      }
      return l;
    }
  }
}, Uy = ["onClick"], $y = ["disabled", "name", "value"];
function Hy(r, o, n, l, s, c) {
  return T(), L("div", {
    class: y(s.twMerge(
      "rounded-lg overflow-x-scroll hide-scrollbar p-2 flex flex-row font-semibold max-w-min",
      c.segmentColorClass,
      c.segmentSizeClass,
      r.$attrs.class
    ))
  }, [
    (T(!0), L(ne, null, Ne(n.options, (g) => (T(), L("label", {
      onClick: () => {
        n.disabled || r.$emit("update:modelValue", g);
      },
      class: y(s.twMerge(
        "flex last:mr-0 flex-row items-center mr-2 rounded-md                     transition-all ease-in-out duration-300 px-3 text-center                     relative select-none min-w-max",
        c.segmentItemClass(g),
        r.$attrs["item-class"]
      ))
    }, [
      D("input", {
        class: "hidden",
        type: "radio",
        disabled: n.disabled,
        name: c.id,
        value: n.modelValue
      }, null, 8, $y),
      r.$slots.option ? K(r.$slots, "option", { key: g }) : (T(), L(ne, { key: 1 }, [
        xe(G(g), 1)
      ], 64))
    ], 10, Uy))), 256))
  ], 2);
}
const Yy = /* @__PURE__ */ we(Ny, [["render", Hy]]);
var Sn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vy(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Li = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Li.exports;
(function(r, o) {
  (function() {
    var n, l = "4.17.21", s = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", g = "Expected a function", h = "Invalid `variable` option passed into `_.template`", w = "__lodash_hash_undefined__", x = 500, z = "__lodash_placeholder__", O = 1, R = 2, E = 4, $ = 1, W = 2, F = 1, H = 2, te = 4, oe = 8, ke = 16, de = 32, Se = 64, J = 128, Ye = 256, Qe = 512, Tt = 30, dr = "...", ge = 800, Or = 16, Rt = 1, Re = 2, Ve = 3, Ge = 1 / 0, ct = 9007199254740991, gr = 17976931348623157e292, hr = 0 / 0, Ue = 4294967295, Dr = Ue - 1, $u = Ue >>> 1, Hu = [
      ["ary", J],
      ["bind", F],
      ["bindKey", H],
      ["curry", oe],
      ["curryRight", ke],
      ["flip", Qe],
      ["partial", de],
      ["partialRight", Se],
      ["rearg", Ye]
    ], Lr = "[object Arguments]", An = "[object Array]", Yu = "[object AsyncFunction]", en = "[object Boolean]", tn = "[object Date]", Vu = "[object DOMException]", En = "[object Error]", In = "[object Function]", ks = "[object GeneratorFunction]", _t = "[object Map]", rn = "[object Number]", Gu = "[object Null]", Pt = "[object Object]", Ms = "[object Promise]", qu = "[object Proxy]", nn = "[object RegExp]", Ct = "[object Set]", on = "[object String]", Rn = "[object Symbol]", Xu = "[object Undefined]", sn = "[object WeakMap]", Ku = "[object WeakSet]", an = "[object ArrayBuffer]", Ar = "[object DataView]", Bi = "[object Float32Array]", Fi = "[object Float64Array]", Ni = "[object Int8Array]", Ui = "[object Int16Array]", $i = "[object Int32Array]", Hi = "[object Uint8Array]", Yi = "[object Uint8ClampedArray]", Vi = "[object Uint16Array]", Gi = "[object Uint32Array]", Qu = /\b__p \+= '';/g, Ju = /\b(__p \+=) '' \+/g, Zu = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zs = /&(?:amp|lt|gt|quot|#39);/g, Ss = /[&<>"']/g, ju = RegExp(zs.source), ec = RegExp(Ss.source), tc = /<%-([\s\S]+?)%>/g, rc = /<%([\s\S]+?)%>/g, Ts = /<%=([\s\S]+?)%>/g, nc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ic = /^\w*$/, oc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qi = /[\\^$.*+?()[\]{}|]/g, sc = RegExp(qi.source), Xi = /^\s+/, ac = /\s/, lc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, uc = /\{\n\/\* \[wrapped with (.+)\] \*/, cc = /,? & /, fc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, dc = /[()=,{}\[\]\/\s]/, gc = /\\(\\)?/g, hc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Os = /\w*$/, mc = /^[-+]0x[0-9a-f]+$/i, pc = /^0b[01]+$/i, bc = /^\[object .+?Constructor\]$/, vc = /^0o[0-7]+$/i, wc = /^(?:0|[1-9]\d*)$/, yc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pn = /($^)/, xc = /['\n\r\u2028\u2029\\]/g, Wn = "\\ud800-\\udfff", _c = "\\u0300-\\u036f", Cc = "\\ufe20-\\ufe2f", kc = "\\u20d0-\\u20ff", Ds = _c + Cc + kc, Ls = "\\u2700-\\u27bf", As = "a-z\\xdf-\\xf6\\xf8-\\xff", Mc = "\\xac\\xb1\\xd7\\xf7", zc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Sc = "\\u2000-\\u206f", Tc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Es = "A-Z\\xc0-\\xd6\\xd8-\\xde", Is = "\\ufe0e\\ufe0f", Rs = Mc + zc + Sc + Tc, Ki = "['’]", Oc = "[" + Wn + "]", Ps = "[" + Rs + "]", Bn = "[" + Ds + "]", Ws = "\\d+", Dc = "[" + Ls + "]", Bs = "[" + As + "]", Fs = "[^" + Wn + Rs + Ws + Ls + As + Es + "]", Qi = "\\ud83c[\\udffb-\\udfff]", Lc = "(?:" + Bn + "|" + Qi + ")", Ns = "[^" + Wn + "]", Ji = "(?:\\ud83c[\\udde6-\\uddff]){2}", Zi = "[\\ud800-\\udbff][\\udc00-\\udfff]", Er = "[" + Es + "]", Us = "\\u200d", $s = "(?:" + Bs + "|" + Fs + ")", Ac = "(?:" + Er + "|" + Fs + ")", Hs = "(?:" + Ki + "(?:d|ll|m|re|s|t|ve))?", Ys = "(?:" + Ki + "(?:D|LL|M|RE|S|T|VE))?", Vs = Lc + "?", Gs = "[" + Is + "]?", Ec = "(?:" + Us + "(?:" + [Ns, Ji, Zi].join("|") + ")" + Gs + Vs + ")*", Ic = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Rc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", qs = Gs + Vs + Ec, Pc = "(?:" + [Dc, Ji, Zi].join("|") + ")" + qs, Wc = "(?:" + [Ns + Bn + "?", Bn, Ji, Zi, Oc].join("|") + ")", Bc = RegExp(Ki, "g"), Fc = RegExp(Bn, "g"), ji = RegExp(Qi + "(?=" + Qi + ")|" + Wc + qs, "g"), Nc = RegExp([
      Er + "?" + Bs + "+" + Hs + "(?=" + [Ps, Er, "$"].join("|") + ")",
      Ac + "+" + Ys + "(?=" + [Ps, Er + $s, "$"].join("|") + ")",
      Er + "?" + $s + "+" + Hs,
      Er + "+" + Ys,
      Rc,
      Ic,
      Ws,
      Pc
    ].join("|"), "g"), Uc = RegExp("[" + Us + Wn + Ds + Is + "]"), $c = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Hc = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Yc = -1, be = {};
    be[Bi] = be[Fi] = be[Ni] = be[Ui] = be[$i] = be[Hi] = be[Yi] = be[Vi] = be[Gi] = !0, be[Lr] = be[An] = be[an] = be[en] = be[Ar] = be[tn] = be[En] = be[In] = be[_t] = be[rn] = be[Pt] = be[nn] = be[Ct] = be[on] = be[sn] = !1;
    var pe = {};
    pe[Lr] = pe[An] = pe[an] = pe[Ar] = pe[en] = pe[tn] = pe[Bi] = pe[Fi] = pe[Ni] = pe[Ui] = pe[$i] = pe[_t] = pe[rn] = pe[Pt] = pe[nn] = pe[Ct] = pe[on] = pe[Rn] = pe[Hi] = pe[Yi] = pe[Vi] = pe[Gi] = !0, pe[En] = pe[In] = pe[sn] = !1;
    var Vc = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Gc = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, qc = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Xc = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Kc = parseFloat, Qc = parseInt, Xs = typeof Sn == "object" && Sn && Sn.Object === Object && Sn, Jc = typeof self == "object" && self && self.Object === Object && self, Be = Xs || Jc || Function("return this")(), eo = o && !o.nodeType && o, mr = eo && !0 && r && !r.nodeType && r, Ks = mr && mr.exports === eo, to = Ks && Xs.process, ft = function() {
      try {
        var b = mr && mr.require && mr.require("util").types;
        return b || to && to.binding && to.binding("util");
      } catch {
      }
    }(), Qs = ft && ft.isArrayBuffer, Js = ft && ft.isDate, Zs = ft && ft.isMap, js = ft && ft.isRegExp, ea = ft && ft.isSet, ta = ft && ft.isTypedArray;
    function rt(b, C, _) {
      switch (_.length) {
        case 0:
          return b.call(C);
        case 1:
          return b.call(C, _[0]);
        case 2:
          return b.call(C, _[0], _[1]);
        case 3:
          return b.call(C, _[0], _[1], _[2]);
      }
      return b.apply(C, _);
    }
    function Zc(b, C, _, I) {
      for (var Y = -1, se = b == null ? 0 : b.length; ++Y < se; ) {
        var Ae = b[Y];
        C(I, Ae, _(Ae), b);
      }
      return I;
    }
    function dt(b, C) {
      for (var _ = -1, I = b == null ? 0 : b.length; ++_ < I && C(b[_], _, b) !== !1; )
        ;
      return b;
    }
    function jc(b, C) {
      for (var _ = b == null ? 0 : b.length; _-- && C(b[_], _, b) !== !1; )
        ;
      return b;
    }
    function ra(b, C) {
      for (var _ = -1, I = b == null ? 0 : b.length; ++_ < I; )
        if (!C(b[_], _, b))
          return !1;
      return !0;
    }
    function Jt(b, C) {
      for (var _ = -1, I = b == null ? 0 : b.length, Y = 0, se = []; ++_ < I; ) {
        var Ae = b[_];
        C(Ae, _, b) && (se[Y++] = Ae);
      }
      return se;
    }
    function Fn(b, C) {
      var _ = b == null ? 0 : b.length;
      return !!_ && Ir(b, C, 0) > -1;
    }
    function ro(b, C, _) {
      for (var I = -1, Y = b == null ? 0 : b.length; ++I < Y; )
        if (_(C, b[I]))
          return !0;
      return !1;
    }
    function ye(b, C) {
      for (var _ = -1, I = b == null ? 0 : b.length, Y = Array(I); ++_ < I; )
        Y[_] = C(b[_], _, b);
      return Y;
    }
    function Zt(b, C) {
      for (var _ = -1, I = C.length, Y = b.length; ++_ < I; )
        b[Y + _] = C[_];
      return b;
    }
    function no(b, C, _, I) {
      var Y = -1, se = b == null ? 0 : b.length;
      for (I && se && (_ = b[++Y]); ++Y < se; )
        _ = C(_, b[Y], Y, b);
      return _;
    }
    function ef(b, C, _, I) {
      var Y = b == null ? 0 : b.length;
      for (I && Y && (_ = b[--Y]); Y--; )
        _ = C(_, b[Y], Y, b);
      return _;
    }
    function io(b, C) {
      for (var _ = -1, I = b == null ? 0 : b.length; ++_ < I; )
        if (C(b[_], _, b))
          return !0;
      return !1;
    }
    var tf = oo("length");
    function rf(b) {
      return b.split("");
    }
    function nf(b) {
      return b.match(fc) || [];
    }
    function na(b, C, _) {
      var I;
      return _(b, function(Y, se, Ae) {
        if (C(Y, se, Ae))
          return I = se, !1;
      }), I;
    }
    function Nn(b, C, _, I) {
      for (var Y = b.length, se = _ + (I ? 1 : -1); I ? se-- : ++se < Y; )
        if (C(b[se], se, b))
          return se;
      return -1;
    }
    function Ir(b, C, _) {
      return C === C ? pf(b, C, _) : Nn(b, ia, _);
    }
    function of(b, C, _, I) {
      for (var Y = _ - 1, se = b.length; ++Y < se; )
        if (I(b[Y], C))
          return Y;
      return -1;
    }
    function ia(b) {
      return b !== b;
    }
    function oa(b, C) {
      var _ = b == null ? 0 : b.length;
      return _ ? ao(b, C) / _ : hr;
    }
    function oo(b) {
      return function(C) {
        return C == null ? n : C[b];
      };
    }
    function so(b) {
      return function(C) {
        return b == null ? n : b[C];
      };
    }
    function sa(b, C, _, I, Y) {
      return Y(b, function(se, Ae, he) {
        _ = I ? (I = !1, se) : C(_, se, Ae, he);
      }), _;
    }
    function sf(b, C) {
      var _ = b.length;
      for (b.sort(C); _--; )
        b[_] = b[_].value;
      return b;
    }
    function ao(b, C) {
      for (var _, I = -1, Y = b.length; ++I < Y; ) {
        var se = C(b[I]);
        se !== n && (_ = _ === n ? se : _ + se);
      }
      return _;
    }
    function lo(b, C) {
      for (var _ = -1, I = Array(b); ++_ < b; )
        I[_] = C(_);
      return I;
    }
    function af(b, C) {
      return ye(C, function(_) {
        return [_, b[_]];
      });
    }
    function aa(b) {
      return b && b.slice(0, fa(b) + 1).replace(Xi, "");
    }
    function nt(b) {
      return function(C) {
        return b(C);
      };
    }
    function uo(b, C) {
      return ye(C, function(_) {
        return b[_];
      });
    }
    function ln(b, C) {
      return b.has(C);
    }
    function la(b, C) {
      for (var _ = -1, I = b.length; ++_ < I && Ir(C, b[_], 0) > -1; )
        ;
      return _;
    }
    function ua(b, C) {
      for (var _ = b.length; _-- && Ir(C, b[_], 0) > -1; )
        ;
      return _;
    }
    function lf(b, C) {
      for (var _ = b.length, I = 0; _--; )
        b[_] === C && ++I;
      return I;
    }
    var uf = so(Vc), cf = so(Gc);
    function ff(b) {
      return "\\" + Xc[b];
    }
    function df(b, C) {
      return b == null ? n : b[C];
    }
    function Rr(b) {
      return Uc.test(b);
    }
    function gf(b) {
      return $c.test(b);
    }
    function hf(b) {
      for (var C, _ = []; !(C = b.next()).done; )
        _.push(C.value);
      return _;
    }
    function co(b) {
      var C = -1, _ = Array(b.size);
      return b.forEach(function(I, Y) {
        _[++C] = [Y, I];
      }), _;
    }
    function ca(b, C) {
      return function(_) {
        return b(C(_));
      };
    }
    function jt(b, C) {
      for (var _ = -1, I = b.length, Y = 0, se = []; ++_ < I; ) {
        var Ae = b[_];
        (Ae === C || Ae === z) && (b[_] = z, se[Y++] = _);
      }
      return se;
    }
    function Un(b) {
      var C = -1, _ = Array(b.size);
      return b.forEach(function(I) {
        _[++C] = I;
      }), _;
    }
    function mf(b) {
      var C = -1, _ = Array(b.size);
      return b.forEach(function(I) {
        _[++C] = [I, I];
      }), _;
    }
    function pf(b, C, _) {
      for (var I = _ - 1, Y = b.length; ++I < Y; )
        if (b[I] === C)
          return I;
      return -1;
    }
    function bf(b, C, _) {
      for (var I = _ + 1; I--; )
        if (b[I] === C)
          return I;
      return I;
    }
    function Pr(b) {
      return Rr(b) ? wf(b) : tf(b);
    }
    function kt(b) {
      return Rr(b) ? yf(b) : rf(b);
    }
    function fa(b) {
      for (var C = b.length; C-- && ac.test(b.charAt(C)); )
        ;
      return C;
    }
    var vf = so(qc);
    function wf(b) {
      for (var C = ji.lastIndex = 0; ji.test(b); )
        ++C;
      return C;
    }
    function yf(b) {
      return b.match(ji) || [];
    }
    function xf(b) {
      return b.match(Nc) || [];
    }
    var _f = function b(C) {
      C = C == null ? Be : Wr.defaults(Be.Object(), C, Wr.pick(Be, Hc));
      var _ = C.Array, I = C.Date, Y = C.Error, se = C.Function, Ae = C.Math, he = C.Object, fo = C.RegExp, Cf = C.String, gt = C.TypeError, $n = _.prototype, kf = se.prototype, Br = he.prototype, Hn = C["__core-js_shared__"], Yn = kf.toString, ue = Br.hasOwnProperty, Mf = 0, da = function() {
        var e = /[^.]+$/.exec(Hn && Hn.keys && Hn.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), Vn = Br.toString, zf = Yn.call(he), Sf = Be._, Tf = fo(
        "^" + Yn.call(ue).replace(qi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Gn = Ks ? C.Buffer : n, er = C.Symbol, qn = C.Uint8Array, ga = Gn ? Gn.allocUnsafe : n, Xn = ca(he.getPrototypeOf, he), ha = he.create, ma = Br.propertyIsEnumerable, Kn = $n.splice, pa = er ? er.isConcatSpreadable : n, un = er ? er.iterator : n, pr = er ? er.toStringTag : n, Qn = function() {
        try {
          var e = xr(he, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), Of = C.clearTimeout !== Be.clearTimeout && C.clearTimeout, Df = I && I.now !== Be.Date.now && I.now, Lf = C.setTimeout !== Be.setTimeout && C.setTimeout, Jn = Ae.ceil, Zn = Ae.floor, go = he.getOwnPropertySymbols, Af = Gn ? Gn.isBuffer : n, ba = C.isFinite, Ef = $n.join, If = ca(he.keys, he), Ee = Ae.max, $e = Ae.min, Rf = I.now, Pf = C.parseInt, va = Ae.random, Wf = $n.reverse, ho = xr(C, "DataView"), cn = xr(C, "Map"), mo = xr(C, "Promise"), Fr = xr(C, "Set"), fn = xr(C, "WeakMap"), dn = xr(he, "create"), jn = fn && new fn(), Nr = {}, Bf = _r(ho), Ff = _r(cn), Nf = _r(mo), Uf = _r(Fr), $f = _r(fn), ei = er ? er.prototype : n, gn = ei ? ei.valueOf : n, wa = ei ? ei.toString : n;
      function f(e) {
        if (Me(e) && !V(e) && !(e instanceof ee)) {
          if (e instanceof ht)
            return e;
          if (ue.call(e, "__wrapped__"))
            return yl(e);
        }
        return new ht(e);
      }
      var Ur = function() {
        function e() {
        }
        return function(t) {
          if (!Ce(t))
            return {};
          if (ha)
            return ha(t);
          e.prototype = t;
          var i = new e();
          return e.prototype = n, i;
        };
      }();
      function ti() {
      }
      function ht(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
      }
      f.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: tc,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: rc,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ts,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: f
        }
      }, f.prototype = ti.prototype, f.prototype.constructor = f, ht.prototype = Ur(ti.prototype), ht.prototype.constructor = ht;
      function ee(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ue, this.__views__ = [];
      }
      function Hf() {
        var e = new ee(this.__wrapped__);
        return e.__actions__ = Je(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Je(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Je(this.__views__), e;
      }
      function Yf() {
        if (this.__filtered__) {
          var e = new ee(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function Vf() {
        var e = this.__wrapped__.value(), t = this.__dir__, i = V(e), a = t < 0, u = i ? e.length : 0, d = ng(0, u, this.__views__), m = d.start, p = d.end, v = p - m, k = a ? p : m - 1, M = this.__iteratees__, S = M.length, A = 0, P = $e(v, this.__takeCount__);
        if (!i || !a && u == v && P == v)
          return Ha(e, this.__actions__);
        var N = [];
        e:
          for (; v-- && A < P; ) {
            k += t;
            for (var Q = -1, U = e[k]; ++Q < S; ) {
              var j = M[Q], re = j.iteratee, st = j.type, Ke = re(U);
              if (st == Re)
                U = Ke;
              else if (!Ke) {
                if (st == Rt)
                  continue e;
                break e;
              }
            }
            N[A++] = U;
          }
        return N;
      }
      ee.prototype = Ur(ti.prototype), ee.prototype.constructor = ee;
      function br(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function Gf() {
        this.__data__ = dn ? dn(null) : {}, this.size = 0;
      }
      function qf(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function Xf(e) {
        var t = this.__data__;
        if (dn) {
          var i = t[e];
          return i === w ? n : i;
        }
        return ue.call(t, e) ? t[e] : n;
      }
      function Kf(e) {
        var t = this.__data__;
        return dn ? t[e] !== n : ue.call(t, e);
      }
      function Qf(e, t) {
        var i = this.__data__;
        return this.size += this.has(e) ? 0 : 1, i[e] = dn && t === n ? w : t, this;
      }
      br.prototype.clear = Gf, br.prototype.delete = qf, br.prototype.get = Xf, br.prototype.has = Kf, br.prototype.set = Qf;
      function Wt(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function Jf() {
        this.__data__ = [], this.size = 0;
      }
      function Zf(e) {
        var t = this.__data__, i = ri(t, e);
        if (i < 0)
          return !1;
        var a = t.length - 1;
        return i == a ? t.pop() : Kn.call(t, i, 1), --this.size, !0;
      }
      function jf(e) {
        var t = this.__data__, i = ri(t, e);
        return i < 0 ? n : t[i][1];
      }
      function ed(e) {
        return ri(this.__data__, e) > -1;
      }
      function td(e, t) {
        var i = this.__data__, a = ri(i, e);
        return a < 0 ? (++this.size, i.push([e, t])) : i[a][1] = t, this;
      }
      Wt.prototype.clear = Jf, Wt.prototype.delete = Zf, Wt.prototype.get = jf, Wt.prototype.has = ed, Wt.prototype.set = td;
      function Bt(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function rd() {
        this.size = 0, this.__data__ = {
          hash: new br(),
          map: new (cn || Wt)(),
          string: new br()
        };
      }
      function nd(e) {
        var t = hi(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function id(e) {
        return hi(this, e).get(e);
      }
      function od(e) {
        return hi(this, e).has(e);
      }
      function sd(e, t) {
        var i = hi(this, e), a = i.size;
        return i.set(e, t), this.size += i.size == a ? 0 : 1, this;
      }
      Bt.prototype.clear = rd, Bt.prototype.delete = nd, Bt.prototype.get = id, Bt.prototype.has = od, Bt.prototype.set = sd;
      function vr(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.__data__ = new Bt(); ++t < i; )
          this.add(e[t]);
      }
      function ad(e) {
        return this.__data__.set(e, w), this;
      }
      function ld(e) {
        return this.__data__.has(e);
      }
      vr.prototype.add = vr.prototype.push = ad, vr.prototype.has = ld;
      function Mt(e) {
        var t = this.__data__ = new Wt(e);
        this.size = t.size;
      }
      function ud() {
        this.__data__ = new Wt(), this.size = 0;
      }
      function cd(e) {
        var t = this.__data__, i = t.delete(e);
        return this.size = t.size, i;
      }
      function fd(e) {
        return this.__data__.get(e);
      }
      function dd(e) {
        return this.__data__.has(e);
      }
      function gd(e, t) {
        var i = this.__data__;
        if (i instanceof Wt) {
          var a = i.__data__;
          if (!cn || a.length < s - 1)
            return a.push([e, t]), this.size = ++i.size, this;
          i = this.__data__ = new Bt(a);
        }
        return i.set(e, t), this.size = i.size, this;
      }
      Mt.prototype.clear = ud, Mt.prototype.delete = cd, Mt.prototype.get = fd, Mt.prototype.has = dd, Mt.prototype.set = gd;
      function ya(e, t) {
        var i = V(e), a = !i && Cr(e), u = !i && !a && or(e), d = !i && !a && !u && Vr(e), m = i || a || u || d, p = m ? lo(e.length, Cf) : [], v = p.length;
        for (var k in e)
          (t || ue.call(e, k)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
          (k == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          u && (k == "offset" || k == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          d && (k == "buffer" || k == "byteLength" || k == "byteOffset") || // Skip index properties.
          $t(k, v))) && p.push(k);
        return p;
      }
      function xa(e) {
        var t = e.length;
        return t ? e[zo(0, t - 1)] : n;
      }
      function hd(e, t) {
        return mi(Je(e), wr(t, 0, e.length));
      }
      function md(e) {
        return mi(Je(e));
      }
      function po(e, t, i) {
        (i !== n && !zt(e[t], i) || i === n && !(t in e)) && Ft(e, t, i);
      }
      function hn(e, t, i) {
        var a = e[t];
        (!(ue.call(e, t) && zt(a, i)) || i === n && !(t in e)) && Ft(e, t, i);
      }
      function ri(e, t) {
        for (var i = e.length; i--; )
          if (zt(e[i][0], t))
            return i;
        return -1;
      }
      function pd(e, t, i, a) {
        return tr(e, function(u, d, m) {
          t(a, u, i(u), m);
        }), a;
      }
      function _a(e, t) {
        return e && Dt(t, Pe(t), e);
      }
      function bd(e, t) {
        return e && Dt(t, je(t), e);
      }
      function Ft(e, t, i) {
        t == "__proto__" && Qn ? Qn(e, t, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : e[t] = i;
      }
      function bo(e, t) {
        for (var i = -1, a = t.length, u = _(a), d = e == null; ++i < a; )
          u[i] = d ? n : Jo(e, t[i]);
        return u;
      }
      function wr(e, t, i) {
        return e === e && (i !== n && (e = e <= i ? e : i), t !== n && (e = e >= t ? e : t)), e;
      }
      function mt(e, t, i, a, u, d) {
        var m, p = t & O, v = t & R, k = t & E;
        if (i && (m = u ? i(e, a, u, d) : i(e)), m !== n)
          return m;
        if (!Ce(e))
          return e;
        var M = V(e);
        if (M) {
          if (m = og(e), !p)
            return Je(e, m);
        } else {
          var S = He(e), A = S == In || S == ks;
          if (or(e))
            return Ga(e, p);
          if (S == Pt || S == Lr || A && !u) {
            if (m = v || A ? {} : fl(e), !p)
              return v ? Xd(e, bd(m, e)) : qd(e, _a(m, e));
          } else {
            if (!pe[S])
              return u ? e : {};
            m = sg(e, S, p);
          }
        }
        d || (d = new Mt());
        var P = d.get(e);
        if (P)
          return P;
        d.set(e, m), Nl(e) ? e.forEach(function(U) {
          m.add(mt(U, t, i, U, e, d));
        }) : Bl(e) && e.forEach(function(U, j) {
          m.set(j, mt(U, t, i, j, e, d));
        });
        var N = k ? v ? Wo : Po : v ? je : Pe, Q = M ? n : N(e);
        return dt(Q || e, function(U, j) {
          Q && (j = U, U = e[j]), hn(m, j, mt(U, t, i, j, e, d));
        }), m;
      }
      function vd(e) {
        var t = Pe(e);
        return function(i) {
          return Ca(i, e, t);
        };
      }
      function Ca(e, t, i) {
        var a = i.length;
        if (e == null)
          return !a;
        for (e = he(e); a--; ) {
          var u = i[a], d = t[u], m = e[u];
          if (m === n && !(u in e) || !d(m))
            return !1;
        }
        return !0;
      }
      function ka(e, t, i) {
        if (typeof e != "function")
          throw new gt(g);
        return xn(function() {
          e.apply(n, i);
        }, t);
      }
      function mn(e, t, i, a) {
        var u = -1, d = Fn, m = !0, p = e.length, v = [], k = t.length;
        if (!p)
          return v;
        i && (t = ye(t, nt(i))), a ? (d = ro, m = !1) : t.length >= s && (d = ln, m = !1, t = new vr(t));
        e:
          for (; ++u < p; ) {
            var M = e[u], S = i == null ? M : i(M);
            if (M = a || M !== 0 ? M : 0, m && S === S) {
              for (var A = k; A--; )
                if (t[A] === S)
                  continue e;
              v.push(M);
            } else
              d(t, S, a) || v.push(M);
          }
        return v;
      }
      var tr = Ja(Ot), Ma = Ja(wo, !0);
      function wd(e, t) {
        var i = !0;
        return tr(e, function(a, u, d) {
          return i = !!t(a, u, d), i;
        }), i;
      }
      function ni(e, t, i) {
        for (var a = -1, u = e.length; ++a < u; ) {
          var d = e[a], m = t(d);
          if (m != null && (p === n ? m === m && !ot(m) : i(m, p)))
            var p = m, v = d;
        }
        return v;
      }
      function yd(e, t, i, a) {
        var u = e.length;
        for (i = q(i), i < 0 && (i = -i > u ? 0 : u + i), a = a === n || a > u ? u : q(a), a < 0 && (a += u), a = i > a ? 0 : $l(a); i < a; )
          e[i++] = t;
        return e;
      }
      function za(e, t) {
        var i = [];
        return tr(e, function(a, u, d) {
          t(a, u, d) && i.push(a);
        }), i;
      }
      function Fe(e, t, i, a, u) {
        var d = -1, m = e.length;
        for (i || (i = lg), u || (u = []); ++d < m; ) {
          var p = e[d];
          t > 0 && i(p) ? t > 1 ? Fe(p, t - 1, i, a, u) : Zt(u, p) : a || (u[u.length] = p);
        }
        return u;
      }
      var vo = Za(), Sa = Za(!0);
      function Ot(e, t) {
        return e && vo(e, t, Pe);
      }
      function wo(e, t) {
        return e && Sa(e, t, Pe);
      }
      function ii(e, t) {
        return Jt(t, function(i) {
          return Ht(e[i]);
        });
      }
      function yr(e, t) {
        t = nr(t, e);
        for (var i = 0, a = t.length; e != null && i < a; )
          e = e[Lt(t[i++])];
        return i && i == a ? e : n;
      }
      function Ta(e, t, i) {
        var a = t(e);
        return V(e) ? a : Zt(a, i(e));
      }
      function qe(e) {
        return e == null ? e === n ? Xu : Gu : pr && pr in he(e) ? rg(e) : mg(e);
      }
      function yo(e, t) {
        return e > t;
      }
      function xd(e, t) {
        return e != null && ue.call(e, t);
      }
      function _d(e, t) {
        return e != null && t in he(e);
      }
      function Cd(e, t, i) {
        return e >= $e(t, i) && e < Ee(t, i);
      }
      function xo(e, t, i) {
        for (var a = i ? ro : Fn, u = e[0].length, d = e.length, m = d, p = _(d), v = 1 / 0, k = []; m--; ) {
          var M = e[m];
          m && t && (M = ye(M, nt(t))), v = $e(M.length, v), p[m] = !i && (t || u >= 120 && M.length >= 120) ? new vr(m && M) : n;
        }
        M = e[0];
        var S = -1, A = p[0];
        e:
          for (; ++S < u && k.length < v; ) {
            var P = M[S], N = t ? t(P) : P;
            if (P = i || P !== 0 ? P : 0, !(A ? ln(A, N) : a(k, N, i))) {
              for (m = d; --m; ) {
                var Q = p[m];
                if (!(Q ? ln(Q, N) : a(e[m], N, i)))
                  continue e;
              }
              A && A.push(N), k.push(P);
            }
          }
        return k;
      }
      function kd(e, t, i, a) {
        return Ot(e, function(u, d, m) {
          t(a, i(u), d, m);
        }), a;
      }
      function pn(e, t, i) {
        t = nr(t, e), e = ml(e, t);
        var a = e == null ? e : e[Lt(bt(t))];
        return a == null ? n : rt(a, e, i);
      }
      function Oa(e) {
        return Me(e) && qe(e) == Lr;
      }
      function Md(e) {
        return Me(e) && qe(e) == an;
      }
      function zd(e) {
        return Me(e) && qe(e) == tn;
      }
      function bn(e, t, i, a, u) {
        return e === t ? !0 : e == null || t == null || !Me(e) && !Me(t) ? e !== e && t !== t : Sd(e, t, i, a, bn, u);
      }
      function Sd(e, t, i, a, u, d) {
        var m = V(e), p = V(t), v = m ? An : He(e), k = p ? An : He(t);
        v = v == Lr ? Pt : v, k = k == Lr ? Pt : k;
        var M = v == Pt, S = k == Pt, A = v == k;
        if (A && or(e)) {
          if (!or(t))
            return !1;
          m = !0, M = !1;
        }
        if (A && !M)
          return d || (d = new Mt()), m || Vr(e) ? ll(e, t, i, a, u, d) : eg(e, t, v, i, a, u, d);
        if (!(i & $)) {
          var P = M && ue.call(e, "__wrapped__"), N = S && ue.call(t, "__wrapped__");
          if (P || N) {
            var Q = P ? e.value() : e, U = N ? t.value() : t;
            return d || (d = new Mt()), u(Q, U, i, a, d);
          }
        }
        return A ? (d || (d = new Mt()), tg(e, t, i, a, u, d)) : !1;
      }
      function Td(e) {
        return Me(e) && He(e) == _t;
      }
      function _o(e, t, i, a) {
        var u = i.length, d = u, m = !a;
        if (e == null)
          return !d;
        for (e = he(e); u--; ) {
          var p = i[u];
          if (m && p[2] ? p[1] !== e[p[0]] : !(p[0] in e))
            return !1;
        }
        for (; ++u < d; ) {
          p = i[u];
          var v = p[0], k = e[v], M = p[1];
          if (m && p[2]) {
            if (k === n && !(v in e))
              return !1;
          } else {
            var S = new Mt();
            if (a)
              var A = a(k, M, v, e, t, S);
            if (!(A === n ? bn(M, k, $ | W, a, S) : A))
              return !1;
          }
        }
        return !0;
      }
      function Da(e) {
        if (!Ce(e) || cg(e))
          return !1;
        var t = Ht(e) ? Tf : bc;
        return t.test(_r(e));
      }
      function Od(e) {
        return Me(e) && qe(e) == nn;
      }
      function Dd(e) {
        return Me(e) && He(e) == Ct;
      }
      function Ld(e) {
        return Me(e) && xi(e.length) && !!be[qe(e)];
      }
      function La(e) {
        return typeof e == "function" ? e : e == null ? et : typeof e == "object" ? V(e) ? Ia(e[0], e[1]) : Ea(e) : jl(e);
      }
      function Co(e) {
        if (!yn(e))
          return If(e);
        var t = [];
        for (var i in he(e))
          ue.call(e, i) && i != "constructor" && t.push(i);
        return t;
      }
      function Ad(e) {
        if (!Ce(e))
          return hg(e);
        var t = yn(e), i = [];
        for (var a in e)
          a == "constructor" && (t || !ue.call(e, a)) || i.push(a);
        return i;
      }
      function ko(e, t) {
        return e < t;
      }
      function Aa(e, t) {
        var i = -1, a = Ze(e) ? _(e.length) : [];
        return tr(e, function(u, d, m) {
          a[++i] = t(u, d, m);
        }), a;
      }
      function Ea(e) {
        var t = Fo(e);
        return t.length == 1 && t[0][2] ? gl(t[0][0], t[0][1]) : function(i) {
          return i === e || _o(i, e, t);
        };
      }
      function Ia(e, t) {
        return Uo(e) && dl(t) ? gl(Lt(e), t) : function(i) {
          var a = Jo(i, e);
          return a === n && a === t ? Zo(i, e) : bn(t, a, $ | W);
        };
      }
      function oi(e, t, i, a, u) {
        e !== t && vo(t, function(d, m) {
          if (u || (u = new Mt()), Ce(d))
            Ed(e, t, m, i, oi, a, u);
          else {
            var p = a ? a(Ho(e, m), d, m + "", e, t, u) : n;
            p === n && (p = d), po(e, m, p);
          }
        }, je);
      }
      function Ed(e, t, i, a, u, d, m) {
        var p = Ho(e, i), v = Ho(t, i), k = m.get(v);
        if (k) {
          po(e, i, k);
          return;
        }
        var M = d ? d(p, v, i + "", e, t, m) : n, S = M === n;
        if (S) {
          var A = V(v), P = !A && or(v), N = !A && !P && Vr(v);
          M = v, A || P || N ? V(p) ? M = p : Te(p) ? M = Je(p) : P ? (S = !1, M = Ga(v, !0)) : N ? (S = !1, M = qa(v, !0)) : M = [] : _n(v) || Cr(v) ? (M = p, Cr(p) ? M = Hl(p) : (!Ce(p) || Ht(p)) && (M = fl(v))) : S = !1;
        }
        S && (m.set(v, M), u(M, v, a, d, m), m.delete(v)), po(e, i, M);
      }
      function Ra(e, t) {
        var i = e.length;
        if (i)
          return t += t < 0 ? i : 0, $t(t, i) ? e[t] : n;
      }
      function Pa(e, t, i) {
        t.length ? t = ye(t, function(d) {
          return V(d) ? function(m) {
            return yr(m, d.length === 1 ? d[0] : d);
          } : d;
        }) : t = [et];
        var a = -1;
        t = ye(t, nt(B()));
        var u = Aa(e, function(d, m, p) {
          var v = ye(t, function(k) {
            return k(d);
          });
          return { criteria: v, index: ++a, value: d };
        });
        return sf(u, function(d, m) {
          return Gd(d, m, i);
        });
      }
      function Id(e, t) {
        return Wa(e, t, function(i, a) {
          return Zo(e, a);
        });
      }
      function Wa(e, t, i) {
        for (var a = -1, u = t.length, d = {}; ++a < u; ) {
          var m = t[a], p = yr(e, m);
          i(p, m) && vn(d, nr(m, e), p);
        }
        return d;
      }
      function Rd(e) {
        return function(t) {
          return yr(t, e);
        };
      }
      function Mo(e, t, i, a) {
        var u = a ? of : Ir, d = -1, m = t.length, p = e;
        for (e === t && (t = Je(t)), i && (p = ye(e, nt(i))); ++d < m; )
          for (var v = 0, k = t[d], M = i ? i(k) : k; (v = u(p, M, v, a)) > -1; )
            p !== e && Kn.call(p, v, 1), Kn.call(e, v, 1);
        return e;
      }
      function Ba(e, t) {
        for (var i = e ? t.length : 0, a = i - 1; i--; ) {
          var u = t[i];
          if (i == a || u !== d) {
            var d = u;
            $t(u) ? Kn.call(e, u, 1) : Oo(e, u);
          }
        }
        return e;
      }
      function zo(e, t) {
        return e + Zn(va() * (t - e + 1));
      }
      function Pd(e, t, i, a) {
        for (var u = -1, d = Ee(Jn((t - e) / (i || 1)), 0), m = _(d); d--; )
          m[a ? d : ++u] = e, e += i;
        return m;
      }
      function So(e, t) {
        var i = "";
        if (!e || t < 1 || t > ct)
          return i;
        do
          t % 2 && (i += e), t = Zn(t / 2), t && (e += e);
        while (t);
        return i;
      }
      function Z(e, t) {
        return Yo(hl(e, t, et), e + "");
      }
      function Wd(e) {
        return xa(Gr(e));
      }
      function Bd(e, t) {
        var i = Gr(e);
        return mi(i, wr(t, 0, i.length));
      }
      function vn(e, t, i, a) {
        if (!Ce(e))
          return e;
        t = nr(t, e);
        for (var u = -1, d = t.length, m = d - 1, p = e; p != null && ++u < d; ) {
          var v = Lt(t[u]), k = i;
          if (v === "__proto__" || v === "constructor" || v === "prototype")
            return e;
          if (u != m) {
            var M = p[v];
            k = a ? a(M, v, p) : n, k === n && (k = Ce(M) ? M : $t(t[u + 1]) ? [] : {});
          }
          hn(p, v, k), p = p[v];
        }
        return e;
      }
      var Fa = jn ? function(e, t) {
        return jn.set(e, t), e;
      } : et, Fd = Qn ? function(e, t) {
        return Qn(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: es(t),
          writable: !0
        });
      } : et;
      function Nd(e) {
        return mi(Gr(e));
      }
      function pt(e, t, i) {
        var a = -1, u = e.length;
        t < 0 && (t = -t > u ? 0 : u + t), i = i > u ? u : i, i < 0 && (i += u), u = t > i ? 0 : i - t >>> 0, t >>>= 0;
        for (var d = _(u); ++a < u; )
          d[a] = e[a + t];
        return d;
      }
      function Ud(e, t) {
        var i;
        return tr(e, function(a, u, d) {
          return i = t(a, u, d), !i;
        }), !!i;
      }
      function si(e, t, i) {
        var a = 0, u = e == null ? a : e.length;
        if (typeof t == "number" && t === t && u <= $u) {
          for (; a < u; ) {
            var d = a + u >>> 1, m = e[d];
            m !== null && !ot(m) && (i ? m <= t : m < t) ? a = d + 1 : u = d;
          }
          return u;
        }
        return To(e, t, et, i);
      }
      function To(e, t, i, a) {
        var u = 0, d = e == null ? 0 : e.length;
        if (d === 0)
          return 0;
        t = i(t);
        for (var m = t !== t, p = t === null, v = ot(t), k = t === n; u < d; ) {
          var M = Zn((u + d) / 2), S = i(e[M]), A = S !== n, P = S === null, N = S === S, Q = ot(S);
          if (m)
            var U = a || N;
          else
            k ? U = N && (a || A) : p ? U = N && A && (a || !P) : v ? U = N && A && !P && (a || !Q) : P || Q ? U = !1 : U = a ? S <= t : S < t;
          U ? u = M + 1 : d = M;
        }
        return $e(d, Dr);
      }
      function Na(e, t) {
        for (var i = -1, a = e.length, u = 0, d = []; ++i < a; ) {
          var m = e[i], p = t ? t(m) : m;
          if (!i || !zt(p, v)) {
            var v = p;
            d[u++] = m === 0 ? 0 : m;
          }
        }
        return d;
      }
      function Ua(e) {
        return typeof e == "number" ? e : ot(e) ? hr : +e;
      }
      function it(e) {
        if (typeof e == "string")
          return e;
        if (V(e))
          return ye(e, it) + "";
        if (ot(e))
          return wa ? wa.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -Ge ? "-0" : t;
      }
      function rr(e, t, i) {
        var a = -1, u = Fn, d = e.length, m = !0, p = [], v = p;
        if (i)
          m = !1, u = ro;
        else if (d >= s) {
          var k = t ? null : Zd(e);
          if (k)
            return Un(k);
          m = !1, u = ln, v = new vr();
        } else
          v = t ? [] : p;
        e:
          for (; ++a < d; ) {
            var M = e[a], S = t ? t(M) : M;
            if (M = i || M !== 0 ? M : 0, m && S === S) {
              for (var A = v.length; A--; )
                if (v[A] === S)
                  continue e;
              t && v.push(S), p.push(M);
            } else
              u(v, S, i) || (v !== p && v.push(S), p.push(M));
          }
        return p;
      }
      function Oo(e, t) {
        return t = nr(t, e), e = ml(e, t), e == null || delete e[Lt(bt(t))];
      }
      function $a(e, t, i, a) {
        return vn(e, t, i(yr(e, t)), a);
      }
      function ai(e, t, i, a) {
        for (var u = e.length, d = a ? u : -1; (a ? d-- : ++d < u) && t(e[d], d, e); )
          ;
        return i ? pt(e, a ? 0 : d, a ? d + 1 : u) : pt(e, a ? d + 1 : 0, a ? u : d);
      }
      function Ha(e, t) {
        var i = e;
        return i instanceof ee && (i = i.value()), no(t, function(a, u) {
          return u.func.apply(u.thisArg, Zt([a], u.args));
        }, i);
      }
      function Do(e, t, i) {
        var a = e.length;
        if (a < 2)
          return a ? rr(e[0]) : [];
        for (var u = -1, d = _(a); ++u < a; )
          for (var m = e[u], p = -1; ++p < a; )
            p != u && (d[u] = mn(d[u] || m, e[p], t, i));
        return rr(Fe(d, 1), t, i);
      }
      function Ya(e, t, i) {
        for (var a = -1, u = e.length, d = t.length, m = {}; ++a < u; ) {
          var p = a < d ? t[a] : n;
          i(m, e[a], p);
        }
        return m;
      }
      function Lo(e) {
        return Te(e) ? e : [];
      }
      function Ao(e) {
        return typeof e == "function" ? e : et;
      }
      function nr(e, t) {
        return V(e) ? e : Uo(e, t) ? [e] : wl(ae(e));
      }
      var $d = Z;
      function ir(e, t, i) {
        var a = e.length;
        return i = i === n ? a : i, !t && i >= a ? e : pt(e, t, i);
      }
      var Va = Of || function(e) {
        return Be.clearTimeout(e);
      };
      function Ga(e, t) {
        if (t)
          return e.slice();
        var i = e.length, a = ga ? ga(i) : new e.constructor(i);
        return e.copy(a), a;
      }
      function Eo(e) {
        var t = new e.constructor(e.byteLength);
        return new qn(t).set(new qn(e)), t;
      }
      function Hd(e, t) {
        var i = t ? Eo(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.byteLength);
      }
      function Yd(e) {
        var t = new e.constructor(e.source, Os.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function Vd(e) {
        return gn ? he(gn.call(e)) : {};
      }
      function qa(e, t) {
        var i = t ? Eo(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.length);
      }
      function Xa(e, t) {
        if (e !== t) {
          var i = e !== n, a = e === null, u = e === e, d = ot(e), m = t !== n, p = t === null, v = t === t, k = ot(t);
          if (!p && !k && !d && e > t || d && m && v && !p && !k || a && m && v || !i && v || !u)
            return 1;
          if (!a && !d && !k && e < t || k && i && u && !a && !d || p && i && u || !m && u || !v)
            return -1;
        }
        return 0;
      }
      function Gd(e, t, i) {
        for (var a = -1, u = e.criteria, d = t.criteria, m = u.length, p = i.length; ++a < m; ) {
          var v = Xa(u[a], d[a]);
          if (v) {
            if (a >= p)
              return v;
            var k = i[a];
            return v * (k == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function Ka(e, t, i, a) {
        for (var u = -1, d = e.length, m = i.length, p = -1, v = t.length, k = Ee(d - m, 0), M = _(v + k), S = !a; ++p < v; )
          M[p] = t[p];
        for (; ++u < m; )
          (S || u < d) && (M[i[u]] = e[u]);
        for (; k--; )
          M[p++] = e[u++];
        return M;
      }
      function Qa(e, t, i, a) {
        for (var u = -1, d = e.length, m = -1, p = i.length, v = -1, k = t.length, M = Ee(d - p, 0), S = _(M + k), A = !a; ++u < M; )
          S[u] = e[u];
        for (var P = u; ++v < k; )
          S[P + v] = t[v];
        for (; ++m < p; )
          (A || u < d) && (S[P + i[m]] = e[u++]);
        return S;
      }
      function Je(e, t) {
        var i = -1, a = e.length;
        for (t || (t = _(a)); ++i < a; )
          t[i] = e[i];
        return t;
      }
      function Dt(e, t, i, a) {
        var u = !i;
        i || (i = {});
        for (var d = -1, m = t.length; ++d < m; ) {
          var p = t[d], v = a ? a(i[p], e[p], p, i, e) : n;
          v === n && (v = e[p]), u ? Ft(i, p, v) : hn(i, p, v);
        }
        return i;
      }
      function qd(e, t) {
        return Dt(e, No(e), t);
      }
      function Xd(e, t) {
        return Dt(e, ul(e), t);
      }
      function li(e, t) {
        return function(i, a) {
          var u = V(i) ? Zc : pd, d = t ? t() : {};
          return u(i, e, B(a, 2), d);
        };
      }
      function $r(e) {
        return Z(function(t, i) {
          var a = -1, u = i.length, d = u > 1 ? i[u - 1] : n, m = u > 2 ? i[2] : n;
          for (d = e.length > 3 && typeof d == "function" ? (u--, d) : n, m && Xe(i[0], i[1], m) && (d = u < 3 ? n : d, u = 1), t = he(t); ++a < u; ) {
            var p = i[a];
            p && e(t, p, a, d);
          }
          return t;
        });
      }
      function Ja(e, t) {
        return function(i, a) {
          if (i == null)
            return i;
          if (!Ze(i))
            return e(i, a);
          for (var u = i.length, d = t ? u : -1, m = he(i); (t ? d-- : ++d < u) && a(m[d], d, m) !== !1; )
            ;
          return i;
        };
      }
      function Za(e) {
        return function(t, i, a) {
          for (var u = -1, d = he(t), m = a(t), p = m.length; p--; ) {
            var v = m[e ? p : ++u];
            if (i(d[v], v, d) === !1)
              break;
          }
          return t;
        };
      }
      function Kd(e, t, i) {
        var a = t & F, u = wn(e);
        function d() {
          var m = this && this !== Be && this instanceof d ? u : e;
          return m.apply(a ? i : this, arguments);
        }
        return d;
      }
      function ja(e) {
        return function(t) {
          t = ae(t);
          var i = Rr(t) ? kt(t) : n, a = i ? i[0] : t.charAt(0), u = i ? ir(i, 1).join("") : t.slice(1);
          return a[e]() + u;
        };
      }
      function Hr(e) {
        return function(t) {
          return no(Jl(Ql(t).replace(Bc, "")), e, "");
        };
      }
      function wn(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var i = Ur(e.prototype), a = e.apply(i, t);
          return Ce(a) ? a : i;
        };
      }
      function Qd(e, t, i) {
        var a = wn(e);
        function u() {
          for (var d = arguments.length, m = _(d), p = d, v = Yr(u); p--; )
            m[p] = arguments[p];
          var k = d < 3 && m[0] !== v && m[d - 1] !== v ? [] : jt(m, v);
          if (d -= k.length, d < i)
            return il(
              e,
              t,
              ui,
              u.placeholder,
              n,
              m,
              k,
              n,
              n,
              i - d
            );
          var M = this && this !== Be && this instanceof u ? a : e;
          return rt(M, this, m);
        }
        return u;
      }
      function el(e) {
        return function(t, i, a) {
          var u = he(t);
          if (!Ze(t)) {
            var d = B(i, 3);
            t = Pe(t), i = function(p) {
              return d(u[p], p, u);
            };
          }
          var m = e(t, i, a);
          return m > -1 ? u[d ? t[m] : m] : n;
        };
      }
      function tl(e) {
        return Ut(function(t) {
          var i = t.length, a = i, u = ht.prototype.thru;
          for (e && t.reverse(); a--; ) {
            var d = t[a];
            if (typeof d != "function")
              throw new gt(g);
            if (u && !m && gi(d) == "wrapper")
              var m = new ht([], !0);
          }
          for (a = m ? a : i; ++a < i; ) {
            d = t[a];
            var p = gi(d), v = p == "wrapper" ? Bo(d) : n;
            v && $o(v[0]) && v[1] == (J | oe | de | Ye) && !v[4].length && v[9] == 1 ? m = m[gi(v[0])].apply(m, v[3]) : m = d.length == 1 && $o(d) ? m[p]() : m.thru(d);
          }
          return function() {
            var k = arguments, M = k[0];
            if (m && k.length == 1 && V(M))
              return m.plant(M).value();
            for (var S = 0, A = i ? t[S].apply(this, k) : M; ++S < i; )
              A = t[S].call(this, A);
            return A;
          };
        });
      }
      function ui(e, t, i, a, u, d, m, p, v, k) {
        var M = t & J, S = t & F, A = t & H, P = t & (oe | ke), N = t & Qe, Q = A ? n : wn(e);
        function U() {
          for (var j = arguments.length, re = _(j), st = j; st--; )
            re[st] = arguments[st];
          if (P)
            var Ke = Yr(U), at = lf(re, Ke);
          if (a && (re = Ka(re, a, u, P)), d && (re = Qa(re, d, m, P)), j -= at, P && j < k) {
            var Oe = jt(re, Ke);
            return il(
              e,
              t,
              ui,
              U.placeholder,
              i,
              re,
              Oe,
              p,
              v,
              k - j
            );
          }
          var St = S ? i : this, Vt = A ? St[e] : e;
          return j = re.length, p ? re = pg(re, p) : N && j > 1 && re.reverse(), M && v < j && (re.length = v), this && this !== Be && this instanceof U && (Vt = Q || wn(Vt)), Vt.apply(St, re);
        }
        return U;
      }
      function rl(e, t) {
        return function(i, a) {
          return kd(i, e, t(a), {});
        };
      }
      function ci(e, t) {
        return function(i, a) {
          var u;
          if (i === n && a === n)
            return t;
          if (i !== n && (u = i), a !== n) {
            if (u === n)
              return a;
            typeof i == "string" || typeof a == "string" ? (i = it(i), a = it(a)) : (i = Ua(i), a = Ua(a)), u = e(i, a);
          }
          return u;
        };
      }
      function Io(e) {
        return Ut(function(t) {
          return t = ye(t, nt(B())), Z(function(i) {
            var a = this;
            return e(t, function(u) {
              return rt(u, a, i);
            });
          });
        });
      }
      function fi(e, t) {
        t = t === n ? " " : it(t);
        var i = t.length;
        if (i < 2)
          return i ? So(t, e) : t;
        var a = So(t, Jn(e / Pr(t)));
        return Rr(t) ? ir(kt(a), 0, e).join("") : a.slice(0, e);
      }
      function Jd(e, t, i, a) {
        var u = t & F, d = wn(e);
        function m() {
          for (var p = -1, v = arguments.length, k = -1, M = a.length, S = _(M + v), A = this && this !== Be && this instanceof m ? d : e; ++k < M; )
            S[k] = a[k];
          for (; v--; )
            S[k++] = arguments[++p];
          return rt(A, u ? i : this, S);
        }
        return m;
      }
      function nl(e) {
        return function(t, i, a) {
          return a && typeof a != "number" && Xe(t, i, a) && (i = a = n), t = Yt(t), i === n ? (i = t, t = 0) : i = Yt(i), a = a === n ? t < i ? 1 : -1 : Yt(a), Pd(t, i, a, e);
        };
      }
      function di(e) {
        return function(t, i) {
          return typeof t == "string" && typeof i == "string" || (t = vt(t), i = vt(i)), e(t, i);
        };
      }
      function il(e, t, i, a, u, d, m, p, v, k) {
        var M = t & oe, S = M ? m : n, A = M ? n : m, P = M ? d : n, N = M ? n : d;
        t |= M ? de : Se, t &= ~(M ? Se : de), t & te || (t &= ~(F | H));
        var Q = [
          e,
          t,
          u,
          P,
          S,
          N,
          A,
          p,
          v,
          k
        ], U = i.apply(n, Q);
        return $o(e) && pl(U, Q), U.placeholder = a, bl(U, e, t);
      }
      function Ro(e) {
        var t = Ae[e];
        return function(i, a) {
          if (i = vt(i), a = a == null ? 0 : $e(q(a), 292), a && ba(i)) {
            var u = (ae(i) + "e").split("e"), d = t(u[0] + "e" + (+u[1] + a));
            return u = (ae(d) + "e").split("e"), +(u[0] + "e" + (+u[1] - a));
          }
          return t(i);
        };
      }
      var Zd = Fr && 1 / Un(new Fr([, -0]))[1] == Ge ? function(e) {
        return new Fr(e);
      } : ns;
      function ol(e) {
        return function(t) {
          var i = He(t);
          return i == _t ? co(t) : i == Ct ? mf(t) : af(t, e(t));
        };
      }
      function Nt(e, t, i, a, u, d, m, p) {
        var v = t & H;
        if (!v && typeof e != "function")
          throw new gt(g);
        var k = a ? a.length : 0;
        if (k || (t &= ~(de | Se), a = u = n), m = m === n ? m : Ee(q(m), 0), p = p === n ? p : q(p), k -= u ? u.length : 0, t & Se) {
          var M = a, S = u;
          a = u = n;
        }
        var A = v ? n : Bo(e), P = [
          e,
          t,
          i,
          a,
          u,
          M,
          S,
          d,
          m,
          p
        ];
        if (A && gg(P, A), e = P[0], t = P[1], i = P[2], a = P[3], u = P[4], p = P[9] = P[9] === n ? v ? 0 : e.length : Ee(P[9] - k, 0), !p && t & (oe | ke) && (t &= ~(oe | ke)), !t || t == F)
          var N = Kd(e, t, i);
        else
          t == oe || t == ke ? N = Qd(e, t, p) : (t == de || t == (F | de)) && !u.length ? N = Jd(e, t, i, a) : N = ui.apply(n, P);
        var Q = A ? Fa : pl;
        return bl(Q(N, P), e, t);
      }
      function sl(e, t, i, a) {
        return e === n || zt(e, Br[i]) && !ue.call(a, i) ? t : e;
      }
      function al(e, t, i, a, u, d) {
        return Ce(e) && Ce(t) && (d.set(t, e), oi(e, t, n, al, d), d.delete(t)), e;
      }
      function jd(e) {
        return _n(e) ? n : e;
      }
      function ll(e, t, i, a, u, d) {
        var m = i & $, p = e.length, v = t.length;
        if (p != v && !(m && v > p))
          return !1;
        var k = d.get(e), M = d.get(t);
        if (k && M)
          return k == t && M == e;
        var S = -1, A = !0, P = i & W ? new vr() : n;
        for (d.set(e, t), d.set(t, e); ++S < p; ) {
          var N = e[S], Q = t[S];
          if (a)
            var U = m ? a(Q, N, S, t, e, d) : a(N, Q, S, e, t, d);
          if (U !== n) {
            if (U)
              continue;
            A = !1;
            break;
          }
          if (P) {
            if (!io(t, function(j, re) {
              if (!ln(P, re) && (N === j || u(N, j, i, a, d)))
                return P.push(re);
            })) {
              A = !1;
              break;
            }
          } else if (!(N === Q || u(N, Q, i, a, d))) {
            A = !1;
            break;
          }
        }
        return d.delete(e), d.delete(t), A;
      }
      function eg(e, t, i, a, u, d, m) {
        switch (i) {
          case Ar:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case an:
            return !(e.byteLength != t.byteLength || !d(new qn(e), new qn(t)));
          case en:
          case tn:
          case rn:
            return zt(+e, +t);
          case En:
            return e.name == t.name && e.message == t.message;
          case nn:
          case on:
            return e == t + "";
          case _t:
            var p = co;
          case Ct:
            var v = a & $;
            if (p || (p = Un), e.size != t.size && !v)
              return !1;
            var k = m.get(e);
            if (k)
              return k == t;
            a |= W, m.set(e, t);
            var M = ll(p(e), p(t), a, u, d, m);
            return m.delete(e), M;
          case Rn:
            if (gn)
              return gn.call(e) == gn.call(t);
        }
        return !1;
      }
      function tg(e, t, i, a, u, d) {
        var m = i & $, p = Po(e), v = p.length, k = Po(t), M = k.length;
        if (v != M && !m)
          return !1;
        for (var S = v; S--; ) {
          var A = p[S];
          if (!(m ? A in t : ue.call(t, A)))
            return !1;
        }
        var P = d.get(e), N = d.get(t);
        if (P && N)
          return P == t && N == e;
        var Q = !0;
        d.set(e, t), d.set(t, e);
        for (var U = m; ++S < v; ) {
          A = p[S];
          var j = e[A], re = t[A];
          if (a)
            var st = m ? a(re, j, A, t, e, d) : a(j, re, A, e, t, d);
          if (!(st === n ? j === re || u(j, re, i, a, d) : st)) {
            Q = !1;
            break;
          }
          U || (U = A == "constructor");
        }
        if (Q && !U) {
          var Ke = e.constructor, at = t.constructor;
          Ke != at && "constructor" in e && "constructor" in t && !(typeof Ke == "function" && Ke instanceof Ke && typeof at == "function" && at instanceof at) && (Q = !1);
        }
        return d.delete(e), d.delete(t), Q;
      }
      function Ut(e) {
        return Yo(hl(e, n, Cl), e + "");
      }
      function Po(e) {
        return Ta(e, Pe, No);
      }
      function Wo(e) {
        return Ta(e, je, ul);
      }
      var Bo = jn ? function(e) {
        return jn.get(e);
      } : ns;
      function gi(e) {
        for (var t = e.name + "", i = Nr[t], a = ue.call(Nr, t) ? i.length : 0; a--; ) {
          var u = i[a], d = u.func;
          if (d == null || d == e)
            return u.name;
        }
        return t;
      }
      function Yr(e) {
        var t = ue.call(f, "placeholder") ? f : e;
        return t.placeholder;
      }
      function B() {
        var e = f.iteratee || ts;
        return e = e === ts ? La : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function hi(e, t) {
        var i = e.__data__;
        return ug(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
      }
      function Fo(e) {
        for (var t = Pe(e), i = t.length; i--; ) {
          var a = t[i], u = e[a];
          t[i] = [a, u, dl(u)];
        }
        return t;
      }
      function xr(e, t) {
        var i = df(e, t);
        return Da(i) ? i : n;
      }
      function rg(e) {
        var t = ue.call(e, pr), i = e[pr];
        try {
          e[pr] = n;
          var a = !0;
        } catch {
        }
        var u = Vn.call(e);
        return a && (t ? e[pr] = i : delete e[pr]), u;
      }
      var No = go ? function(e) {
        return e == null ? [] : (e = he(e), Jt(go(e), function(t) {
          return ma.call(e, t);
        }));
      } : is, ul = go ? function(e) {
        for (var t = []; e; )
          Zt(t, No(e)), e = Xn(e);
        return t;
      } : is, He = qe;
      (ho && He(new ho(new ArrayBuffer(1))) != Ar || cn && He(new cn()) != _t || mo && He(mo.resolve()) != Ms || Fr && He(new Fr()) != Ct || fn && He(new fn()) != sn) && (He = function(e) {
        var t = qe(e), i = t == Pt ? e.constructor : n, a = i ? _r(i) : "";
        if (a)
          switch (a) {
            case Bf:
              return Ar;
            case Ff:
              return _t;
            case Nf:
              return Ms;
            case Uf:
              return Ct;
            case $f:
              return sn;
          }
        return t;
      });
      function ng(e, t, i) {
        for (var a = -1, u = i.length; ++a < u; ) {
          var d = i[a], m = d.size;
          switch (d.type) {
            case "drop":
              e += m;
              break;
            case "dropRight":
              t -= m;
              break;
            case "take":
              t = $e(t, e + m);
              break;
            case "takeRight":
              e = Ee(e, t - m);
              break;
          }
        }
        return { start: e, end: t };
      }
      function ig(e) {
        var t = e.match(uc);
        return t ? t[1].split(cc) : [];
      }
      function cl(e, t, i) {
        t = nr(t, e);
        for (var a = -1, u = t.length, d = !1; ++a < u; ) {
          var m = Lt(t[a]);
          if (!(d = e != null && i(e, m)))
            break;
          e = e[m];
        }
        return d || ++a != u ? d : (u = e == null ? 0 : e.length, !!u && xi(u) && $t(m, u) && (V(e) || Cr(e)));
      }
      function og(e) {
        var t = e.length, i = new e.constructor(t);
        return t && typeof e[0] == "string" && ue.call(e, "index") && (i.index = e.index, i.input = e.input), i;
      }
      function fl(e) {
        return typeof e.constructor == "function" && !yn(e) ? Ur(Xn(e)) : {};
      }
      function sg(e, t, i) {
        var a = e.constructor;
        switch (t) {
          case an:
            return Eo(e);
          case en:
          case tn:
            return new a(+e);
          case Ar:
            return Hd(e, i);
          case Bi:
          case Fi:
          case Ni:
          case Ui:
          case $i:
          case Hi:
          case Yi:
          case Vi:
          case Gi:
            return qa(e, i);
          case _t:
            return new a();
          case rn:
          case on:
            return new a(e);
          case nn:
            return Yd(e);
          case Ct:
            return new a();
          case Rn:
            return Vd(e);
        }
      }
      function ag(e, t) {
        var i = t.length;
        if (!i)
          return e;
        var a = i - 1;
        return t[a] = (i > 1 ? "& " : "") + t[a], t = t.join(i > 2 ? ", " : " "), e.replace(lc, `{
/* [wrapped with ` + t + `] */
`);
      }
      function lg(e) {
        return V(e) || Cr(e) || !!(pa && e && e[pa]);
      }
      function $t(e, t) {
        var i = typeof e;
        return t = t ?? ct, !!t && (i == "number" || i != "symbol" && wc.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function Xe(e, t, i) {
        if (!Ce(i))
          return !1;
        var a = typeof t;
        return (a == "number" ? Ze(i) && $t(t, i.length) : a == "string" && t in i) ? zt(i[t], e) : !1;
      }
      function Uo(e, t) {
        if (V(e))
          return !1;
        var i = typeof e;
        return i == "number" || i == "symbol" || i == "boolean" || e == null || ot(e) ? !0 : ic.test(e) || !nc.test(e) || t != null && e in he(t);
      }
      function ug(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function $o(e) {
        var t = gi(e), i = f[t];
        if (typeof i != "function" || !(t in ee.prototype))
          return !1;
        if (e === i)
          return !0;
        var a = Bo(i);
        return !!a && e === a[0];
      }
      function cg(e) {
        return !!da && da in e;
      }
      var fg = Hn ? Ht : os;
      function yn(e) {
        var t = e && e.constructor, i = typeof t == "function" && t.prototype || Br;
        return e === i;
      }
      function dl(e) {
        return e === e && !Ce(e);
      }
      function gl(e, t) {
        return function(i) {
          return i == null ? !1 : i[e] === t && (t !== n || e in he(i));
        };
      }
      function dg(e) {
        var t = wi(e, function(a) {
          return i.size === x && i.clear(), a;
        }), i = t.cache;
        return t;
      }
      function gg(e, t) {
        var i = e[1], a = t[1], u = i | a, d = u < (F | H | J), m = a == J && i == oe || a == J && i == Ye && e[7].length <= t[8] || a == (J | Ye) && t[7].length <= t[8] && i == oe;
        if (!(d || m))
          return e;
        a & F && (e[2] = t[2], u |= i & F ? 0 : te);
        var p = t[3];
        if (p) {
          var v = e[3];
          e[3] = v ? Ka(v, p, t[4]) : p, e[4] = v ? jt(e[3], z) : t[4];
        }
        return p = t[5], p && (v = e[5], e[5] = v ? Qa(v, p, t[6]) : p, e[6] = v ? jt(e[5], z) : t[6]), p = t[7], p && (e[7] = p), a & J && (e[8] = e[8] == null ? t[8] : $e(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = u, e;
      }
      function hg(e) {
        var t = [];
        if (e != null)
          for (var i in he(e))
            t.push(i);
        return t;
      }
      function mg(e) {
        return Vn.call(e);
      }
      function hl(e, t, i) {
        return t = Ee(t === n ? e.length - 1 : t, 0), function() {
          for (var a = arguments, u = -1, d = Ee(a.length - t, 0), m = _(d); ++u < d; )
            m[u] = a[t + u];
          u = -1;
          for (var p = _(t + 1); ++u < t; )
            p[u] = a[u];
          return p[t] = i(m), rt(e, this, p);
        };
      }
      function ml(e, t) {
        return t.length < 2 ? e : yr(e, pt(t, 0, -1));
      }
      function pg(e, t) {
        for (var i = e.length, a = $e(t.length, i), u = Je(e); a--; ) {
          var d = t[a];
          e[a] = $t(d, i) ? u[d] : n;
        }
        return e;
      }
      function Ho(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var pl = vl(Fa), xn = Lf || function(e, t) {
        return Be.setTimeout(e, t);
      }, Yo = vl(Fd);
      function bl(e, t, i) {
        var a = t + "";
        return Yo(e, ag(a, bg(ig(a), i)));
      }
      function vl(e) {
        var t = 0, i = 0;
        return function() {
          var a = Rf(), u = Or - (a - i);
          if (i = a, u > 0) {
            if (++t >= ge)
              return arguments[0];
          } else
            t = 0;
          return e.apply(n, arguments);
        };
      }
      function mi(e, t) {
        var i = -1, a = e.length, u = a - 1;
        for (t = t === n ? a : t; ++i < t; ) {
          var d = zo(i, u), m = e[d];
          e[d] = e[i], e[i] = m;
        }
        return e.length = t, e;
      }
      var wl = dg(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(oc, function(i, a, u, d) {
          t.push(u ? d.replace(gc, "$1") : a || i);
        }), t;
      });
      function Lt(e) {
        if (typeof e == "string" || ot(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -Ge ? "-0" : t;
      }
      function _r(e) {
        if (e != null) {
          try {
            return Yn.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function bg(e, t) {
        return dt(Hu, function(i) {
          var a = "_." + i[0];
          t & i[1] && !Fn(e, a) && e.push(a);
        }), e.sort();
      }
      function yl(e) {
        if (e instanceof ee)
          return e.clone();
        var t = new ht(e.__wrapped__, e.__chain__);
        return t.__actions__ = Je(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function vg(e, t, i) {
        (i ? Xe(e, t, i) : t === n) ? t = 1 : t = Ee(q(t), 0);
        var a = e == null ? 0 : e.length;
        if (!a || t < 1)
          return [];
        for (var u = 0, d = 0, m = _(Jn(a / t)); u < a; )
          m[d++] = pt(e, u, u += t);
        return m;
      }
      function wg(e) {
        for (var t = -1, i = e == null ? 0 : e.length, a = 0, u = []; ++t < i; ) {
          var d = e[t];
          d && (u[a++] = d);
        }
        return u;
      }
      function yg() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = _(e - 1), i = arguments[0], a = e; a--; )
          t[a - 1] = arguments[a];
        return Zt(V(i) ? Je(i) : [i], Fe(t, 1));
      }
      var xg = Z(function(e, t) {
        return Te(e) ? mn(e, Fe(t, 1, Te, !0)) : [];
      }), _g = Z(function(e, t) {
        var i = bt(t);
        return Te(i) && (i = n), Te(e) ? mn(e, Fe(t, 1, Te, !0), B(i, 2)) : [];
      }), Cg = Z(function(e, t) {
        var i = bt(t);
        return Te(i) && (i = n), Te(e) ? mn(e, Fe(t, 1, Te, !0), n, i) : [];
      });
      function kg(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : q(t), pt(e, t < 0 ? 0 : t, a)) : [];
      }
      function Mg(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : q(t), t = a - t, pt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function zg(e, t) {
        return e && e.length ? ai(e, B(t, 3), !0, !0) : [];
      }
      function Sg(e, t) {
        return e && e.length ? ai(e, B(t, 3), !0) : [];
      }
      function Tg(e, t, i, a) {
        var u = e == null ? 0 : e.length;
        return u ? (i && typeof i != "number" && Xe(e, t, i) && (i = 0, a = u), yd(e, t, i, a)) : [];
      }
      function xl(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var u = i == null ? 0 : q(i);
        return u < 0 && (u = Ee(a + u, 0)), Nn(e, B(t, 3), u);
      }
      function _l(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var u = a - 1;
        return i !== n && (u = q(i), u = i < 0 ? Ee(a + u, 0) : $e(u, a - 1)), Nn(e, B(t, 3), u, !0);
      }
      function Cl(e) {
        var t = e == null ? 0 : e.length;
        return t ? Fe(e, 1) : [];
      }
      function Og(e) {
        var t = e == null ? 0 : e.length;
        return t ? Fe(e, Ge) : [];
      }
      function Dg(e, t) {
        var i = e == null ? 0 : e.length;
        return i ? (t = t === n ? 1 : q(t), Fe(e, t)) : [];
      }
      function Lg(e) {
        for (var t = -1, i = e == null ? 0 : e.length, a = {}; ++t < i; ) {
          var u = e[t];
          a[u[0]] = u[1];
        }
        return a;
      }
      function kl(e) {
        return e && e.length ? e[0] : n;
      }
      function Ag(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var u = i == null ? 0 : q(i);
        return u < 0 && (u = Ee(a + u, 0)), Ir(e, t, u);
      }
      function Eg(e) {
        var t = e == null ? 0 : e.length;
        return t ? pt(e, 0, -1) : [];
      }
      var Ig = Z(function(e) {
        var t = ye(e, Lo);
        return t.length && t[0] === e[0] ? xo(t) : [];
      }), Rg = Z(function(e) {
        var t = bt(e), i = ye(e, Lo);
        return t === bt(i) ? t = n : i.pop(), i.length && i[0] === e[0] ? xo(i, B(t, 2)) : [];
      }), Pg = Z(function(e) {
        var t = bt(e), i = ye(e, Lo);
        return t = typeof t == "function" ? t : n, t && i.pop(), i.length && i[0] === e[0] ? xo(i, n, t) : [];
      });
      function Wg(e, t) {
        return e == null ? "" : Ef.call(e, t);
      }
      function bt(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : n;
      }
      function Bg(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var u = a;
        return i !== n && (u = q(i), u = u < 0 ? Ee(a + u, 0) : $e(u, a - 1)), t === t ? bf(e, t, u) : Nn(e, ia, u, !0);
      }
      function Fg(e, t) {
        return e && e.length ? Ra(e, q(t)) : n;
      }
      var Ng = Z(Ml);
      function Ml(e, t) {
        return e && e.length && t && t.length ? Mo(e, t) : e;
      }
      function Ug(e, t, i) {
        return e && e.length && t && t.length ? Mo(e, t, B(i, 2)) : e;
      }
      function $g(e, t, i) {
        return e && e.length && t && t.length ? Mo(e, t, n, i) : e;
      }
      var Hg = Ut(function(e, t) {
        var i = e == null ? 0 : e.length, a = bo(e, t);
        return Ba(e, ye(t, function(u) {
          return $t(u, i) ? +u : u;
        }).sort(Xa)), a;
      });
      function Yg(e, t) {
        var i = [];
        if (!(e && e.length))
          return i;
        var a = -1, u = [], d = e.length;
        for (t = B(t, 3); ++a < d; ) {
          var m = e[a];
          t(m, a, e) && (i.push(m), u.push(a));
        }
        return Ba(e, u), i;
      }
      function Vo(e) {
        return e == null ? e : Wf.call(e);
      }
      function Vg(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (i && typeof i != "number" && Xe(e, t, i) ? (t = 0, i = a) : (t = t == null ? 0 : q(t), i = i === n ? a : q(i)), pt(e, t, i)) : [];
      }
      function Gg(e, t) {
        return si(e, t);
      }
      function qg(e, t, i) {
        return To(e, t, B(i, 2));
      }
      function Xg(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var a = si(e, t);
          if (a < i && zt(e[a], t))
            return a;
        }
        return -1;
      }
      function Kg(e, t) {
        return si(e, t, !0);
      }
      function Qg(e, t, i) {
        return To(e, t, B(i, 2), !0);
      }
      function Jg(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var a = si(e, t, !0) - 1;
          if (zt(e[a], t))
            return a;
        }
        return -1;
      }
      function Zg(e) {
        return e && e.length ? Na(e) : [];
      }
      function jg(e, t) {
        return e && e.length ? Na(e, B(t, 2)) : [];
      }
      function eh(e) {
        var t = e == null ? 0 : e.length;
        return t ? pt(e, 1, t) : [];
      }
      function th(e, t, i) {
        return e && e.length ? (t = i || t === n ? 1 : q(t), pt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function rh(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : q(t), t = a - t, pt(e, t < 0 ? 0 : t, a)) : [];
      }
      function nh(e, t) {
        return e && e.length ? ai(e, B(t, 3), !1, !0) : [];
      }
      function ih(e, t) {
        return e && e.length ? ai(e, B(t, 3)) : [];
      }
      var oh = Z(function(e) {
        return rr(Fe(e, 1, Te, !0));
      }), sh = Z(function(e) {
        var t = bt(e);
        return Te(t) && (t = n), rr(Fe(e, 1, Te, !0), B(t, 2));
      }), ah = Z(function(e) {
        var t = bt(e);
        return t = typeof t == "function" ? t : n, rr(Fe(e, 1, Te, !0), n, t);
      });
      function lh(e) {
        return e && e.length ? rr(e) : [];
      }
      function uh(e, t) {
        return e && e.length ? rr(e, B(t, 2)) : [];
      }
      function ch(e, t) {
        return t = typeof t == "function" ? t : n, e && e.length ? rr(e, n, t) : [];
      }
      function Go(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = Jt(e, function(i) {
          if (Te(i))
            return t = Ee(i.length, t), !0;
        }), lo(t, function(i) {
          return ye(e, oo(i));
        });
      }
      function zl(e, t) {
        if (!(e && e.length))
          return [];
        var i = Go(e);
        return t == null ? i : ye(i, function(a) {
          return rt(t, n, a);
        });
      }
      var fh = Z(function(e, t) {
        return Te(e) ? mn(e, t) : [];
      }), dh = Z(function(e) {
        return Do(Jt(e, Te));
      }), gh = Z(function(e) {
        var t = bt(e);
        return Te(t) && (t = n), Do(Jt(e, Te), B(t, 2));
      }), hh = Z(function(e) {
        var t = bt(e);
        return t = typeof t == "function" ? t : n, Do(Jt(e, Te), n, t);
      }), mh = Z(Go);
      function ph(e, t) {
        return Ya(e || [], t || [], hn);
      }
      function bh(e, t) {
        return Ya(e || [], t || [], vn);
      }
      var vh = Z(function(e) {
        var t = e.length, i = t > 1 ? e[t - 1] : n;
        return i = typeof i == "function" ? (e.pop(), i) : n, zl(e, i);
      });
      function Sl(e) {
        var t = f(e);
        return t.__chain__ = !0, t;
      }
      function wh(e, t) {
        return t(e), e;
      }
      function pi(e, t) {
        return t(e);
      }
      var yh = Ut(function(e) {
        var t = e.length, i = t ? e[0] : 0, a = this.__wrapped__, u = function(d) {
          return bo(d, e);
        };
        return t > 1 || this.__actions__.length || !(a instanceof ee) || !$t(i) ? this.thru(u) : (a = a.slice(i, +i + (t ? 1 : 0)), a.__actions__.push({
          func: pi,
          args: [u],
          thisArg: n
        }), new ht(a, this.__chain__).thru(function(d) {
          return t && !d.length && d.push(n), d;
        }));
      });
      function xh() {
        return Sl(this);
      }
      function _h() {
        return new ht(this.value(), this.__chain__);
      }
      function Ch() {
        this.__values__ === n && (this.__values__ = Ul(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? n : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function kh() {
        return this;
      }
      function Mh(e) {
        for (var t, i = this; i instanceof ti; ) {
          var a = yl(i);
          a.__index__ = 0, a.__values__ = n, t ? u.__wrapped__ = a : t = a;
          var u = a;
          i = i.__wrapped__;
        }
        return u.__wrapped__ = e, t;
      }
      function zh() {
        var e = this.__wrapped__;
        if (e instanceof ee) {
          var t = e;
          return this.__actions__.length && (t = new ee(this)), t = t.reverse(), t.__actions__.push({
            func: pi,
            args: [Vo],
            thisArg: n
          }), new ht(t, this.__chain__);
        }
        return this.thru(Vo);
      }
      function Sh() {
        return Ha(this.__wrapped__, this.__actions__);
      }
      var Th = li(function(e, t, i) {
        ue.call(e, i) ? ++e[i] : Ft(e, i, 1);
      });
      function Oh(e, t, i) {
        var a = V(e) ? ra : wd;
        return i && Xe(e, t, i) && (t = n), a(e, B(t, 3));
      }
      function Dh(e, t) {
        var i = V(e) ? Jt : za;
        return i(e, B(t, 3));
      }
      var Lh = el(xl), Ah = el(_l);
      function Eh(e, t) {
        return Fe(bi(e, t), 1);
      }
      function Ih(e, t) {
        return Fe(bi(e, t), Ge);
      }
      function Rh(e, t, i) {
        return i = i === n ? 1 : q(i), Fe(bi(e, t), i);
      }
      function Tl(e, t) {
        var i = V(e) ? dt : tr;
        return i(e, B(t, 3));
      }
      function Ol(e, t) {
        var i = V(e) ? jc : Ma;
        return i(e, B(t, 3));
      }
      var Ph = li(function(e, t, i) {
        ue.call(e, i) ? e[i].push(t) : Ft(e, i, [t]);
      });
      function Wh(e, t, i, a) {
        e = Ze(e) ? e : Gr(e), i = i && !a ? q(i) : 0;
        var u = e.length;
        return i < 0 && (i = Ee(u + i, 0)), _i(e) ? i <= u && e.indexOf(t, i) > -1 : !!u && Ir(e, t, i) > -1;
      }
      var Bh = Z(function(e, t, i) {
        var a = -1, u = typeof t == "function", d = Ze(e) ? _(e.length) : [];
        return tr(e, function(m) {
          d[++a] = u ? rt(t, m, i) : pn(m, t, i);
        }), d;
      }), Fh = li(function(e, t, i) {
        Ft(e, i, t);
      });
      function bi(e, t) {
        var i = V(e) ? ye : Aa;
        return i(e, B(t, 3));
      }
      function Nh(e, t, i, a) {
        return e == null ? [] : (V(t) || (t = t == null ? [] : [t]), i = a ? n : i, V(i) || (i = i == null ? [] : [i]), Pa(e, t, i));
      }
      var Uh = li(function(e, t, i) {
        e[i ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function $h(e, t, i) {
        var a = V(e) ? no : sa, u = arguments.length < 3;
        return a(e, B(t, 4), i, u, tr);
      }
      function Hh(e, t, i) {
        var a = V(e) ? ef : sa, u = arguments.length < 3;
        return a(e, B(t, 4), i, u, Ma);
      }
      function Yh(e, t) {
        var i = V(e) ? Jt : za;
        return i(e, yi(B(t, 3)));
      }
      function Vh(e) {
        var t = V(e) ? xa : Wd;
        return t(e);
      }
      function Gh(e, t, i) {
        (i ? Xe(e, t, i) : t === n) ? t = 1 : t = q(t);
        var a = V(e) ? hd : Bd;
        return a(e, t);
      }
      function qh(e) {
        var t = V(e) ? md : Nd;
        return t(e);
      }
      function Xh(e) {
        if (e == null)
          return 0;
        if (Ze(e))
          return _i(e) ? Pr(e) : e.length;
        var t = He(e);
        return t == _t || t == Ct ? e.size : Co(e).length;
      }
      function Kh(e, t, i) {
        var a = V(e) ? io : Ud;
        return i && Xe(e, t, i) && (t = n), a(e, B(t, 3));
      }
      var Qh = Z(function(e, t) {
        if (e == null)
          return [];
        var i = t.length;
        return i > 1 && Xe(e, t[0], t[1]) ? t = [] : i > 2 && Xe(t[0], t[1], t[2]) && (t = [t[0]]), Pa(e, Fe(t, 1), []);
      }), vi = Df || function() {
        return Be.Date.now();
      };
      function Jh(e, t) {
        if (typeof t != "function")
          throw new gt(g);
        return e = q(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function Dl(e, t, i) {
        return t = i ? n : t, t = e && t == null ? e.length : t, Nt(e, J, n, n, n, n, t);
      }
      function Ll(e, t) {
        var i;
        if (typeof t != "function")
          throw new gt(g);
        return e = q(e), function() {
          return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
        };
      }
      var qo = Z(function(e, t, i) {
        var a = F;
        if (i.length) {
          var u = jt(i, Yr(qo));
          a |= de;
        }
        return Nt(e, a, t, i, u);
      }), Al = Z(function(e, t, i) {
        var a = F | H;
        if (i.length) {
          var u = jt(i, Yr(Al));
          a |= de;
        }
        return Nt(t, a, e, i, u);
      });
      function El(e, t, i) {
        t = i ? n : t;
        var a = Nt(e, oe, n, n, n, n, n, t);
        return a.placeholder = El.placeholder, a;
      }
      function Il(e, t, i) {
        t = i ? n : t;
        var a = Nt(e, ke, n, n, n, n, n, t);
        return a.placeholder = Il.placeholder, a;
      }
      function Rl(e, t, i) {
        var a, u, d, m, p, v, k = 0, M = !1, S = !1, A = !0;
        if (typeof e != "function")
          throw new gt(g);
        t = vt(t) || 0, Ce(i) && (M = !!i.leading, S = "maxWait" in i, d = S ? Ee(vt(i.maxWait) || 0, t) : d, A = "trailing" in i ? !!i.trailing : A);
        function P(Oe) {
          var St = a, Vt = u;
          return a = u = n, k = Oe, m = e.apply(Vt, St), m;
        }
        function N(Oe) {
          return k = Oe, p = xn(j, t), M ? P(Oe) : m;
        }
        function Q(Oe) {
          var St = Oe - v, Vt = Oe - k, eu = t - St;
          return S ? $e(eu, d - Vt) : eu;
        }
        function U(Oe) {
          var St = Oe - v, Vt = Oe - k;
          return v === n || St >= t || St < 0 || S && Vt >= d;
        }
        function j() {
          var Oe = vi();
          if (U(Oe))
            return re(Oe);
          p = xn(j, Q(Oe));
        }
        function re(Oe) {
          return p = n, A && a ? P(Oe) : (a = u = n, m);
        }
        function st() {
          p !== n && Va(p), k = 0, a = v = u = p = n;
        }
        function Ke() {
          return p === n ? m : re(vi());
        }
        function at() {
          var Oe = vi(), St = U(Oe);
          if (a = arguments, u = this, v = Oe, St) {
            if (p === n)
              return N(v);
            if (S)
              return Va(p), p = xn(j, t), P(v);
          }
          return p === n && (p = xn(j, t)), m;
        }
        return at.cancel = st, at.flush = Ke, at;
      }
      var Zh = Z(function(e, t) {
        return ka(e, 1, t);
      }), jh = Z(function(e, t, i) {
        return ka(e, vt(t) || 0, i);
      });
      function em(e) {
        return Nt(e, Qe);
      }
      function wi(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new gt(g);
        var i = function() {
          var a = arguments, u = t ? t.apply(this, a) : a[0], d = i.cache;
          if (d.has(u))
            return d.get(u);
          var m = e.apply(this, a);
          return i.cache = d.set(u, m) || d, m;
        };
        return i.cache = new (wi.Cache || Bt)(), i;
      }
      wi.Cache = Bt;
      function yi(e) {
        if (typeof e != "function")
          throw new gt(g);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function tm(e) {
        return Ll(2, e);
      }
      var rm = $d(function(e, t) {
        t = t.length == 1 && V(t[0]) ? ye(t[0], nt(B())) : ye(Fe(t, 1), nt(B()));
        var i = t.length;
        return Z(function(a) {
          for (var u = -1, d = $e(a.length, i); ++u < d; )
            a[u] = t[u].call(this, a[u]);
          return rt(e, this, a);
        });
      }), Xo = Z(function(e, t) {
        var i = jt(t, Yr(Xo));
        return Nt(e, de, n, t, i);
      }), Pl = Z(function(e, t) {
        var i = jt(t, Yr(Pl));
        return Nt(e, Se, n, t, i);
      }), nm = Ut(function(e, t) {
        return Nt(e, Ye, n, n, n, t);
      });
      function im(e, t) {
        if (typeof e != "function")
          throw new gt(g);
        return t = t === n ? t : q(t), Z(e, t);
      }
      function om(e, t) {
        if (typeof e != "function")
          throw new gt(g);
        return t = t == null ? 0 : Ee(q(t), 0), Z(function(i) {
          var a = i[t], u = ir(i, 0, t);
          return a && Zt(u, a), rt(e, this, u);
        });
      }
      function sm(e, t, i) {
        var a = !0, u = !0;
        if (typeof e != "function")
          throw new gt(g);
        return Ce(i) && (a = "leading" in i ? !!i.leading : a, u = "trailing" in i ? !!i.trailing : u), Rl(e, t, {
          leading: a,
          maxWait: t,
          trailing: u
        });
      }
      function am(e) {
        return Dl(e, 1);
      }
      function lm(e, t) {
        return Xo(Ao(t), e);
      }
      function um() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return V(e) ? e : [e];
      }
      function cm(e) {
        return mt(e, E);
      }
      function fm(e, t) {
        return t = typeof t == "function" ? t : n, mt(e, E, t);
      }
      function dm(e) {
        return mt(e, O | E);
      }
      function gm(e, t) {
        return t = typeof t == "function" ? t : n, mt(e, O | E, t);
      }
      function hm(e, t) {
        return t == null || Ca(e, t, Pe(t));
      }
      function zt(e, t) {
        return e === t || e !== e && t !== t;
      }
      var mm = di(yo), pm = di(function(e, t) {
        return e >= t;
      }), Cr = Oa(function() {
        return arguments;
      }()) ? Oa : function(e) {
        return Me(e) && ue.call(e, "callee") && !ma.call(e, "callee");
      }, V = _.isArray, bm = Qs ? nt(Qs) : Md;
      function Ze(e) {
        return e != null && xi(e.length) && !Ht(e);
      }
      function Te(e) {
        return Me(e) && Ze(e);
      }
      function vm(e) {
        return e === !0 || e === !1 || Me(e) && qe(e) == en;
      }
      var or = Af || os, wm = Js ? nt(Js) : zd;
      function ym(e) {
        return Me(e) && e.nodeType === 1 && !_n(e);
      }
      function xm(e) {
        if (e == null)
          return !0;
        if (Ze(e) && (V(e) || typeof e == "string" || typeof e.splice == "function" || or(e) || Vr(e) || Cr(e)))
          return !e.length;
        var t = He(e);
        if (t == _t || t == Ct)
          return !e.size;
        if (yn(e))
          return !Co(e).length;
        for (var i in e)
          if (ue.call(e, i))
            return !1;
        return !0;
      }
      function _m(e, t) {
        return bn(e, t);
      }
      function Cm(e, t, i) {
        i = typeof i == "function" ? i : n;
        var a = i ? i(e, t) : n;
        return a === n ? bn(e, t, n, i) : !!a;
      }
      function Ko(e) {
        if (!Me(e))
          return !1;
        var t = qe(e);
        return t == En || t == Vu || typeof e.message == "string" && typeof e.name == "string" && !_n(e);
      }
      function km(e) {
        return typeof e == "number" && ba(e);
      }
      function Ht(e) {
        if (!Ce(e))
          return !1;
        var t = qe(e);
        return t == In || t == ks || t == Yu || t == qu;
      }
      function Wl(e) {
        return typeof e == "number" && e == q(e);
      }
      function xi(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ct;
      }
      function Ce(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function Me(e) {
        return e != null && typeof e == "object";
      }
      var Bl = Zs ? nt(Zs) : Td;
      function Mm(e, t) {
        return e === t || _o(e, t, Fo(t));
      }
      function zm(e, t, i) {
        return i = typeof i == "function" ? i : n, _o(e, t, Fo(t), i);
      }
      function Sm(e) {
        return Fl(e) && e != +e;
      }
      function Tm(e) {
        if (fg(e))
          throw new Y(c);
        return Da(e);
      }
      function Om(e) {
        return e === null;
      }
      function Dm(e) {
        return e == null;
      }
      function Fl(e) {
        return typeof e == "number" || Me(e) && qe(e) == rn;
      }
      function _n(e) {
        if (!Me(e) || qe(e) != Pt)
          return !1;
        var t = Xn(e);
        if (t === null)
          return !0;
        var i = ue.call(t, "constructor") && t.constructor;
        return typeof i == "function" && i instanceof i && Yn.call(i) == zf;
      }
      var Qo = js ? nt(js) : Od;
      function Lm(e) {
        return Wl(e) && e >= -ct && e <= ct;
      }
      var Nl = ea ? nt(ea) : Dd;
      function _i(e) {
        return typeof e == "string" || !V(e) && Me(e) && qe(e) == on;
      }
      function ot(e) {
        return typeof e == "symbol" || Me(e) && qe(e) == Rn;
      }
      var Vr = ta ? nt(ta) : Ld;
      function Am(e) {
        return e === n;
      }
      function Em(e) {
        return Me(e) && He(e) == sn;
      }
      function Im(e) {
        return Me(e) && qe(e) == Ku;
      }
      var Rm = di(ko), Pm = di(function(e, t) {
        return e <= t;
      });
      function Ul(e) {
        if (!e)
          return [];
        if (Ze(e))
          return _i(e) ? kt(e) : Je(e);
        if (un && e[un])
          return hf(e[un]());
        var t = He(e), i = t == _t ? co : t == Ct ? Un : Gr;
        return i(e);
      }
      function Yt(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = vt(e), e === Ge || e === -Ge) {
          var t = e < 0 ? -1 : 1;
          return t * gr;
        }
        return e === e ? e : 0;
      }
      function q(e) {
        var t = Yt(e), i = t % 1;
        return t === t ? i ? t - i : t : 0;
      }
      function $l(e) {
        return e ? wr(q(e), 0, Ue) : 0;
      }
      function vt(e) {
        if (typeof e == "number")
          return e;
        if (ot(e))
          return hr;
        if (Ce(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = Ce(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = aa(e);
        var i = pc.test(e);
        return i || vc.test(e) ? Qc(e.slice(2), i ? 2 : 8) : mc.test(e) ? hr : +e;
      }
      function Hl(e) {
        return Dt(e, je(e));
      }
      function Wm(e) {
        return e ? wr(q(e), -ct, ct) : e === 0 ? e : 0;
      }
      function ae(e) {
        return e == null ? "" : it(e);
      }
      var Bm = $r(function(e, t) {
        if (yn(t) || Ze(t)) {
          Dt(t, Pe(t), e);
          return;
        }
        for (var i in t)
          ue.call(t, i) && hn(e, i, t[i]);
      }), Yl = $r(function(e, t) {
        Dt(t, je(t), e);
      }), Ci = $r(function(e, t, i, a) {
        Dt(t, je(t), e, a);
      }), Fm = $r(function(e, t, i, a) {
        Dt(t, Pe(t), e, a);
      }), Nm = Ut(bo);
      function Um(e, t) {
        var i = Ur(e);
        return t == null ? i : _a(i, t);
      }
      var $m = Z(function(e, t) {
        e = he(e);
        var i = -1, a = t.length, u = a > 2 ? t[2] : n;
        for (u && Xe(t[0], t[1], u) && (a = 1); ++i < a; )
          for (var d = t[i], m = je(d), p = -1, v = m.length; ++p < v; ) {
            var k = m[p], M = e[k];
            (M === n || zt(M, Br[k]) && !ue.call(e, k)) && (e[k] = d[k]);
          }
        return e;
      }), Hm = Z(function(e) {
        return e.push(n, al), rt(Vl, n, e);
      });
      function Ym(e, t) {
        return na(e, B(t, 3), Ot);
      }
      function Vm(e, t) {
        return na(e, B(t, 3), wo);
      }
      function Gm(e, t) {
        return e == null ? e : vo(e, B(t, 3), je);
      }
      function qm(e, t) {
        return e == null ? e : Sa(e, B(t, 3), je);
      }
      function Xm(e, t) {
        return e && Ot(e, B(t, 3));
      }
      function Km(e, t) {
        return e && wo(e, B(t, 3));
      }
      function Qm(e) {
        return e == null ? [] : ii(e, Pe(e));
      }
      function Jm(e) {
        return e == null ? [] : ii(e, je(e));
      }
      function Jo(e, t, i) {
        var a = e == null ? n : yr(e, t);
        return a === n ? i : a;
      }
      function Zm(e, t) {
        return e != null && cl(e, t, xd);
      }
      function Zo(e, t) {
        return e != null && cl(e, t, _d);
      }
      var jm = rl(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = Vn.call(t)), e[t] = i;
      }, es(et)), e0 = rl(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = Vn.call(t)), ue.call(e, t) ? e[t].push(i) : e[t] = [i];
      }, B), t0 = Z(pn);
      function Pe(e) {
        return Ze(e) ? ya(e) : Co(e);
      }
      function je(e) {
        return Ze(e) ? ya(e, !0) : Ad(e);
      }
      function r0(e, t) {
        var i = {};
        return t = B(t, 3), Ot(e, function(a, u, d) {
          Ft(i, t(a, u, d), a);
        }), i;
      }
      function n0(e, t) {
        var i = {};
        return t = B(t, 3), Ot(e, function(a, u, d) {
          Ft(i, u, t(a, u, d));
        }), i;
      }
      var i0 = $r(function(e, t, i) {
        oi(e, t, i);
      }), Vl = $r(function(e, t, i, a) {
        oi(e, t, i, a);
      }), o0 = Ut(function(e, t) {
        var i = {};
        if (e == null)
          return i;
        var a = !1;
        t = ye(t, function(d) {
          return d = nr(d, e), a || (a = d.length > 1), d;
        }), Dt(e, Wo(e), i), a && (i = mt(i, O | R | E, jd));
        for (var u = t.length; u--; )
          Oo(i, t[u]);
        return i;
      });
      function s0(e, t) {
        return Gl(e, yi(B(t)));
      }
      var a0 = Ut(function(e, t) {
        return e == null ? {} : Id(e, t);
      });
      function Gl(e, t) {
        if (e == null)
          return {};
        var i = ye(Wo(e), function(a) {
          return [a];
        });
        return t = B(t), Wa(e, i, function(a, u) {
          return t(a, u[0]);
        });
      }
      function l0(e, t, i) {
        t = nr(t, e);
        var a = -1, u = t.length;
        for (u || (u = 1, e = n); ++a < u; ) {
          var d = e == null ? n : e[Lt(t[a])];
          d === n && (a = u, d = i), e = Ht(d) ? d.call(e) : d;
        }
        return e;
      }
      function u0(e, t, i) {
        return e == null ? e : vn(e, t, i);
      }
      function c0(e, t, i, a) {
        return a = typeof a == "function" ? a : n, e == null ? e : vn(e, t, i, a);
      }
      var ql = ol(Pe), Xl = ol(je);
      function f0(e, t, i) {
        var a = V(e), u = a || or(e) || Vr(e);
        if (t = B(t, 4), i == null) {
          var d = e && e.constructor;
          u ? i = a ? new d() : [] : Ce(e) ? i = Ht(d) ? Ur(Xn(e)) : {} : i = {};
        }
        return (u ? dt : Ot)(e, function(m, p, v) {
          return t(i, m, p, v);
        }), i;
      }
      function d0(e, t) {
        return e == null ? !0 : Oo(e, t);
      }
      function g0(e, t, i) {
        return e == null ? e : $a(e, t, Ao(i));
      }
      function h0(e, t, i, a) {
        return a = typeof a == "function" ? a : n, e == null ? e : $a(e, t, Ao(i), a);
      }
      function Gr(e) {
        return e == null ? [] : uo(e, Pe(e));
      }
      function m0(e) {
        return e == null ? [] : uo(e, je(e));
      }
      function p0(e, t, i) {
        return i === n && (i = t, t = n), i !== n && (i = vt(i), i = i === i ? i : 0), t !== n && (t = vt(t), t = t === t ? t : 0), wr(vt(e), t, i);
      }
      function b0(e, t, i) {
        return t = Yt(t), i === n ? (i = t, t = 0) : i = Yt(i), e = vt(e), Cd(e, t, i);
      }
      function v0(e, t, i) {
        if (i && typeof i != "boolean" && Xe(e, t, i) && (t = i = n), i === n && (typeof t == "boolean" ? (i = t, t = n) : typeof e == "boolean" && (i = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = Yt(e), t === n ? (t = e, e = 0) : t = Yt(t)), e > t) {
          var a = e;
          e = t, t = a;
        }
        if (i || e % 1 || t % 1) {
          var u = va();
          return $e(e + u * (t - e + Kc("1e-" + ((u + "").length - 1))), t);
        }
        return zo(e, t);
      }
      var w0 = Hr(function(e, t, i) {
        return t = t.toLowerCase(), e + (i ? Kl(t) : t);
      });
      function Kl(e) {
        return jo(ae(e).toLowerCase());
      }
      function Ql(e) {
        return e = ae(e), e && e.replace(yc, uf).replace(Fc, "");
      }
      function y0(e, t, i) {
        e = ae(e), t = it(t);
        var a = e.length;
        i = i === n ? a : wr(q(i), 0, a);
        var u = i;
        return i -= t.length, i >= 0 && e.slice(i, u) == t;
      }
      function x0(e) {
        return e = ae(e), e && ec.test(e) ? e.replace(Ss, cf) : e;
      }
      function _0(e) {
        return e = ae(e), e && sc.test(e) ? e.replace(qi, "\\$&") : e;
      }
      var C0 = Hr(function(e, t, i) {
        return e + (i ? "-" : "") + t.toLowerCase();
      }), k0 = Hr(function(e, t, i) {
        return e + (i ? " " : "") + t.toLowerCase();
      }), M0 = ja("toLowerCase");
      function z0(e, t, i) {
        e = ae(e), t = q(t);
        var a = t ? Pr(e) : 0;
        if (!t || a >= t)
          return e;
        var u = (t - a) / 2;
        return fi(Zn(u), i) + e + fi(Jn(u), i);
      }
      function S0(e, t, i) {
        e = ae(e), t = q(t);
        var a = t ? Pr(e) : 0;
        return t && a < t ? e + fi(t - a, i) : e;
      }
      function T0(e, t, i) {
        e = ae(e), t = q(t);
        var a = t ? Pr(e) : 0;
        return t && a < t ? fi(t - a, i) + e : e;
      }
      function O0(e, t, i) {
        return i || t == null ? t = 0 : t && (t = +t), Pf(ae(e).replace(Xi, ""), t || 0);
      }
      function D0(e, t, i) {
        return (i ? Xe(e, t, i) : t === n) ? t = 1 : t = q(t), So(ae(e), t);
      }
      function L0() {
        var e = arguments, t = ae(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var A0 = Hr(function(e, t, i) {
        return e + (i ? "_" : "") + t.toLowerCase();
      });
      function E0(e, t, i) {
        return i && typeof i != "number" && Xe(e, t, i) && (t = i = n), i = i === n ? Ue : i >>> 0, i ? (e = ae(e), e && (typeof t == "string" || t != null && !Qo(t)) && (t = it(t), !t && Rr(e)) ? ir(kt(e), 0, i) : e.split(t, i)) : [];
      }
      var I0 = Hr(function(e, t, i) {
        return e + (i ? " " : "") + jo(t);
      });
      function R0(e, t, i) {
        return e = ae(e), i = i == null ? 0 : wr(q(i), 0, e.length), t = it(t), e.slice(i, i + t.length) == t;
      }
      function P0(e, t, i) {
        var a = f.templateSettings;
        i && Xe(e, t, i) && (t = n), e = ae(e), t = Ci({}, t, a, sl);
        var u = Ci({}, t.imports, a.imports, sl), d = Pe(u), m = uo(u, d), p, v, k = 0, M = t.interpolate || Pn, S = "__p += '", A = fo(
          (t.escape || Pn).source + "|" + M.source + "|" + (M === Ts ? hc : Pn).source + "|" + (t.evaluate || Pn).source + "|$",
          "g"
        ), P = "//# sourceURL=" + (ue.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Yc + "]") + `
`;
        e.replace(A, function(U, j, re, st, Ke, at) {
          return re || (re = st), S += e.slice(k, at).replace(xc, ff), j && (p = !0, S += `' +
__e(` + j + `) +
'`), Ke && (v = !0, S += `';
` + Ke + `;
__p += '`), re && (S += `' +
((__t = (` + re + `)) == null ? '' : __t) +
'`), k = at + U.length, U;
        }), S += `';
`;
        var N = ue.call(t, "variable") && t.variable;
        if (!N)
          S = `with (obj) {
` + S + `
}
`;
        else if (dc.test(N))
          throw new Y(h);
        S = (v ? S.replace(Qu, "") : S).replace(Ju, "$1").replace(Zu, "$1;"), S = "function(" + (N || "obj") + `) {
` + (N ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (p ? ", __e = _.escape" : "") + (v ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + S + `return __p
}`;
        var Q = Zl(function() {
          return se(d, P + "return " + S).apply(n, m);
        });
        if (Q.source = S, Ko(Q))
          throw Q;
        return Q;
      }
      function W0(e) {
        return ae(e).toLowerCase();
      }
      function B0(e) {
        return ae(e).toUpperCase();
      }
      function F0(e, t, i) {
        if (e = ae(e), e && (i || t === n))
          return aa(e);
        if (!e || !(t = it(t)))
          return e;
        var a = kt(e), u = kt(t), d = la(a, u), m = ua(a, u) + 1;
        return ir(a, d, m).join("");
      }
      function N0(e, t, i) {
        if (e = ae(e), e && (i || t === n))
          return e.slice(0, fa(e) + 1);
        if (!e || !(t = it(t)))
          return e;
        var a = kt(e), u = ua(a, kt(t)) + 1;
        return ir(a, 0, u).join("");
      }
      function U0(e, t, i) {
        if (e = ae(e), e && (i || t === n))
          return e.replace(Xi, "");
        if (!e || !(t = it(t)))
          return e;
        var a = kt(e), u = la(a, kt(t));
        return ir(a, u).join("");
      }
      function $0(e, t) {
        var i = Tt, a = dr;
        if (Ce(t)) {
          var u = "separator" in t ? t.separator : u;
          i = "length" in t ? q(t.length) : i, a = "omission" in t ? it(t.omission) : a;
        }
        e = ae(e);
        var d = e.length;
        if (Rr(e)) {
          var m = kt(e);
          d = m.length;
        }
        if (i >= d)
          return e;
        var p = i - Pr(a);
        if (p < 1)
          return a;
        var v = m ? ir(m, 0, p).join("") : e.slice(0, p);
        if (u === n)
          return v + a;
        if (m && (p += v.length - p), Qo(u)) {
          if (e.slice(p).search(u)) {
            var k, M = v;
            for (u.global || (u = fo(u.source, ae(Os.exec(u)) + "g")), u.lastIndex = 0; k = u.exec(M); )
              var S = k.index;
            v = v.slice(0, S === n ? p : S);
          }
        } else if (e.indexOf(it(u), p) != p) {
          var A = v.lastIndexOf(u);
          A > -1 && (v = v.slice(0, A));
        }
        return v + a;
      }
      function H0(e) {
        return e = ae(e), e && ju.test(e) ? e.replace(zs, vf) : e;
      }
      var Y0 = Hr(function(e, t, i) {
        return e + (i ? " " : "") + t.toUpperCase();
      }), jo = ja("toUpperCase");
      function Jl(e, t, i) {
        return e = ae(e), t = i ? n : t, t === n ? gf(e) ? xf(e) : nf(e) : e.match(t) || [];
      }
      var Zl = Z(function(e, t) {
        try {
          return rt(e, n, t);
        } catch (i) {
          return Ko(i) ? i : new Y(i);
        }
      }), V0 = Ut(function(e, t) {
        return dt(t, function(i) {
          i = Lt(i), Ft(e, i, qo(e[i], e));
        }), e;
      });
      function G0(e) {
        var t = e == null ? 0 : e.length, i = B();
        return e = t ? ye(e, function(a) {
          if (typeof a[1] != "function")
            throw new gt(g);
          return [i(a[0]), a[1]];
        }) : [], Z(function(a) {
          for (var u = -1; ++u < t; ) {
            var d = e[u];
            if (rt(d[0], this, a))
              return rt(d[1], this, a);
          }
        });
      }
      function q0(e) {
        return vd(mt(e, O));
      }
      function es(e) {
        return function() {
          return e;
        };
      }
      function X0(e, t) {
        return e == null || e !== e ? t : e;
      }
      var K0 = tl(), Q0 = tl(!0);
      function et(e) {
        return e;
      }
      function ts(e) {
        return La(typeof e == "function" ? e : mt(e, O));
      }
      function J0(e) {
        return Ea(mt(e, O));
      }
      function Z0(e, t) {
        return Ia(e, mt(t, O));
      }
      var j0 = Z(function(e, t) {
        return function(i) {
          return pn(i, e, t);
        };
      }), ep = Z(function(e, t) {
        return function(i) {
          return pn(e, i, t);
        };
      });
      function rs(e, t, i) {
        var a = Pe(t), u = ii(t, a);
        i == null && !(Ce(t) && (u.length || !a.length)) && (i = t, t = e, e = this, u = ii(t, Pe(t)));
        var d = !(Ce(i) && "chain" in i) || !!i.chain, m = Ht(e);
        return dt(u, function(p) {
          var v = t[p];
          e[p] = v, m && (e.prototype[p] = function() {
            var k = this.__chain__;
            if (d || k) {
              var M = e(this.__wrapped__), S = M.__actions__ = Je(this.__actions__);
              return S.push({ func: v, args: arguments, thisArg: e }), M.__chain__ = k, M;
            }
            return v.apply(e, Zt([this.value()], arguments));
          });
        }), e;
      }
      function tp() {
        return Be._ === this && (Be._ = Sf), this;
      }
      function ns() {
      }
      function rp(e) {
        return e = q(e), Z(function(t) {
          return Ra(t, e);
        });
      }
      var np = Io(ye), ip = Io(ra), op = Io(io);
      function jl(e) {
        return Uo(e) ? oo(Lt(e)) : Rd(e);
      }
      function sp(e) {
        return function(t) {
          return e == null ? n : yr(e, t);
        };
      }
      var ap = nl(), lp = nl(!0);
      function is() {
        return [];
      }
      function os() {
        return !1;
      }
      function up() {
        return {};
      }
      function cp() {
        return "";
      }
      function fp() {
        return !0;
      }
      function dp(e, t) {
        if (e = q(e), e < 1 || e > ct)
          return [];
        var i = Ue, a = $e(e, Ue);
        t = B(t), e -= Ue;
        for (var u = lo(a, t); ++i < e; )
          t(i);
        return u;
      }
      function gp(e) {
        return V(e) ? ye(e, Lt) : ot(e) ? [e] : Je(wl(ae(e)));
      }
      function hp(e) {
        var t = ++Mf;
        return ae(e) + t;
      }
      var mp = ci(function(e, t) {
        return e + t;
      }, 0), pp = Ro("ceil"), bp = ci(function(e, t) {
        return e / t;
      }, 1), vp = Ro("floor");
      function wp(e) {
        return e && e.length ? ni(e, et, yo) : n;
      }
      function yp(e, t) {
        return e && e.length ? ni(e, B(t, 2), yo) : n;
      }
      function xp(e) {
        return oa(e, et);
      }
      function _p(e, t) {
        return oa(e, B(t, 2));
      }
      function Cp(e) {
        return e && e.length ? ni(e, et, ko) : n;
      }
      function kp(e, t) {
        return e && e.length ? ni(e, B(t, 2), ko) : n;
      }
      var Mp = ci(function(e, t) {
        return e * t;
      }, 1), zp = Ro("round"), Sp = ci(function(e, t) {
        return e - t;
      }, 0);
      function Tp(e) {
        return e && e.length ? ao(e, et) : 0;
      }
      function Op(e, t) {
        return e && e.length ? ao(e, B(t, 2)) : 0;
      }
      return f.after = Jh, f.ary = Dl, f.assign = Bm, f.assignIn = Yl, f.assignInWith = Ci, f.assignWith = Fm, f.at = Nm, f.before = Ll, f.bind = qo, f.bindAll = V0, f.bindKey = Al, f.castArray = um, f.chain = Sl, f.chunk = vg, f.compact = wg, f.concat = yg, f.cond = G0, f.conforms = q0, f.constant = es, f.countBy = Th, f.create = Um, f.curry = El, f.curryRight = Il, f.debounce = Rl, f.defaults = $m, f.defaultsDeep = Hm, f.defer = Zh, f.delay = jh, f.difference = xg, f.differenceBy = _g, f.differenceWith = Cg, f.drop = kg, f.dropRight = Mg, f.dropRightWhile = zg, f.dropWhile = Sg, f.fill = Tg, f.filter = Dh, f.flatMap = Eh, f.flatMapDeep = Ih, f.flatMapDepth = Rh, f.flatten = Cl, f.flattenDeep = Og, f.flattenDepth = Dg, f.flip = em, f.flow = K0, f.flowRight = Q0, f.fromPairs = Lg, f.functions = Qm, f.functionsIn = Jm, f.groupBy = Ph, f.initial = Eg, f.intersection = Ig, f.intersectionBy = Rg, f.intersectionWith = Pg, f.invert = jm, f.invertBy = e0, f.invokeMap = Bh, f.iteratee = ts, f.keyBy = Fh, f.keys = Pe, f.keysIn = je, f.map = bi, f.mapKeys = r0, f.mapValues = n0, f.matches = J0, f.matchesProperty = Z0, f.memoize = wi, f.merge = i0, f.mergeWith = Vl, f.method = j0, f.methodOf = ep, f.mixin = rs, f.negate = yi, f.nthArg = rp, f.omit = o0, f.omitBy = s0, f.once = tm, f.orderBy = Nh, f.over = np, f.overArgs = rm, f.overEvery = ip, f.overSome = op, f.partial = Xo, f.partialRight = Pl, f.partition = Uh, f.pick = a0, f.pickBy = Gl, f.property = jl, f.propertyOf = sp, f.pull = Ng, f.pullAll = Ml, f.pullAllBy = Ug, f.pullAllWith = $g, f.pullAt = Hg, f.range = ap, f.rangeRight = lp, f.rearg = nm, f.reject = Yh, f.remove = Yg, f.rest = im, f.reverse = Vo, f.sampleSize = Gh, f.set = u0, f.setWith = c0, f.shuffle = qh, f.slice = Vg, f.sortBy = Qh, f.sortedUniq = Zg, f.sortedUniqBy = jg, f.split = E0, f.spread = om, f.tail = eh, f.take = th, f.takeRight = rh, f.takeRightWhile = nh, f.takeWhile = ih, f.tap = wh, f.throttle = sm, f.thru = pi, f.toArray = Ul, f.toPairs = ql, f.toPairsIn = Xl, f.toPath = gp, f.toPlainObject = Hl, f.transform = f0, f.unary = am, f.union = oh, f.unionBy = sh, f.unionWith = ah, f.uniq = lh, f.uniqBy = uh, f.uniqWith = ch, f.unset = d0, f.unzip = Go, f.unzipWith = zl, f.update = g0, f.updateWith = h0, f.values = Gr, f.valuesIn = m0, f.without = fh, f.words = Jl, f.wrap = lm, f.xor = dh, f.xorBy = gh, f.xorWith = hh, f.zip = mh, f.zipObject = ph, f.zipObjectDeep = bh, f.zipWith = vh, f.entries = ql, f.entriesIn = Xl, f.extend = Yl, f.extendWith = Ci, rs(f, f), f.add = mp, f.attempt = Zl, f.camelCase = w0, f.capitalize = Kl, f.ceil = pp, f.clamp = p0, f.clone = cm, f.cloneDeep = dm, f.cloneDeepWith = gm, f.cloneWith = fm, f.conformsTo = hm, f.deburr = Ql, f.defaultTo = X0, f.divide = bp, f.endsWith = y0, f.eq = zt, f.escape = x0, f.escapeRegExp = _0, f.every = Oh, f.find = Lh, f.findIndex = xl, f.findKey = Ym, f.findLast = Ah, f.findLastIndex = _l, f.findLastKey = Vm, f.floor = vp, f.forEach = Tl, f.forEachRight = Ol, f.forIn = Gm, f.forInRight = qm, f.forOwn = Xm, f.forOwnRight = Km, f.get = Jo, f.gt = mm, f.gte = pm, f.has = Zm, f.hasIn = Zo, f.head = kl, f.identity = et, f.includes = Wh, f.indexOf = Ag, f.inRange = b0, f.invoke = t0, f.isArguments = Cr, f.isArray = V, f.isArrayBuffer = bm, f.isArrayLike = Ze, f.isArrayLikeObject = Te, f.isBoolean = vm, f.isBuffer = or, f.isDate = wm, f.isElement = ym, f.isEmpty = xm, f.isEqual = _m, f.isEqualWith = Cm, f.isError = Ko, f.isFinite = km, f.isFunction = Ht, f.isInteger = Wl, f.isLength = xi, f.isMap = Bl, f.isMatch = Mm, f.isMatchWith = zm, f.isNaN = Sm, f.isNative = Tm, f.isNil = Dm, f.isNull = Om, f.isNumber = Fl, f.isObject = Ce, f.isObjectLike = Me, f.isPlainObject = _n, f.isRegExp = Qo, f.isSafeInteger = Lm, f.isSet = Nl, f.isString = _i, f.isSymbol = ot, f.isTypedArray = Vr, f.isUndefined = Am, f.isWeakMap = Em, f.isWeakSet = Im, f.join = Wg, f.kebabCase = C0, f.last = bt, f.lastIndexOf = Bg, f.lowerCase = k0, f.lowerFirst = M0, f.lt = Rm, f.lte = Pm, f.max = wp, f.maxBy = yp, f.mean = xp, f.meanBy = _p, f.min = Cp, f.minBy = kp, f.stubArray = is, f.stubFalse = os, f.stubObject = up, f.stubString = cp, f.stubTrue = fp, f.multiply = Mp, f.nth = Fg, f.noConflict = tp, f.noop = ns, f.now = vi, f.pad = z0, f.padEnd = S0, f.padStart = T0, f.parseInt = O0, f.random = v0, f.reduce = $h, f.reduceRight = Hh, f.repeat = D0, f.replace = L0, f.result = l0, f.round = zp, f.runInContext = b, f.sample = Vh, f.size = Xh, f.snakeCase = A0, f.some = Kh, f.sortedIndex = Gg, f.sortedIndexBy = qg, f.sortedIndexOf = Xg, f.sortedLastIndex = Kg, f.sortedLastIndexBy = Qg, f.sortedLastIndexOf = Jg, f.startCase = I0, f.startsWith = R0, f.subtract = Sp, f.sum = Tp, f.sumBy = Op, f.template = P0, f.times = dp, f.toFinite = Yt, f.toInteger = q, f.toLength = $l, f.toLower = W0, f.toNumber = vt, f.toSafeInteger = Wm, f.toString = ae, f.toUpper = B0, f.trim = F0, f.trimEnd = N0, f.trimStart = U0, f.truncate = $0, f.unescape = H0, f.uniqueId = hp, f.upperCase = Y0, f.upperFirst = jo, f.each = Tl, f.eachRight = Ol, f.first = kl, rs(f, function() {
        var e = {};
        return Ot(f, function(t, i) {
          ue.call(f.prototype, i) || (e[i] = t);
        }), e;
      }(), { chain: !1 }), f.VERSION = l, dt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        f[e].placeholder = f;
      }), dt(["drop", "take"], function(e, t) {
        ee.prototype[e] = function(i) {
          i = i === n ? 1 : Ee(q(i), 0);
          var a = this.__filtered__ && !t ? new ee(this) : this.clone();
          return a.__filtered__ ? a.__takeCount__ = $e(i, a.__takeCount__) : a.__views__.push({
            size: $e(i, Ue),
            type: e + (a.__dir__ < 0 ? "Right" : "")
          }), a;
        }, ee.prototype[e + "Right"] = function(i) {
          return this.reverse()[e](i).reverse();
        };
      }), dt(["filter", "map", "takeWhile"], function(e, t) {
        var i = t + 1, a = i == Rt || i == Ve;
        ee.prototype[e] = function(u) {
          var d = this.clone();
          return d.__iteratees__.push({
            iteratee: B(u, 3),
            type: i
          }), d.__filtered__ = d.__filtered__ || a, d;
        };
      }), dt(["head", "last"], function(e, t) {
        var i = "take" + (t ? "Right" : "");
        ee.prototype[e] = function() {
          return this[i](1).value()[0];
        };
      }), dt(["initial", "tail"], function(e, t) {
        var i = "drop" + (t ? "" : "Right");
        ee.prototype[e] = function() {
          return this.__filtered__ ? new ee(this) : this[i](1);
        };
      }), ee.prototype.compact = function() {
        return this.filter(et);
      }, ee.prototype.find = function(e) {
        return this.filter(e).head();
      }, ee.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, ee.prototype.invokeMap = Z(function(e, t) {
        return typeof e == "function" ? new ee(this) : this.map(function(i) {
          return pn(i, e, t);
        });
      }), ee.prototype.reject = function(e) {
        return this.filter(yi(B(e)));
      }, ee.prototype.slice = function(e, t) {
        e = q(e);
        var i = this;
        return i.__filtered__ && (e > 0 || t < 0) ? new ee(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), t !== n && (t = q(t), i = t < 0 ? i.dropRight(-t) : i.take(t - e)), i);
      }, ee.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, ee.prototype.toArray = function() {
        return this.take(Ue);
      }, Ot(ee.prototype, function(e, t) {
        var i = /^(?:filter|find|map|reject)|While$/.test(t), a = /^(?:head|last)$/.test(t), u = f[a ? "take" + (t == "last" ? "Right" : "") : t], d = a || /^find/.test(t);
        u && (f.prototype[t] = function() {
          var m = this.__wrapped__, p = a ? [1] : arguments, v = m instanceof ee, k = p[0], M = v || V(m), S = function(j) {
            var re = u.apply(f, Zt([j], p));
            return a && A ? re[0] : re;
          };
          M && i && typeof k == "function" && k.length != 1 && (v = M = !1);
          var A = this.__chain__, P = !!this.__actions__.length, N = d && !A, Q = v && !P;
          if (!d && M) {
            m = Q ? m : new ee(this);
            var U = e.apply(m, p);
            return U.__actions__.push({ func: pi, args: [S], thisArg: n }), new ht(U, A);
          }
          return N && Q ? e.apply(this, p) : (U = this.thru(S), N ? a ? U.value()[0] : U.value() : U);
        });
      }), dt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = $n[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
        f.prototype[e] = function() {
          var u = arguments;
          if (a && !this.__chain__) {
            var d = this.value();
            return t.apply(V(d) ? d : [], u);
          }
          return this[i](function(m) {
            return t.apply(V(m) ? m : [], u);
          });
        };
      }), Ot(ee.prototype, function(e, t) {
        var i = f[t];
        if (i) {
          var a = i.name + "";
          ue.call(Nr, a) || (Nr[a] = []), Nr[a].push({ name: t, func: i });
        }
      }), Nr[ui(n, H).name] = [{
        name: "wrapper",
        func: n
      }], ee.prototype.clone = Hf, ee.prototype.reverse = Yf, ee.prototype.value = Vf, f.prototype.at = yh, f.prototype.chain = xh, f.prototype.commit = _h, f.prototype.next = Ch, f.prototype.plant = Mh, f.prototype.reverse = zh, f.prototype.toJSON = f.prototype.valueOf = f.prototype.value = Sh, f.prototype.first = f.prototype.head, un && (f.prototype[un] = kh), f;
    }, Wr = _f();
    mr ? ((mr.exports = Wr)._ = Wr, eo._ = Wr) : Be._ = Wr;
  }).call(Sn);
})(Li, Li.exports);
var Gy = Li.exports;
const Uu = /* @__PURE__ */ Vy(Gy), qy = {
  name: "TableComponent",
  props: {
    columns: Array,
    rows: Array,
    limit: {
      type: Number,
      default: 20
    },
    columnOrder: Object,
    clientOffset: Number,
    serverPagination: Boolean,
    serverOffset: Number,
    disablePrev: Boolean,
    disableNext: Boolean
  },
  emits: ["changed", "offset-changed", "previous-page", "next-page", "order-changed"],
  data() {
    return {
      offset: 0,
      order: {
        column: null,
        direction: "asc"
      },
      twMerge: fe
    };
  },
  computed: {
    orderedRows() {
      var r, o;
      return !this.order.column || !((r = this.rows) != null && r.length) ? [] : Uu.orderBy(
        this.rows,
        [(n) => {
          var l;
          return n == null ? void 0 : n[(l = this.order) == null ? void 0 : l.column];
        }],
        [(o = this.order) == null ? void 0 : o.direction]
      );
    },
    columnsByKey() {
      return Object.fromEntries(this.columns.map((r) => [
        r.key,
        {
          ...r,
          ...r.sortable && {
            // eslint-disable-next-line no-nested-ternary
            orderIcon: this.order.column === r.key ? this.order.direction === "asc" ? "expand_less" : "expand_more" : "unfold_more"
          }
        }
      ]));
    },
    offsetStart() {
      var r;
      return this.serverPagination ? this.serverOffset : (r = this.orderedRows) != null && r.length ? this.offset + 1 : 0;
    },
    offsetEnd() {
      var o, n;
      if (this.serverPagination)
        return this.serverOffset + this.limit;
      const r = this.offset + this.limit;
      return ((o = this.orderedRows) == null ? void 0 : o.length) > r ? r : (n = this.orderedRows) == null ? void 0 : n.length;
    },
    isFirstPage() {
      return this.serverPagination ? this.disablePrev : this.orderedRows ? this.offset === 0 : !0;
    },
    isLastPage() {
      var r;
      return this.serverPagination ? this.disableNext : this.orderedRows ? this.offset + this.limit >= ((r = this.orderedRows) == null ? void 0 : r.length) : !0;
    },
    chunk() {
      return this.orderedRows.slice(this.offset, this.offsetEnd);
    }
  },
  watch: {
    columnOrder: {
      handler() {
        var r, o;
        (r = this.columnOrder) != null && r.column && this.columnOrder.column !== this.order.column && (this.order.column = this.columnOrder.column), (o = this.columnOrder) != null && o.direction && this.columnOrder.direction !== this.order.direction && (this.order.direction = this.columnOrder.direction);
      },
      deep: !0
    },
    rows: {
      handler() {
        var r, o;
        this.offset = this.clientOffset ?? 0, !(!((r = this.rows) != null && r.length) || !((o = this.chunk) != null && o.length)) && this.$emit("changed", this.chunk);
      },
      deep: !0
    },
    clientOffset: function() {
      this.offset !== this.clientOffset && (this.offset = this.clientOffset);
    },
    offset: function() {
      this.$emit("offset-changed", this.offset);
    }
  },
  mounted() {
    this.setOrder(), this.$emit("changed", this.chunk);
  },
  methods: {
    setOrder() {
      var n, l;
      if (!((n = this.columns) != null && n.length))
        return;
      const r = this.columns.findIndex((s) => s.order), o = this.columns[r];
      this.order.column = (o == null ? void 0 : o.key) ?? ((l = this.columns[0]) == null ? void 0 : l.key), this.order.direction = (o == null ? void 0 : o.orderDirection) === "desc" ? "desc" : "asc", this.$emit("order-changed", this.order);
    },
    prevPage() {
      if (!this.serverPagination) {
        this.offset -= this.limit, this.$emit("changed", this.chunk);
        return;
      }
      this.$emit("previous-page");
    },
    nextPage() {
      if (!this.serverPagination) {
        this.offset += this.limit, this.$emit("changed", this.chunk);
        return;
      }
      this.$emit("next-page");
    }
  }
}, Xy = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1), Ky = /* @__PURE__ */ D("div", { class: "flex-1" }, null, -1);
function Qy(r, o, n, l, s, c) {
  var w, x, z;
  const g = Ie("fs-alert"), h = Ie("fs-button");
  return (w = n.rows) != null && w.length ? (T(), L("div", {
    key: 1,
    class: y(s.twMerge(
      "flex flex-col rounded-lg overflow-hidden w-full",
      r.$attrs["container-class"]
    ))
  }, [
    D("div", {
      class: y(s.twMerge(
        "flex flex-row items-center mb-4",
        r.$attrs["controller-container-class"],
        r.$attrs["controller-container-before-class"]
      ))
    }, [
      K(r.$slots, "custom-controls-before"),
      Xy,
      D("div", {
        class: y(s.twMerge(
          "flex flex-row justify-end items-center",
          r.$attrs["controller-content-class"],
          r.$attrs["controller-content-before-class"]
        ))
      }, [
        D("div", {
          class: y(s.twMerge(
            "font-semibold mr-4",
            r.$attrs["controller-page-info-class"],
            r.$attrs["controller-page-info-before-class"]
          ))
        }, [
          xe(G(c.offsetStart) + "-" + G(c.offsetEnd) + " ", 1),
          n.serverPagination ? me("", !0) : (T(), L(ne, { key: 0 }, [
            xe(" of " + G(n.serverPagination ? null : `${(x = c.orderedRows) == null ? void 0 : x.length}`), 1)
          ], 64))
        ], 2),
        ze(h, {
          type: "text",
          color: "black",
          icon: "chevron_left",
          class: y(s.twMerge(
            "mr-4",
            r.$attrs["controller-page-previous-button-class"],
            r.$attrs["controller-page-previous-button-before-class"]
          )),
          disabled: c.isFirstPage,
          onClick: c.prevPage
        }, null, 8, ["class", "disabled", "onClick"]),
        ze(h, {
          type: "text",
          color: "black",
          icon: "chevron_right",
          class: y(s.twMerge(
            r.$attrs["controller-page-next-button-class"],
            r.$attrs["controller-page-next-button-before-class"]
          )),
          disabled: c.isLastPage,
          onClick: c.nextPage
        }, null, 8, ["class", "disabled", "onClick"])
      ], 2),
      K(r.$slots, "custom-controls-after")
    ], 2),
    D("div", {
      class: y(s.twMerge(
        "flex flex-col rounded-lg overflow-x-scroll hide-scrollbar",
        r.$attrs["table-container-class"]
      ))
    }, [
      D("table", {
        class: y(s.twMerge(
          "w-full",
          r.$attrs["table-content-class"]
        ))
      }, [
        D("thead", {
          class: y(s.twMerge(
            "bg-zinc-950 !bg-opacity-20 text-zinc-950 dark:bg-zinc-50 dark:bg-opacity-20               dark:text-zinc-50",
            r.$attrs["table-head-container-class"]
          ))
        }, [
          D("tr", {
            class: y(s.twMerge(
              "relative",
              r.$attrs["table-head-row-class"]
            ))
          }, [
            K(r.$slots, "head-before"),
            (T(!0), L(ne, null, Ne(c.columnsByKey, (O) => (T(), L("th", {
              class: y(s.twMerge(
                "p-4",
                r.$attrs["table-head-item-container-class"]
              ))
            }, [
              D("div", {
                class: y(s.twMerge(
                  "flex flex-row items-center",
                  r.$attrs["table-head-item-sort-container-class"]
                ))
              }, [
                D("span", {
                  class: y(s.twMerge(
                    "min-w-max",
                    r.$attrs["table-head-item-sort-content-class"]
                  ))
                }, G(O.name), 3),
                O.sortable ? (T(), _e(h, {
                  key: 0,
                  type: "text",
                  color: "black",
                  icon: O.orderIcon,
                  class: y(s.twMerge(
                    "min-w-[3rem] ml-2",
                    r.$attrs["table-head-item-sort-button-class"]
                  )),
                  onClick: () => {
                    s.order.column = O.key, s.order.direction = s.order.direction === "asc" ? "desc" : "asc", r.$emit("order-changed", s.order);
                  }
                }, null, 8, ["icon", "class", "onClick"])) : me("", !0)
              ], 2)
            ], 2))), 256)),
            K(r.$slots, "head-after")
          ], 2)
        ], 2),
        D("tbody", {
          class: y(s.twMerge(
            r.$attrs["table-body-container-class"]
          ))
        }, [
          K(r.$slots, "body-before"),
          (T(!0), L(ne, null, Ne(c.chunk, (O, R) => (T(), L("tr", {
            class: y(s.twMerge(
              "even:bg-zinc-50 dark:even:bg-zinc-950 dark:even:bg-opacity-20",
              r.$attrs["table-body-row-class"]
            ))
          }, [
            K(r.$slots, "column-before", {
              row: O,
              index: R
            }),
            (T(!0), L(ne, null, Ne(c.columnsByKey, (E) => (T(), L("td", {
              class: y(s.twMerge(
                "p-4",
                r.$attrs["table-body-item-container-class"]
              ))
            }, [
              r.$slots.row ? K(r.$slots, "row", {
                key: 1,
                row: O,
                index: R,
                column: E
              }) : (T(), L(ne, { key: 0 }, [
                xe(G(O[E.key]), 1)
              ], 64))
            ], 2))), 256)),
            K(r.$slots, "column-after", {
              row: O,
              index: R
            })
          ], 2))), 256)),
          K(r.$slots, "body-after")
        ], 2)
      ], 2)
    ], 2),
    D("div", {
      class: y(s.twMerge(
        "flex flex-row items-center mt-4",
        r.$attrs["controller-container-class"],
        r.$attrs["controller-container-after-class"]
      ))
    }, [
      K(r.$slots, "custom-controls-before"),
      Ky,
      D("div", {
        class: y(s.twMerge(
          "flex flex-row justify-end items-center",
          r.$attrs["controller-content-class"],
          r.$attrs["controller-content-after-class"]
        ))
      }, [
        D("div", {
          class: y(s.twMerge(
            "font-semibold mr-4",
            r.$attrs["controller-page-info-class"],
            r.$attrs["controller-page-info-after-class"]
          ))
        }, [
          xe(G(c.offsetStart) + "-" + G(c.offsetEnd) + " ", 1),
          n.serverPagination ? me("", !0) : (T(), L(ne, { key: 0 }, [
            xe(" of " + G(n.serverPagination ? null : `${(z = c.orderedRows) == null ? void 0 : z.length}`), 1)
          ], 64))
        ], 2),
        ze(h, {
          type: "text",
          color: "black",
          icon: "chevron_left",
          class: y(s.twMerge(
            "mr-4",
            r.$attrs["controller-page-previous-button-class"],
            r.$attrs["controller-page-previous-button-after-class"]
          )),
          disabled: c.isFirstPage,
          onClick: c.prevPage
        }, null, 8, ["class", "disabled", "onClick"]),
        ze(h, {
          type: "text",
          color: "black",
          icon: "chevron_right",
          class: y(s.twMerge(
            r.$attrs["controller-page-next-button-class"],
            r.$attrs["controller-page-next-button-after-class"]
          )),
          disabled: c.isLastPage,
          onClick: c.nextPage
        }, null, 8, ["class", "disabled", "onClick"])
      ], 2),
      K(r.$slots, "custom-controls-after")
    ], 2)
  ], 2)) : (T(), _e(g, {
    key: 0,
    color: "yellow",
    icon: "info",
    class: y(s.twMerge(
      "w-full mt-4",
      r.$attrs["container-class"]
    ))
  }, {
    default: De(() => [
      xe(" Not enough data to show ")
    ]),
    _: 1
  }, 8, ["class"]));
}
const Jy = /* @__PURE__ */ we(qy, [["render", Qy]]), Zy = {
  name: "SelectComponent",
  props: {
    options: Array,
    disableSearch: Boolean,
    dismissOnSelect: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["selected"],
  data() {
    return {
      query: "",
      searchedQuery: "",
      show: !1,
      twMerge: fe
    };
  },
  computed: {
    finalOptions() {
      const r = this.options, o = this.searchedQuery.length && new RegExp(this.searchedQuery, "gi");
      return this.searchedQuery.length ? r.filter((l) => JSON.stringify(l).match(o)) : r;
    }
  },
  methods: {
    searched() {
      this.searchedQuery = this.query;
    },
    select(r) {
      this.$emit("selected", r), this.dismissOnSelect && (this.show = !1);
    }
  }
}, jy = {
  key: 0,
  class: "mb-1"
}, e1 = { class: "flex flex-row items-center flex-1 text-left" }, t1 = /* @__PURE__ */ D("i", { class: "material-icons text-2xl ml-2" }, "expand_more", -1), r1 = ["onClick"];
function n1(r, o, n, l, s, c) {
  const g = Ie("fs-button"), h = Ie("fs-input"), w = Ie("fs-dropdown");
  return T(), L("div", {
    class: y(s.twMerge(
      "flex flex-col",
      r.$attrs["container-class"]
    ))
  }, [
    r.$attrs.label || r.$slots.label ? (T(), L("label", {
      key: 0,
      class: y(s.twMerge(
        "font-semibold text-lg text-zinc-900 dark:text-zinc-50",
        r.$attrs["label-class"]
      ))
    }, [
      r.$attrs.label ? (T(), L("div", jy, G(r.$attrs.label), 1)) : r.$slots.label ? K(r.$slots, "label", { key: 1 }) : me("", !0)
    ], 2)) : me("", !0),
    ze(w, Ei({
      modelValue: s.show,
      "onUpdate:modelValue": o[2] || (o[2] = (x) => s.show = x)
    }, r.$attrs, {
      class: r.$attrs.class,
      "content-class": s.twMerge(
        "w-full max-w-[320px]",
        r.$attrs["content-class"]
      ),
      "onUpdate:modelValue": o[3] || (o[3] = () => {
        s.show || (s.query = "", s.searchedQuery = "");
      })
    }), {
      trigger: De(() => [
        ze(g, {
          color: (r.$attrs.color === "white" ? "gray" : r.$attrs.color) ?? "gray",
          disabled: r.$attrs["trigger-disabled"],
          class: y(s.twMerge(
            "w-full",
            r.$attrs["trigger-class"]
          )),
          onClick: o[0] || (o[0] = (x) => s.show = !0)
        }, {
          default: De(() => [
            D("div", e1, [
              K(r.$slots, "trigger")
            ]),
            t1
          ]),
          _: 3
        }, 8, ["color", "disabled", "class"])
      ]),
      default: De(() => [
        n.disableSearch ? me("", !0) : (T(), _e(h, {
          key: 0,
          modelValue: s.query,
          "onUpdate:modelValue": o[1] || (o[1] = (x) => s.query = x),
          type: "text",
          placeholder: "Search here …",
          class: y(s.twMerge(
            "w-full border-e-none",
            r.$attrs["search-box-class"]
          )),
          onKeyup: c.searched
        }, null, 8, ["modelValue", "class", "onKeyup"])),
        D("div", {
          class: y(s.twMerge(
            "flex flex-col bg-zinc-50 dark:bg-zinc-900 w-full overflow-hidden             rounded-lg max-h-[180px] overflow-y-scroll",
            n.disableSearch ? "" : "mt-3",
            r.$attrs["options-container-class"]
          ))
        }, [
          K(r.$slots, "before-option"),
          (T(!0), L(ne, null, Ne(c.finalOptions, (x) => (T(), L("div", {
            class: y(s.twMerge(
              "flex flex-row hover:bg-gray-200 dark:hover:bg-gray-800               transition-colors ease-in-out cursor-pointer",
              r.$attrs["option-class"]
            )),
            onClick: (z) => c.select(x)
          }, [
            K(r.$slots, "option", { option: x })
          ], 10, r1))), 256)),
          K(r.$slots, "after-option")
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue", "class", "content-class"])
  ], 2);
}
const i1 = /* @__PURE__ */ we(Zy, [["render", n1]]), o1 = {
  name: "GeneralSelectComponent",
  props: {
    modelValue: Object,
    options: Array,
    trackBy: {
      type: String,
      default: "value"
    },
    descriptionBy: String
  },
  emits: ["update:modelValue"],
  data() {
    return {
      twMerge: fe
    };
  },
  computed: {
    orderedOptions() {
      const r = Object.values(this.options), o = (l) => Uu.orderBy(
        l,
        (s) => {
          var c;
          return (c = s[this.descriptionBy ?? this.trackBy]) == null ? void 0 : c.toLowerCase();
        },
        ["asc"]
      );
      let n = o(r.filter((l) => {
        var s;
        return !["first", "last"].includes((s = l.pin) == null ? void 0 : s.toLowerCase());
      }));
      return n = [
        ...o(r.filter((l) => {
          var s;
          return ((s = l.pin) == null ? void 0 : s.toLowerCase()) === "first";
        })),
        ...n,
        ...o(r.filter((l) => {
          var s;
          return ((s = l.pin) == null ? void 0 : s.toLowerCase()) === "last";
        }))
      ], n;
    }
  }
};
function s1(r, o, n, l, s, c) {
  var h;
  const g = Ie("fs-select");
  return T(), _e(g, Ei(r.$attrs, {
    type: "custom",
    options: c.orderedOptions,
    "options-container-class": s.twMerge(
      ((h = n.options) == null ? void 0 : h.length) > 3 ? "" : "hide-scrollbar",
      r.$attrs["options-container-class"]
    ),
    "disable-search": r.$attrs["disable-search"] ?? !0,
    onSelected: o[0] || (o[0] = (w) => r.$emit("update:modelValue", w))
  }), {
    trigger: De(() => {
      var w, x;
      return [
        D("div", {
          class: y(s.twMerge(
            "flex-1 text-left",
            r.$attrs["trigger-class"]
          ))
        }, [
          K(r.$slots, "before-trigger"),
          (w = n.modelValue) != null && w[n.trackBy] ? (T(), L(ne, { key: 0 }, [
            xe(G(((x = n.options.find((z) => {
              var O;
              return z[n.trackBy] === ((O = n.modelValue) == null ? void 0 : O[n.trackBy]);
            })) == null ? void 0 : x[n.descriptionBy ?? n.trackBy]) ?? ""), 1)
          ], 64)) : (T(), L(ne, { key: 1 }, [
            xe(G(r.$attrs.placeholder ?? "Select"), 1)
          ], 64)),
          K(r.$slots, "after-trigger")
        ], 2)
      ];
    }),
    option: De(({ option: w }) => {
      var x, z;
      return [
        D("div", {
          class: y(s.twMerge(
            "flex flex-row flex-1 items-center p-3 text-zinc-950 dark:text-zinc-50",
            ((w == null ? void 0 : w[n.trackBy]) === ((x = n.modelValue) == null ? void 0 : x[n.trackBy]), ""),
            (w == null ? void 0 : w[n.trackBy]) === ((z = n.modelValue) == null ? void 0 : z[n.trackBy]) ? {
              blue: "bg-sky-300 !text-zinc-950",
              red: "bg-red-300 !text-zinc-950",
              yellow: "bg-yellow-300 !text-zinc-950",
              green: "bg-green-300 !text-zinc-950",
              gray: "bg-gray-300 !text-zinc-950",
              white: "bg-gray-100 !text-zinc-950",
              black: "bg-zinc-800"
            }[r.$attrs.color ?? "gray"] : "",
            r.$attrs["option-class"]
          ))
        }, [
          K(r.$slots, "before-option", { option: w }),
          D("strong", null, G(w[n.descriptionBy ?? n.trackBy]), 1),
          K(r.$slots, "after-option", { option: w })
        ], 2)
      ];
    }),
    _: 3
  }, 16, ["options", "options-container-class", "disable-search"]);
}
const a1 = /* @__PURE__ */ we(o1, [["render", s1]]), l1 = {
  name: "SelectComponent",
  components: {
    CustomSelect: i1,
    GeneralSelect: a1
  },
  props: {
    type: {
      type: String,
      default: "general"
    }
  },
  computed: {
    component() {
      return {
        general: "GeneralSelect",
        custom: "CustomSelect"
      }[this.type];
    }
  }
};
function u1(r, o, n, l, s, c) {
  return T(), _e(Ai(c.component), us(cs(r.$attrs)), Ip({ _: 2 }, [
    Ne(r.$slots, (g, h) => ({
      name: h,
      fn: De((w) => [
        K(r.$slots, h, us(cs(w || {})))
      ])
    }))
  ]), 1040);
}
const c1 = /* @__PURE__ */ we(l1, [["render", u1]]);
const f1 = {
  name: "NotificationComponent",
  props: {
    index: Number,
    show: Boolean,
    duration: {
      type: Number,
      default: 5e3
    },
    content: String,
    position: {
      type: Object,
      default: {
        top: 0,
        left: 0
      }
    },
    placement: String,
    size: {
      type: String
    },
    color: {
      type: String,
      default: "gray"
    }
  },
  emits: ["showChange"],
  data() {
    return {
      timer: null,
      hovered: !1,
      twMerge: fe
    };
  },
  computed: {
    transitionName() {
      return ["bottom-left", "bottom", "bottom-right"].includes(this.placement) ? "fadeToTop" : ["top-left", "top", "top-right"].includes(this.placement) ? "fadeToBottom" : "";
    },
    gap() {
      return ["bottom-left", "bottom", "bottom-right"].includes(this.placement) ? "px-2 md:px-4 pb-2 md:pb-4" : ["top-left", "top", "top-right"].includes(this.placement) ? "px-2 pt-2 md:px-4 md:pt-4" : "";
    },
    notificationColorClass() {
      var o;
      const r = (o = this.color) == null ? void 0 : o.toLowerCase();
      return {
        blue: "rounded-lg bg-sky-300 hover:bg-sky-400 text-zinc-900",
        red: "rounded-lg bg-red-300 hover:bg-red-400 text-zinc-900",
        yellow: "rounded-lg bg-yellow-300 hover:bg-yellow-400 text-zinc-900",
        green: "rounded-lg bg-green-300 hover:bg-green-400 text-zinc-900",
        gray: "rounded-lg bg-gray-300 hover:bg-gray-400 text-zinc-900 dark:bg-gray-600 dark:hover:bg-gray-700 dark:text-zinc-50",
        black: "rounded-lg bg-zinc-900 hover:bg-zinc-700 text-zinc-50 dark:bg-zinc-800 dark:hover:bg-zinc-600 dark:text-zinc-50"
      }[r];
    },
    notificationSizeClass() {
      var o;
      switch ((o = this.size) == null ? void 0 : o.toLowerCase()) {
        case "small":
          return "p-1 leading-3 text-base min-h-10";
        case "large":
          return "p-3 leading-7 text-xl min-h-14";
        default:
          return "p-5 leading-5 text-lg min-h-12";
      }
    }
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    destroy() {
      var r, o;
      this.$refs.root && ((o = (r = this.$refs.root) == null ? void 0 : r.parentNode) == null || o.removeChild(this.$refs.root));
    },
    startTimer() {
      this.duration && this.duration > 0 && (this.hovered = !1, this.timer = setTimeout(() => {
        this.$emit("showChange", !1);
      }, this.duration));
    },
    clearTimer() {
      clearTimeout(this.timer), this.hovered = !0;
    }
  }
};
function d1(r, o, n, l, s, c) {
  return T(), _e(hs, {
    name: c.transitionName,
    onAfterLeave: c.destroy
  }, {
    default: De(() => {
      var g, h, w, x, z;
      return [
        zi(D("div", {
          ref: "root",
          class: y(s.twMerge(
            "fixed flex flex-col z-[999999] transition-all",
            c.gap,
            ((g = n.position) == null ? void 0 : g.left) === "50%" ? "-translate-x-1/2" : "",
            ((h = n.position) == null ? void 0 : h.left) === "100%" ? "-translate-x-full" : "",
            ((w = n.position) == null ? void 0 : w.top) === "100%" ? "-translate-y-full" : ""
          )),
          style: On({
            left: (x = n.position) == null ? void 0 : x.left,
            top: (z = n.position) == null ? void 0 : z.top
          })
        }, [
          D("div", {
            class: y(s.twMerge(
              "flex flex-row items-center overflow-hidden font-semibold                         shadow-lg transition-all ease-in-out rounded-lg duration-300",
              c.notificationColorClass,
              c.notificationSizeClass,
              r.$attrs["content-class"]
            )),
            onMouseleave: o[0] || (o[0] = (...O) => c.startTimer && c.startTimer(...O)),
            onMouseenter: o[1] || (o[1] = (...O) => c.clearTimer && c.clearTimer(...O))
          }, [
            n.content ? (T(), L(ne, { key: 0 }, [
              xe(G(n.content), 1)
            ], 64)) : r.$slots.default ? K(r.$slots, "default", { key: 1 }) : me("", !0)
          ], 34)
        ], 6), [
          [ms, n.show]
        ])
      ];
    }),
    _: 3
  }, 8, ["name", "onAfterLeave"]);
}
const g1 = /* @__PURE__ */ we(f1, [["render", d1]]), Tn = {
  "top-left": /* @__PURE__ */ new Set(),
  top: /* @__PURE__ */ new Set(),
  "top-right": /* @__PURE__ */ new Set(),
  "bottom-left": /* @__PURE__ */ new Set(),
  bottom: /* @__PURE__ */ new Set(),
  "bottom-right": /* @__PURE__ */ new Set()
}, h1 = (r) => {
  var l;
  const o = Array.from(Tn[r]).pop(), n = (l = o == null ? void 0 : o.childNodes) == null ? void 0 : l[0];
  if (["top-left", "top", "top-right"].includes(r))
    return {
      top: o ? `${n.offsetTop + n.offsetHeight}px` : "0px",
      left: {
        "top-left": "0%",
        top: "50%",
        "top-right": "100%"
      }[r]
    };
  if (["bottom-left", "bottom", "bottom-right"].includes(r)) {
    let s = "100%";
    return o && ((n == null ? void 0 : n.offsetTop) === window.innerHeight ? s = `${n.offsetTop - n.offsetHeight * 2}px` : s = `${n.offsetTop - n.offsetHeight}px`), {
      top: s,
      left: {
        "bottom-left": "0%",
        bottom: "50%",
        "bottom-right": "100%"
      }[r]
    };
  }
}, m1 = (r, o) => {
  var g, h;
  const n = Object.keys(Tn).includes(
    (g = r == null ? void 0 : r.placement) == null ? void 0 : g.toLowerCase()
  ) ? (h = r == null ? void 0 : r.placement) == null ? void 0 : h.toLowerCase() : "top", l = Rp({
    ...r,
    placement: n,
    index: Tn[n].size,
    show: !1,
    onShowChange: () => {
    }
  });
  l.position = h1(l.placement), l.onShowChange = (w) => {
    l.show = w, w || (document.body.removeChild(c), Tn[n].delete(c));
  };
  const s = Pp({
    render: () => Wp(g1, l, () => o)
  }), c = document.createElement("div");
  s.mount(c), document.body.appendChild(c), Tn[n].add(c), l.show = !0;
}, b1 = {
  install: (r) => {
    r.component("FsIcon", bb), r.component("FsButton", yb), r.component("FsRange", zb), r.component("FsInput", Ab), r.component("FsCheckbox", Wb), r.component("FsCalendar", Pw), r.component("FsWrapper", Fw), r.component("FsContainer", $w), r.component("FsModal", Gw), r.component("FsProgress", Kw), r.component("FsSpinner", ty), r.component("FsRadio", sy), r.component("FsSwitch", uy), r.component("FsDropdown", Ry), r.component("FsTooltip", Py), r.component("FsAlert", Fy), r.component("FsSegment", Yy), r.component("FsTable", Jy), r.component("FsSelect", c1), r.config.globalProperties.$notification = m1;
  }
};
export {
  b1 as default
};
